var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeorgesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "304.000000pt",
    height: "271.000000pt",
    viewBox: "0 0 304.000000 271.000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1355 l0 -1355 1520 0 1520 0 0 1355 0 1355 -560 0 c-308 0 -560 -3 -560 -8 0 -4 10 -12 22 -17 12 -6 26 -17 31 -25 l9 -16 -23 -59 c-13 -32 -30 -61 -38 -63 l-14 -5 8 19 c4 11 8 30 9 44 l1 25 -23 10 -23 10 5 25 c2 14 8 33 11 43 l7 17 -951 0 -951 0 0 -1355z m2067 960 c8 -27 20 -69 26 -92 6 -24 16 -43 22 -43 5 0 25 21 44 46 38 51 55 53 21 2 -35 -50 -92 -108 -122 -124 l-27 -14 -36 13 c-20 6 -38 16 -38 22 -1 5 12 12 28 15 l30 5 3 24 c2 13 1 39 -3 57 l-6 34 -17 0 -17 0 -38 -59 c-21 -33 -56 -80 -78 -105 l-40 -45 -53 -26 -54 -26 -29 15 c-15 9 -36 22 -46 29 l-18 12 -33 -39 -33 -40 -11 -68 c-18 -117 -99 -258 -149 -258 -25 0 -63 36 -63 59 0 22 37 78 102 153 l49 57 6 56 6 55 -12 0 c-7 0 -34 -23 -60 -52 l-47 -51 -26 6 -27 7 -6 20 c-3 11 -10 20 -15 20 -5 0 -28 -20 -51 -45 -40 -44 -60 -52 -93 -39 l-16 6 0 74 0 74 -13 0 c-7 0 -32 -26 -54 -59 l-42 -58 -36 -17 c-20 -10 -58 -40 -84 -67 l-47 -49 -26 0 c-14 0 -37 9 -51 20 -14 11 -31 20 -39 20 -8 0 -30 -16 -49 -36 -40 -42 -98 -74 -133 -74 -13 0 -38 12 -55 26 l-31 26 0 47 0 48 23 43 c25 49 78 95 118 105 l27 7 33 -30 33 -30 -27 -38 c-14 -22 -47 -55 -72 -74 l-45 -35 3 -20 2 -20 23 -3 c37 -5 80 17 117 61 l35 41 0 30 c1 44 32 107 69 139 31 26 61 34 73 21 4 -3 -4 -21 -17 -40 -25 -37 -50 -127 -44 -159 3 -11 12 -21 21 -23 l17 -3 15 30 c9 16 16 48 16 69 0 40 17 102 28 102 3 0 16 -10 29 -22 l23 -21 0 -34 0 -33 13 0 c22 0 97 90 97 116 0 7 -11 15 -25 18 -14 4 -25 12 -25 20 0 11 19 76 25 84 5 7 35 -11 35 -22 0 -6 28 -20 61 -31 l61 -19 -7 -78 -6 -78 15 0 c19 0 91 90 111 137 19 44 61 99 96 124 l29 20 21 -6 21 -7 -25 -26 c-39 -42 -87 -124 -87 -149 l0 -23 15 0 c23 0 57 40 90 106 l29 57 18 -23 18 -22 0 -49 0 -49 13 0 c14 0 47 50 47 72 0 64 65 159 128 185 l33 14 29 -18 c35 -20 45 -44 31 -71 -6 -11 -36 -42 -66 -71 l-56 -51 3 -22 3 -23 29 2 c41 3 87 38 132 100 54 74 84 134 90 179 3 22 8 45 10 52 l4 14 31 -19 32 -18 14 -50z m-1667 26 c19 -15 40 -43 47 -62 l12 -34 -6 -45 c-7 -54 -41 -150 -53 -150 -13 0 -70 34 -70 42 0 3 9 27 20 52 10 25 22 67 25 94 l7 47 -11 28 -11 27 -24 0 -24 0 -35 -39 c-64 -71 -134 -248 -162 -410 -18 -100 -19 -167 -4 -210 l11 -31 25 0 25 0 29 31 c40 42 95 143 110 201 l13 46 48 10 49 9 -5 -26 c-16 -76 -26 -178 -26 -278 l0 -113 -40 -20 -40 -20 0 95 0 95 -12 0 c-7 0 -23 -16 -36 -35 -12 -20 -34 -41 -47 -47 l-25 -11 -37 11 c-49 15 -106 62 -127 106 l-16 34 0 84 0 85 20 77 c10 42 37 115 59 161 l40 85 53 56 c29 31 71 65 93 75 l40 19 25 -6 c14 -3 41 -18 60 -33z m1943 -743 c11 -10 25 -18 31 -18 14 0 50 -40 42 -47 -2 -3 -11 4 -18 16 -7 12 -20 21 -30 21 -9 0 -23 6 -30 13 -7 7 -21 16 -32 20 l-18 7 13 16 13 16 5 -13 c2 -8 13 -22 24 -31z m156 3 c-15 -5 -22 6 -14 19 l8 12 8 -13 8 -14 -10 -4z m163 -6 c0 -5 -5 -11 -11 -13 -6 -2 -11 4 -11 13 0 9 5 15 11 13 6 -2 11 -8 11 -13z m-965 -22 c-4 -3 -10 -3 -14 0 -3 4 0 7 7 7 7 0 10 -3 7 -7z m60 -9 c-3 -3 -12 -4 -19 -1 l-13 5 19 1 c11 1 17 -2 13 -5z m745 -34 c-18 -32 -32 -39 -32 -15 0 19 31 56 41 49 4 -2 0 -18 -9 -34z m155 5 c-9 -8 -20 -15 -26 -15 -6 0 -11 -4 -11 -10 0 -5 -7 -10 -16 -10 l-16 0 4 13 c3 6 13 14 23 16 10 2 25 10 33 18 8 7 17 12 19 9 3 -3 -2 -12 -10 -21z m-877 6 c0 -12 -39 -25 -47 -17 -4 3 1 6 10 6 10 0 17 5 17 10 0 6 5 10 10 10 6 0 10 -4 10 -9z m520 -36 c0 -8 5 -15 12 -15 l12 0 -11 -11 -11 -11 -21 7 c-12 3 -21 11 -21 16 0 5 -10 9 -22 10 l-23 1 25 8 c14 4 33 8 43 9 l17 1 0 -15z m143 -4 l5 -20 -14 6 c-8 3 -14 11 -14 19 0 21 17 17 23 -5z m137 -11 c0 -5 -9 -10 -21 -10 l-20 0 6 10 c3 6 13 10 21 10 8 0 14 -4 14 -10z m-1023 -17 c-4 -3 -7 0 -7 7 0 7 3 10 7 7 3 -4 3 -10 0 -14z m220 0 c-4 -3 -7 0 -7 7 0 7 3 10 7 7 3 -4 3 -10 0 -14z m-120 -9 c-3 -3 -12 -4 -19 -1 l-13 5 19 1 c11 1 17 -2 13 -5z m728 -4 c3 -5 15 -10 26 -10 l20 0 -15 -16 -16 -15 -40 3 -41 3 16 23 c17 23 40 29 50 12z m142 -7 c-4 -3 -7 0 -7 7 0 7 3 10 7 7 3 -4 3 -10 0 -14z m343 -25 c0 -21 -11 -23 -27 -7 l-12 12 12 18 11 18 8 -12 c4 -7 8 -20 8 -29z m-120 17 c0 -17 -2 -18 -24 -9 -23 9 -20 24 4 24 l20 0 0 -15z m-43 -45 l5 -15 -9 11 c-10 13 -81 16 -88 3 l-6 -8 -26 12 -27 12 34 5 c19 3 53 3 74 0 l39 -5 4 -15z m-200 -32 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m513 -4 l0 -14 -20 0 -20 0 0 -15 0 -15 -19 0 c-10 0 -21 6 -24 14 l-6 14 20 -5 20 -6 11 31 12 31 13 -11 c7 -6 13 -17 13 -24z m-616 18 c3 -5 -13 -13 -35 -19 -40 -10 -48 -6 -27 15 14 14 54 16 62 4z m433 -14 l-5 -13 -1 19 c-1 11 2 17 5 13 3 -3 4 -12 1 -19z m-547 -22 c0 -3 -6 -6 -14 -6 -15 0 -28 24 -19 34 6 5 33 -18 33 -28z m465 24 l6 -10 -23 0 -23 0 15 10 c19 12 18 12 25 0z m-310 -66 c-9 -26 -14 -58 -11 -70 l6 -21 -26 5 c-14 2 -22 7 -17 11 5 3 20 34 32 69 27 72 40 78 16 6z m161 19 c21 -28 16 -39 -6 -13 -11 13 -20 25 -20 27 0 9 14 1 26 -14z m228 11 c23 -9 20 -23 -4 -17 -11 3 -20 9 -20 14 0 11 3 11 24 3z m-54 -19 c0 -8 -7 -15 -15 -15 l-14 0 5 15 c4 8 10 15 15 15 5 0 9 -7 9 -15z m124 -9 c-3 -9 -15 -16 -26 -16 l-20 0 23 19 c13 11 25 18 27 17 1 -2 0 -11 -4 -20z m-1734 -6 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m1360 -20 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 -4 15 -10z m211 0 c5 0 9 -4 9 -9 0 -4 -11 -6 -25 -3 -14 2 -31 -1 -39 -7 -14 -12 -46 -5 -46 9 0 9 57 19 78 13 8 -1 18 -3 23 -3z m-774 -17 c-4 -3 -7 0 -7 7 0 7 3 10 7 7 3 -4 3 -10 0 -14z m80 -19 c-3 -3 -12 -4 -19 -1 l-13 5 19 1 c11 1 17 -2 13 -5z m120 -10 c-3 -3 -12 -4 -19 -1 l-13 5 19 1 c11 1 17 -2 13 -5z m617 -18 c-3 -8 -14 -16 -25 -19 l-19 -5 11 19 c5 10 16 19 24 19 l14 0 -5 -14z m116 4 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 l-6 10 15 0 c9 0 16 -4 16 -10z m-1522 -20 l27 0 -12 -8 c-7 -5 -32 -7 -55 -6 -24 1 -53 2 -65 3 -13 1 -23 6 -23 11 l0 10 39 -6 38 -6 9 13 8 13 4 -12 c2 -7 16 -12 30 -12z m-208 0 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m1783 -72 c-2 -5 -11 -8 -19 -8 l-14 0 0 33 c0 19 3 37 7 41 8 8 33 -55 26 -66z m-753 41 c0 -4 -7 -6 -15 -3 -8 4 -15 10 -15 15 0 4 7 6 15 3 8 -4 15 -10 15 -15z m60 -9 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 l-6 10 15 0 c9 0 16 -4 16 -10z m480 -4 c0 -26 -12 -46 -27 -46 l-15 0 5 -20 c3 -11 1 -23 -4 -26 -5 -3 -9 0 -9 5 0 6 -7 11 -15 11 l-15 0 0 33 0 32 9 -13 c5 -8 17 -12 27 -10 l19 3 3 23 c4 24 22 31 22 8z m-1691 2 c-2 -2 -22 -19 -43 -38 l-39 -35 29 37 c16 21 35 38 43 38 8 0 12 -1 10 -2z m91 -22 l-55 -11 -3 -38 -3 -37 -51 0 -51 0 64 49 64 49 45 0 45 0 -55 -12z m207 -83 c-2 -21 -4 -6 -4 32 0 39 2 55 4 38 2 -18 2 -50 0 -70z m356 90 l-73 -4 0 -206 0 -205 25 4 25 5 0 -13 0 -14 -56 0 -56 0 6 -25 6 -25 -20 0 c-11 0 -20 5 -20 10 0 6 -11 10 -25 10 l-25 0 -1 13 c0 6 -1 112 -2 235 l-2 222 145 -2 145 -2 -72 -3z m418 -4 l69 -12 0 -33 0 -34 -130 0 -130 0 0 45 0 45 61 0 c33 0 91 -5 130 -11z m309 -16 c0 -14 -19 -38 -25 -32 -8 8 5 39 16 39 5 0 9 -3 9 -7z m60 -8 c0 -8 -9 -19 -20 -25 l-20 -11 0 11 c0 5 7 10 15 10 8 0 15 7 15 15 0 8 2 15 5 15 3 0 5 -7 5 -15z m-202 -5 c6 0 12 -7 12 -15 l0 -15 -19 0 c-11 0 -26 -3 -35 -6 l-16 -6 0 27 0 27 23 -6 c12 -3 28 -6 35 -6z m552 0 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 -4 15 -10z m-1647 -12 l-23 -11 0 -23 c0 -12 4 -24 10 -26 l9 -3 -14 -40 c-16 -45 -17 -42 -15 38 l1 57 -13 1 c-7 1 1 5 17 9 43 11 53 10 28 -2z m1757 -35 l-12 -18 6 18 c3 10 6 24 7 30 l1 12 4 -12 c3 -7 0 -20 -6 -30z m68 25 c-6 -18 -28 -21 -28 -4 0 9 7 16 16 16 9 0 14 -5 12 -12z m-188 -78 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 -4 15 -10z m-1613 -47 c-4 -3 -7 0 -7 7 0 7 3 10 7 7 3 -4 3 -10 0 -14z m163 -331 c17 3 30 1 30 -4 0 -4 -16 -8 -35 -8 l-35 0 2 158 2 157 3 -154 4 -153 29 4z m-522 216 l213 -3 -5 -20 c-3 -11 -6 -25 -6 -32 l0 -12 -75 1 c-41 1 -75 5 -75 10 0 15 -29 8 -39 -9 l-10 -18 -20 13 c-24 14 -94 16 -119 3 -9 -4 -35 -11 -57 -14 l-40 -5 23 10 c25 12 30 38 7 38 -8 0 -15 5 -15 11 l0 12 -51 -5 -51 -5 -9 -14 -9 -14 0 16 c0 9 -7 20 -16 23 -27 10 -72 7 -76 -6 l-4 -12 -7 17 -7 18 20 7 c11 4 64 4 118 0 53 -4 193 -8 310 -10z m1432 -3 c0 -19 -37 -57 -45 -46 -2 5 2 11 10 15 8 3 15 15 15 26 0 11 5 20 10 20 6 0 10 -7 10 -15z m-160 -25 l0 -30 -15 0 -16 0 7 -36 7 -36 -22 18 c-22 19 -29 54 -11 54 6 0 10 11 10 23 0 27 7 37 27 37 l13 0 0 -30z m73 23 c-15 -5 -18 -33 -4 -33 11 0 24 -38 21 -62 l-1 -18 18 0 c10 0 27 -7 37 -15 l20 -15 -26 0 c-14 0 -40 -3 -57 -6 l-31 -6 0 81 0 81 18 -1 17 -1 -12 -5z m-243 -22 c0 -5 3 -23 6 -40 l7 -31 -22 0 -21 0 0 40 0 40 15 0 c8 0 15 -4 15 -9z m805 -11 c-3 -5 -10 -10 -16 -10 -5 0 -9 5 -9 10 0 6 7 10 16 10 l15 0 -6 -10z m-2278 -27 c-4 -3 -10 -3 -14 0 -3 4 0 7 7 7 7 0 10 -3 7 -7z m680 1 c-3 -3 -12 -4 -19 -1 l-13 5 19 1 c11 1 17 -2 13 -5z m693 -14 l0 -20 -67 1 -68 1 50 18 c28 10 58 19 68 19 l17 1 0 -20z m-597 -81 c-2 -39 0 -76 6 -83 5 -6 10 -32 12 -58 l4 -48 -14 -5 c-8 -3 -16 -3 -19 0 -3 3 0 5 6 5 7 0 12 7 12 16 l0 16 -32 -5 c-18 -3 -45 -9 -60 -12 l-28 -7 0 11 c0 6 11 11 24 11 l24 0 20 63 c12 34 24 78 27 97 8 43 15 70 19 70 2 0 1 -32 -1 -71z m-103 40 c0 -5 -7 -9 -15 -9 -8 0 -15 7 -15 15 l0 14 15 -5 c8 -4 15 -10 15 -15z m700 -34 l0 -25 -30 0 -30 0 0 15 c0 8 7 15 15 15 8 0 15 5 15 10 0 6 7 10 15 10 l15 0 0 -25z m122 -5 c3 -16 1 -30 -4 -30 -4 0 -8 7 -8 16 l0 16 -20 -5 -20 -5 0 19 0 19 24 0 24 0 4 -30z m118 10 c0 -5 8 -10 18 -11 l17 -1 -12 -5 c-7 -2 -13 -11 -13 -19 l0 -14 25 0 25 0 0 18 0 17 9 -14 9 -14 41 7 42 6 15 -14 c7 -8 14 -19 14 -24 l0 -10 -100 0 -100 1 0 28 c0 15 -3 34 -6 43 l-6 16 11 0 c6 0 11 -4 11 -10z m454 -13 l11 -17 -16 -15 -15 -16 -16 6 c-24 10 -29 32 -11 50 18 18 32 16 47 -8z m80 -10 l11 -9 -15 5 c-8 2 -16 12 -17 23 l-3 19 7 -15 c3 -8 11 -19 17 -23z m76 19 c0 -8 6 -17 13 -19 6 -3 2 -6 -10 -6 l-23 -1 0 20 c0 11 5 20 10 20 6 0 10 -6 10 -14z m-1568 -36 l11 0 -6 -41 c-3 -22 -7 -42 -9 -44 -2 -2 -15 -6 -30 -10 l-27 -7 19 56 c11 30 21 63 21 73 l2 18 4 -22 c2 -13 9 -23 15 -23z m1316 -12 c-5 -15 -58 -24 -58 -9 0 9 20 17 48 20 8 0 12 -5 10 -11z m-458 -42 c0 -13 3 -31 6 -40 l6 -16 -13 0 c-7 0 -25 -15 -40 -32 l-28 -33 -1 67 0 67 23 4 c12 2 28 5 35 6 l12 1 0 -24z m-140 -36 l0 -40 -162 0 -163 0 -69 -15 c-38 -8 -77 -17 -87 -20 l-19 -6 0 28 c0 15 3 38 6 49 l6 22 171 9 c95 5 205 10 245 11 l72 2 0 -40z m375 10 l6 -10 -36 0 -36 0 6 10 c3 6 17 10 30 10 13 0 27 -4 30 -10z m-1457 -373 l62 -63 -65 -64 -65 -64 -65 64 -65 64 62 63 c34 35 65 63 68 63 3 0 34 -28 68 -63z m2000 0 l62 -63 -65 -64 -65 -64 -65 64 -65 64 62 63 c34 35 65 63 68 63 3 0 34 -28 68 -63z m-1689 29 c7 -8 12 -36 11 -62 0 -27 1 -64 1 -83 l2 -33 -14 -9 c-8 -5 -29 -9 -46 -9 l-33 0 0 105 0 105 34 0 c18 0 39 -6 45 -14z m151 -1 l0 -15 -20 0 -20 0 0 -30 0 -30 15 0 c8 0 15 -7 15 -15 0 -8 -7 -15 -15 -15 l-15 0 0 -30 0 -30 20 0 20 0 0 -15 0 -15 -35 0 -35 0 0 105 0 105 35 0 35 0 0 -15z m144 -74 c9 -49 16 -96 16 -105 0 -23 -17 -20 -25 4 l-6 20 -21 0 -20 0 -5 -20 c-7 -25 -23 -26 -23 -2 0 9 7 56 16 105 l16 87 18 0 17 0 17 -89z m153 81 c15 -10 20 -44 7 -49 -6 -2 -14 5 -17 17 -3 11 -12 20 -21 20 l-16 0 0 -85 0 -85 16 0 c9 0 18 9 21 20 3 11 9 20 14 20 15 0 20 -20 9 -40 l-11 -20 -27 0 c-16 0 -33 5 -40 12 l-12 12 0 81 0 81 12 12 c13 13 47 16 65 4z m103 -37 l0 -45 25 0 25 0 0 45 0 45 15 0 15 0 0 -105 0 -105 -15 0 -15 0 0 45 0 45 -25 0 -25 0 0 -45 0 -45 -10 0 -10 0 0 105 0 105 10 0 10 0 0 -45z m328 33 c7 -7 12 -20 12 -30 l0 -18 -15 0 -15 0 0 21 0 20 -17 -3 -18 -3 0 -80 0 -80 18 -3 17 -3 0 20 c0 24 18 28 26 6 9 -23 -15 -45 -47 -45 l-28 0 -11 19 c-5 11 -10 50 -10 86 0 36 5 75 10 86 l11 19 27 0 c16 0 33 -5 40 -12z m102 -77 l0 -90 20 -6 c32 -10 23 -25 -15 -25 l-35 0 0 105 0 105 15 0 15 0 0 -89z m120 -6 l0 -95 20 0 20 0 0 95 0 95 15 0 15 0 0 -86 c0 -47 -5 -94 -10 -105 l-11 -19 -27 0 c-16 0 -33 5 -40 12 l-12 12 0 93 0 93 15 0 15 0 0 -95z m209 85 l18 -9 1 -83 c0 -46 -5 -89 -10 -95 -6 -7 -28 -13 -49 -13 l-39 0 0 105 0 105 31 0 c17 0 38 -4 48 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735 2230 c-8 -16 -15 -38 -15 -50 l0 -20 14 0 c21 0 46 40 46 72 l0 28 -15 0 c-8 0 -21 -13 -30 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602 1978 c-9 -12 -32 -83 -32 -100 0 -5 6 -8 14 -8 19 0 56 61 56 94 l0 26 -14 0 c-7 0 -18 -6 -24 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418 1813 c-22 -25 -48 -79 -48 -98 l0 -16 18 3 c17 3 71 91 72 116 0 18 -24 15 -42 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653 193 l-7 -17 12 -4 c15 -5 16 -32 2 -32 -5 0 -10 -9 -10 -20 l0 -20 15 0 c8 0 15 7 15 16 0 8 7 22 15 30 l15 15 0 -21 c0 -23 21 -50 39 -50 6 0 11 7 11 15 0 8 -4 15 -10 15 -5 0 -10 14 -10 30 0 17 5 30 10 30 6 0 10 7 10 15 0 8 -7 15 -15 15 -8 0 -15 -4 -15 -10 0 -5 -9 -10 -20 -10 -11 0 -20 5 -20 10 0 17 -30 11 -37 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2730 195 c0 -8 5 -15 10 -15 6 0 10 -13 10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -7 -10 -15 0 -19 17 -19 36 -1 28 29 10 106 -25 106 -6 0 -11 -7 -11 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2680 179 c0 -11 -7 -27 -15 -35 -19 -20 -19 -44 0 -44 l15 0 6 25 c3 14 10 25 15 25 5 0 9 11 9 25 l0 25 -15 0 -15 0 0 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 190 l0 -30 20 0 20 0 0 30 0 30 -20 0 -20 0 0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032 98 l3 -33 20 0 20 0 0 30 0 30 -23 3 -23 4 3 -34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350 190 l0 -30 20 0 20 0 0 30 0 30 -20 0 -20 0 0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350 94 l0 -35 18 3 17 3 3 33 3 32 -20 0 -21 0 0 -36z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f27fb2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1880 2686 c-5 -15 -10 -37 -10 -49 l0 -22 23 -10 22 -10 -3 -20 c-2 -11 -4 -31 -5 -45 l-2 -25 14 0 c19 0 46 47 63 108 l12 47 -19 20 c-11 11 -35 22 -52 26 l-33 6 -10 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1977 2403 c-4 -3 -7 -18 -7 -33 0 -42 -19 -89 -65 -160 -50 -77 -97 -125 -137 -139 l-29 -10 -5 13 -5 14 65 64 66 64 0 27 0 26 -22 20 c-12 12 -30 23 -40 27 -32 10 -85 -15 -126 -60 l-40 -44 -11 -38 c-6 -22 -11 -46 -11 -54 0 -8 -9 -28 -20 -45 l-20 -30 0 50 0 51 -16 22 c-8 12 -21 22 -28 22 -8 0 -26 -25 -42 -56 -15 -30 -39 -67 -53 -82 l-24 -27 -5 13 c-5 15 39 91 79 136 16 19 29 38 29 44 0 12 -24 22 -51 22 -29 0 -105 -81 -134 -142 -14 -29 -43 -73 -65 -98 l-40 -45 6 65 c4 36 6 67 6 70 0 22 -9 29 -62 46 -33 10 -60 24 -60 30 0 12 -22 24 -44 24 -13 0 -36 -62 -36 -98 l0 -22 25 -6 25 -6 -17 -30 c-10 -16 -30 -41 -45 -55 l-28 -27 0 35 0 36 -23 21 c-13 12 -29 22 -37 22 -7 0 -18 6 -24 14 -6 8 -20 17 -31 20 l-21 6 -38 -32 c-43 -36 -75 -97 -76 -145 l0 -33 -43 -44 c-23 -24 -55 -48 -70 -51 l-28 -8 -11 11 -11 11 34 28 c55 45 99 96 106 122 l6 24 -33 30 -33 29 -35 -6 c-46 -7 -100 -52 -129 -106 l-23 -43 0 -58 0 -57 31 -26 31 -26 34 0 c45 0 89 22 141 72 l41 41 28 -22 27 -21 35 0 36 0 47 49 c26 27 64 57 84 67 l36 17 42 59 42 60 3 -75 3 -75 30 -11 31 -11 17 10 c10 5 34 27 54 50 21 22 37 36 37 31 0 -19 32 -41 60 -41 l28 0 48 53 47 52 -6 -49 -7 -48 -49 -57 c-70 -81 -101 -130 -101 -160 0 -34 9 -47 44 -65 l29 -15 27 14 c34 17 83 90 109 159 10 28 22 76 26 106 l7 54 30 37 30 37 35 -24 c20 -13 43 -24 52 -24 10 0 40 12 69 26 l52 26 39 44 c22 25 57 72 78 105 21 32 41 59 45 59 10 0 21 -67 15 -84 -3 -8 -18 -16 -34 -18 l-28 -3 0 -20 0 -20 40 -13 c22 -7 50 -10 63 -7 31 8 98 70 138 129 l33 50 -11 13 c-6 7 -13 13 -17 13 -3 -1 -22 -23 -41 -50 l-34 -48 -13 44 c-7 24 -19 65 -27 91 l-13 48 -29 17 c-31 19 -47 22 -57 11z m-223 -211 l-17 -27 -4 12 c-2 6 4 27 13 45 l18 33 4 -18 c2 -10 -4 -30 -14 -45z m-854 -168 c-6 -14 -10 -43 -10 -65 0 -22 -7 -54 -16 -71 l-16 -30 -11 11 -10 10 12 53 c10 48 43 118 56 118 2 0 0 -12 -5 -26z m-290 -109 c-12 -19 -23 -35 -25 -35 -7 0 17 75 29 89 l11 14 3 -17 c2 -9 -6 -32 -18 -51z m815 -144 c-22 -44 -45 -73 -45 -56 0 19 55 105 67 105 2 0 -8 -22 -22 -49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 2372 c-22 -11 -64 -45 -93 -76 l-53 -56 -40 -85 c-22 -46 -49 -119 -59 -161 l-20 -77 0 -96 0 -96 19 -35 c10 -19 37 -49 60 -67 45 -35 96 -49 136 -39 l25 6 30 42 30 41 0 -96 0 -97 10 0 c6 0 29 9 50 20 l40 20 0 111 c0 61 7 159 16 216 8 58 13 107 11 109 -2 2 -28 -1 -59 -7 l-54 -11 -13 -47 c-24 -90 -118 -231 -154 -231 l-15 0 -11 31 c-15 43 -14 90 4 190 17 100 55 220 97 308 32 68 92 141 114 141 8 0 19 -12 25 -27 l10 -27 -7 -41 c-3 -22 -17 -64 -30 -94 -13 -29 -24 -55 -24 -56 0 -2 20 -15 45 -30 25 -14 49 -23 54 -20 16 10 49 108 55 165 l6 55 -13 34 c-15 43 -73 90 -118 97 l-34 5 -40 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2477 1633 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2640 1605 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 1550 c0 -11 -4 -20 -10 -20 -5 0 -10 -7 -10 -15 0 -23 16 -18 34 10 20 30 20 45 1 45 l-15 0 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2639 1560 c-16 -10 -12 -15 19 -24 l22 -7 0 14 c0 19 -23 28 -41 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790 1551 c0 -5 7 -11 15 -15 8 -3 15 -1 15 3 0 5 -7 11 -15 15 -8 3 -15 1 -15 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 1531 c0 -5 7 -11 15 -15 l15 -5 0 14 c0 8 -7 15 -15 15 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730 1524 l0 -15 22 3 c12 2 23 9 26 16 l4 12 -26 0 -26 0 0 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2243 1523 c-18 -7 -16 -23 2 -23 8 0 15 7 15 15 0 8 -1 15 -2 14 -2 0 -9 -3 -15 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585 1469 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732 1469 c2 -7 10 -15 17 -17 l14 -4 -5 13 c-2 7 -10 15 -17 17 l-13 5 4 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2836 1449 c-3 -17 -4 -35 -1 -39 3 -4 14 -10 26 -13 l21 -6 -6 31 c-3 17 -6 37 -6 44 0 8 -6 14 -14 14 l-13 0 -7 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2580 1454 l0 -13 15 5 c8 4 15 9 15 13 0 4 -7 8 -15 8 -8 0 -15 -6 -15 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 1455 l0 -15 20 0 20 0 0 15 0 15 -20 0 -20 0 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792 1428 c6 -18 28 -21 28 -4 0 9 -7 16 -16 16 -9 0 -14 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305 1409 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510 1395 l0 -13 17 2 c24 4 27 21 3 23 l-20 2 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820 1385 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340 1380 l0 -20 15 0 15 0 0 20 0 20 -15 0 -15 0 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 1385 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2490 1380 l0 -20 15 0 15 0 0 20 0 20 -15 0 -15 0 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2235 1370 c-9 -14 -6 -17 29 -26 l28 -7 -4 19 -3 19 -22 3 c-11 2 -24 -2 -28 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197 1343 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535 1339 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615 1339 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850 1335 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 1325 c0 -6 11 -12 25 -13 l25 -2 0 14 0 14 -25 -2 c-14 0 -25 -6 -25 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2510 1325 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2650 1331 c0 -14 18 -23 31 -15 l11 7 -13 8 c-18 11 -29 11 -29 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2800 1314 c0 -9 5 -14 12 -12 18 6 21 28 4 28 -9 0 -16 -7 -16 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2486 1296 c3 -9 11 -16 16 -16 13 0 5 23 -10 28 l-12 4 6 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2762 1298 c6 -18 28 -21 28 -4 0 9 -7 16 -16 16 -9 0 -14 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2860 1285 l0 -14 15 5 c8 4 15 10 15 15 0 5 -7 9 -15 9 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500 1275 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005 1276 c3 -6 8 -19 11 -28 8 -22 34 -24 34 -3 0 8 -4 15 -10 15 -5 0 -10 6 -10 13 0 8 -7 14 -15 14 -9 0 -13 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2100 1286 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308 1273 c-24 -6 -23 -23 2 -23 l20 0 0 15 c0 8 -1 14 -2 14 -2 -1 -11 -3 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950 1265 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 1235 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135 1213 l-5 -14 35 3 35 2 -3 11 c-5 15 -56 13 -62 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316 1215 c-11 -8 -17 -17 -14 -20 10 -11 58 7 58 21 0 18 -20 17 -44 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950 1220 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 1210 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1211 c0 -5 7 -11 15 -15 l15 -5 0 14 c0 8 -7 15 -15 15 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 1211 c0 -5 7 -11 15 -15 8 -3 15 -1 15 3 0 5 -7 11 -15 15 -8 3 -15 1 -15 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1703 1203 c-18 -7 -16 -20 2 -20 8 0 15 6 15 14 0 7 -1 13 -2 12 -2 0 -9 -3 -15 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2730 1195 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2866 1195 c-3 -8 -1 -15 3 -15 5 0 11 7 15 15 3 8 1 15 -3 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 1184 l0 -15 17 3 c24 4 27 23 3 25 l-20 2 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200 1187 c0 -8 7 -14 15 -14 8 0 15 6 15 14 0 7 -7 13 -15 13 -8 0 -15 -6 -15 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2770 1180 c0 -5 9 -14 20 -20 l20 -11 0 15 c0 7 -7 17 -16 20 -21 8 -24 8 -24 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2839 1168 c-1 -2 -3 -15 -5 -30 -4 -38 13 -36 18 2 3 17 1 30 -4 30 -4 0 -9 -1 -9 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158 1153 c-10 -2 -18 -10 -18 -17 l0 -13 32 6 c17 4 33 12 36 19 l4 12 -19 -1 c-10 -1 -26 -3 -35 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 928 c1 -128 3 -241 4 -250 l1 -17 33 6 c17 3 41 12 52 19 11 7 37 16 58 19 l37 7 0 14 c0 8 -7 14 -15 14 l-15 0 0 30 c0 17 3 30 8 30 6 0 6 89 -2 220 -2 30 -4 74 -5 98 l-1 42 -78 0 -79 0 2 -232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 1105 l0 -55 140 0 140 0 0 29 c0 16 2 36 5 43 l6 14 -78 12 c-43 7 -108 12 -145 12 l-68 0 0 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023 1102 c-29 -20 -53 -43 -53 -50 l0 -13 62 3 63 3 2 48 2 47 -12 0 c-7 -1 -36 -18 -64 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225 1122 c-2 -3 -2 -8 1 -13 5 -9 34 -1 34 10 0 8 -27 10 -35 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220 1094 l0 -36 31 6 c17 3 38 6 45 6 l14 0 0 24 0 24 -31 6 c-17 3 -38 6 -45 6 l-14 0 0 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713 1103 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 l-30 0 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933 1093 c-23 -9 -14 -20 15 -18 39 3 42 4 42 15 0 10 -35 12 -57 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142 1088 c6 -18 28 -21 28 -4 0 9 -7 16 -16 16 -9 0 -14 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2341 1074 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 1071 c0 -4 11 -6 25 -3 14 2 25 6 25 8 0 2 -11 4 -25 4 -14 0 -25 -4 -25 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2476 1073 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2797 1067 l-5 -13 24 -11 23 -11 5 14 5 14 -20 0 -20 0 6 10 c3 6 2 10 -3 10 -6 0 -12 -6 -15 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 1018 l0 -43 39 -18 c41 -20 72 -20 79 1 l4 12 -15 0 c-9 0 -17 -6 -20 -12 l-4 -13 -14 13 -13 12 12 12 c7 7 12 20 12 30 l0 18 -15 0 -15 0 0 -26 0 -26 -12 4 c-7 3 -14 21 -16 41 -4 51 -22 47 -22 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 1035 l0 -14 15 5 c8 4 15 7 15 9 0 2 -7 5 -15 9 l-15 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 1030 c0 -19 11 -26 23 -14 8 8 -3 34 -14 34 -5 0 -9 -9 -9 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2790 1026 c0 -9 7 -16 16 -16 17 0 14 22 -4 28 -7 2 -12 -3 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2466 1003 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438 983 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1658 983 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2809 973 c-1 -5 -1 -11 -1 -14 1 -4 -6 -6 -15 -5 -25 2 -26 -21 -1 -27 l22 -6 8 12 c11 17 10 47 -2 47 -5 0 -11 -3 -11 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2495 959 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150 925 l0 -14 15 5 c8 4 15 7 15 9 0 2 -7 5 -15 9 l-15 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 925 c0 -9 5 -15 11 -13 6 2 11 8 11 13 0 5 -5 11 -11 13 -6 2 -11 -4 -11 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144 891 c-12 -12 -1 -21 25 -21 l29 0 5 14 5 13 -30 -1 c-16 -1 -31 -3 -34 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 875 c0 -9 5 -15 11 -13 6 2 11 8 11 13 0 5 -5 11 -11 13 -6 2 -11 -4 -11 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417 868 c-15 -5 -26 -15 -24 -21 5 -15 94 -29 175 -28 l62 1 0 -15 0 -14 18 5 c9 3 5 -2 -10 -11 -16 -8 -28 -20 -28 -26 l0 -11 53 7 c28 4 60 11 69 16 10 5 46 9 80 8 35 0 82 2 104 6 l42 7 6 -11 c4 -6 25 -11 46 -11 l39 0 -5 -15 c-6 -15 11 -22 19 -7 3 4 8 31 12 61 l7 53 -48 -6 c-46 -7 -508 9 -564 18 -14 3 -38 0 -53 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266 865 l-5 -15 14 0 c16 0 20 16 6 24 -5 3 -11 -1 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 870 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2747 863 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2164 848 c3 -7 9 -21 12 -30 4 -10 13 -18 20 -18 17 0 18 12 2 28 l-12 12 12 0 c7 0 12 5 12 10 0 6 -12 10 -26 10 l-26 0 6 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2280 845 c0 -8 4 -15 9 -15 5 0 11 7 15 15 l5 15 -14 0 c-8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953 843 c-18 -7 -16 -23 2 -23 8 0 15 7 15 15 0 8 -1 15 -2 14 -2 0 -9 -3 -15 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2110 835 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2765 829 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137 813 c-3 -10 -13 -54 -22 -97 -9 -44 -25 -99 -36 -122 l-18 -44 -16 6 -15 6 0 -11 c0 -20 25 -22 63 -6 20 8 39 15 42 15 3 0 5 -7 5 -15 0 -8 3 -15 8 -15 4 0 8 28 9 63 2 34 5 72 8 85 l5 22 -17 0 -17 0 22 20 c12 12 22 26 22 31 l0 11 -15 -6 c-22 -8 -18 12 5 24 11 6 20 15 20 21 l0 10 -22 -6 -21 -7 6 16 c4 9 2 16 -3 16 -5 0 -11 -8 -13 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262 808 c-6 -13 -16 -50 -22 -83 -14 -75 -38 -152 -58 -187 -9 -15 -13 -31 -9 -34 4 -4 18 -2 32 4 14 7 32 12 40 12 l13 0 -5 -20 -5 -20 14 0 c8 0 19 5 24 10 l11 11 -5 52 c-2 29 -8 57 -12 62 -5 6 -7 48 -5 94 l3 84 12 7 c13 8 6 30 -9 30 -4 0 -13 -10 -19 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2467 823 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2727 813 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2073 803 c-7 -2 -13 -11 -13 -20 l0 -14 17 3 c10 2 19 11 21 21 3 17 -3 20 -25 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2288 775 c-6 -30 -3 -43 8 -33 3 4 4 19 2 35 l-3 28 -7 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2417 783 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2183 765 c-7 -8 -13 -26 -13 -40 0 -15 -5 -35 -10 -46 l-11 -19 -35 0 -35 0 3 -27 3 -28 20 3 c38 5 156 3 175 -3 l20 -6 0 23 c0 13 -6 30 -12 37 -7 7 -8 12 -3 11 6 -2 22 -2 38 -1 l27 1 0 15 0 15 -25 -6 -25 -6 5 15 6 14 -18 7 c-10 3 -24 9 -30 12 l-13 6 0 -16 c0 -9 -7 -16 -15 -16 l-15 0 0 -20 0 -20 -18 0 -18 0 4 40 4 41 18 -6 18 -6 7 12 8 11 -14 9 c-19 12 -32 11 -46 -6z m97 -66 c0 -6 -6 -17 -14 -24 l-13 -14 -11 11 -10 10 11 14 c14 16 37 18 37 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2735 769 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687 753 c-13 -13 -7 -21 13 -16 11 3 20 9 20 14 0 10 -24 12 -33 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2060 750 c0 -9 31 -30 44 -30 13 0 5 28 -10 34 -23 9 -34 7 -34 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1952 718 c-16 -16 -15 -26 2 -44 23 -23 34 -16 34 21 l0 35 -12 0 c-7 0 -17 -5 -24 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2530 705 c0 -16 27 -32 37 -21 7 7 -16 36 -28 36 -5 0 -9 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2607 713 c-4 -3 -7 -15 -7 -25 l0 -18 15 0 15 0 0 25 c0 24 -10 32 -23 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036 694 c-9 -22 3 -32 14 -14 12 19 12 30 1 30 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2486 694 c-9 -24 -7 -34 8 -34 13 0 26 20 26 41 0 15 -27 10 -34 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2377 673 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423 660 c-13 -5 -23 -14 -23 -20 0 -12 2 -12 34 0 14 5 26 14 26 20 0 12 -7 12 -37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2435 649 c-8 -25 -1 -34 20 -26 8 4 15 16 15 27 l0 20 -14 0 c-8 0 -18 -9 -21 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1842 651 l-14 -8 17 -7 c23 -9 25 -8 25 9 0 17 -9 19 -28 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648 643 c-16 -2 -28 -9 -28 -15 l0 -10 23 6 c12 3 30 6 40 6 9 0 17 5 17 10 0 10 -3 10 -52 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 625 l0 -15 20 0 20 0 0 15 0 15 -20 0 -20 0 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943 633 l-23 -4 0 -80 c0 -43 4 -79 8 -79 5 0 27 20 49 45 l41 46 -5 39 -6 40 -21 -1 c-11 -1 -31 -4 -43 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463 623 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 l-30 0 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 600 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1529 607 l-176 -9 -2 -51 c-1 -27 -4 -53 -7 -58 -2 -4 -11 -6 -19 -2 -8 3 -15 1 -15 -5 0 -18 28 -21 57 -7 15 7 63 21 105 29 l77 16 161 0 160 0 0 50 0 50 -82 -2 c-46 -1 -162 -6 -259 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 222 c-37 -37 -67 -72 -67 -78 0 -15 124 -134 141 -134 16 0 139 119 139 136 0 9 -131 144 -141 144 -2 0 -35 -30 -72 -68z m43 -26 c0 -3 -5 -8 -12 -12 l-11 -7 7 11 c7 12 16 16 16 8z m47 -63 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z m-60 -20 c-4 -3 -7 0 -7 7 0 7 3 10 7 7 3 -4 3 -10 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2637 222 c-37 -37 -67 -72 -67 -78 0 -15 124 -134 141 -134 16 0 139 119 139 136 0 9 -131 144 -141 144 -2 0 -35 -30 -72 -68z m63 -49 l0 -18 -8 10 c-4 6 -11 13 -16 18 l-9 7 16 0 17 0 0 -17z m67 -40 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 145 l0 -115 43 0 c23 0 49 4 56 9 l15 10 -1 43 c-1 24 -1 65 -2 91 0 27 -5 55 -12 63 l-11 14 -44 0 -44 0 0 -115z m60 45 c0 -11 -4 -20 -10 -20 -5 0 -10 9 -10 20 0 11 5 20 10 20 6 0 10 -9 10 -20z m5 -93 c0 -26 -20 -25 -23 2 l-4 23 14 -4 c7 -3 13 -12 13 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 145 l0 -115 45 0 45 0 0 25 0 25 -20 0 -20 0 0 20 0 20 15 0 15 0 0 25 0 25 -15 0 -15 0 0 20 0 20 20 0 20 0 0 25 0 25 -45 0 -45 0 0 -115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306 168 c-9 -51 -19 -103 -21 -115 l-5 -23 24 0 24 0 5 20 c3 11 10 20 15 20 6 0 14 -9 17 -20 l6 -20 25 0 25 0 -5 18 c-2 9 -12 61 -21 115 l-17 97 -28 0 -28 0 -16 -92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462 248 l-12 -12 0 -92 0 -92 15 -12 c9 -7 30 -13 48 -12 l31 1 14 18 c7 10 11 27 10 38 l-3 20 -21 3 -21 3 -8 -23 -8 -23 -4 43 c-2 23 -2 59 0 80 l4 37 8 -23 8 -23 21 3 21 3 -2 29 c-1 16 -8 33 -15 38 -19 12 -72 10 -86 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 145 l0 -115 20 0 20 0 0 45 0 45 15 0 15 0 0 -45 0 -45 25 0 25 0 0 115 0 115 -25 0 -25 0 0 -45 0 -45 -15 0 -15 0 0 45 0 45 -20 0 -20 0 0 -115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880 241 c-5 -11 -10 -55 -10 -98 l0 -79 14 -19 13 -18 31 0 c17 0 38 6 47 13 l16 13 -3 26 -3 26 -22 3 -23 3 0 -21 0 -21 -10 6 c-5 3 -10 35 -10 70 0 35 5 67 10 70 l10 6 0 -20 0 -21 25 0 25 0 0 28 c0 15 -5 33 -12 40 -7 7 -29 12 -50 12 l-37 0 -11 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 145 l0 -115 45 0 45 0 0 19 0 20 -20 6 -20 6 0 90 0 89 -25 0 -25 0 0 -115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2150 156 l0 -104 14 -11 c8 -7 29 -13 47 -13 l32 -1 13 18 14 19 0 98 0 98 -25 0 -25 0 0 -95 0 -95 -10 0 -10 0 0 95 0 95 -25 0 -25 0 0 -104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310 145 l0 -115 49 0 49 0 10 13 11 12 0 93 0 92 -19 10 c-10 6 -37 10 -59 10 l-41 0 0 -115z m70 45 c0 -11 -4 -20 -10 -20 -5 0 -10 9 -10 20 0 11 5 20 10 20 6 0 10 -9 10 -20z m0 -89 c0 -11 -4 -23 -10 -26 l-10 -6 0 25 c0 14 5 26 10 26 6 0 10 -9 10 -19z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f49dc3",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1870 2650 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916 2585 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1955 2559 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 2370 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1972 2360 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838 2278 c7 -7 12 -21 12 -32 0 -10 3 -17 6 -13 10 10 -5 57 -18 57 l-12 0 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080 2281 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2176 2274 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 2264 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1986 2271 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916 2223 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420 2220 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 2210 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 2163 l-11 -28 15 19 c8 11 15 23 15 28 0 15 -7 8 -19 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 2174 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 2180 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2100 2179 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 2155 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548 2158 c7 -7 13 -26 13 -42 l1 -31 5 18 c7 26 -5 67 -19 67 l-12 0 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 2123 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 2110 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830 2110 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415 2099 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 2083 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456 2083 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1983 2093 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 2076 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 2076 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 2070 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221 2054 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476 2055 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0 -6 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1576 2054 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296 2044 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 2019 c-7 -11 -10 -23 -7 -25 2 -2 9 7 15 21 14 30 7 33 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105 2029 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046 2004 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756 1993 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982 1990 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131 1994 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482 1990 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 1990 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628 1963 l6 -28 4 19 c2 10 0 22 -6 28 l-10 10 6 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211 1968 c-1 -16 4 -28 9 -28 12 0 12 8 0 35 l-9 20 0 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296 1967 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 1960 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 1944 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891 1934 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020 1925 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741 1914 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 1894 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 1880 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541 1884 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 1874 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 1875 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 1864 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716 1864 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 1854 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1835 l-12 -15 16 0 c9 0 16 7 16 15 0 8 -2 15 -4 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 1824 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 1825 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 1803 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 1804 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 1760 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 1793 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 l-30 0 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515 1789 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1754 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495 1749 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 1730 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614 1734 l-19 -15 25 12 c31 14 36 19 24 19 -6 0 -19 -7 -30 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406 1733 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375 1729 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 1705 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0 -6 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 1683 c-13 -14 -22 -27 -19 -29 2 -2 16 10 32 26 16 17 25 30 19 29 -5 -1 -19 -12 -32 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 1670 c-16 -16 -26 -30 -22 -30 7 0 57 48 57 55 0 9 -7 5 -35 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363 1643 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 1620 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2300 1615 c0 -8 5 -15 10 -15 6 0 10 -6 10 -12 0 -17 39 -34 68 -30 l23 4 -4 11 c-2 7 -14 11 -26 9 -23 -2 -51 18 -51 37 0 6 -7 11 -15 11 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2402 1618 c5 -15 28 -23 28 -10 0 5 -7 13 -16 16 l-16 6 4 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2640 1612 c0 -4 9 -8 20 -9 l20 -2 -5 10 c-7 11 -35 12 -35 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503 1586 c0 -14 -8 -32 -17 -41 -9 -9 -16 -25 -16 -36 l0 -19 16 0 16 0 -6 16 -6 15 10 -6 c10 -6 14 7 11 34 l-2 13 12 -8 12 -7 -6 17 c-4 10 -7 24 -7 32 0 8 -4 14 -9 14 -5 0 -8 -11 -8 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 1583 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657 1583 c-11 -11 -8 -20 8 -20 8 0 15 6 15 14 0 14 -12 17 -23 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730 1575 c0 -6 55 -65 61 -65 2 0 5 11 5 25 l2 25 -14 0 c-8 0 -14 5 -14 10 0 6 -9 10 -20 10 -11 0 -20 -2 -20 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 1573 c0 -14 19 -38 25 -32 8 8 -5 39 -16 39 -5 0 -9 -3 -9 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594 1549 c-3 -6 -1 -15 6 -19 l13 -8 -22 -11 -22 -12 -21 7 -21 6 6 -16 6 -15 -17 -10 -17 -9 8 -9 9 -8 11 16 c7 8 22 18 34 21 l22 6 4 -12 c2 -6 -7 -21 -20 -33 -12 -12 -23 -29 -23 -38 l0 -15 28 0 c15 0 34 5 42 11 l15 11 -13 5 c-6 2 -10 9 -6 14 3 5 1 9 -5 9 -5 0 -13 -9 -16 -20 -4 -11 -11 -18 -16 -14 l-10 6 14 21 c8 12 20 23 26 23 6 1 17 2 25 3 8 0 17 12 20 26 l6 25 15 0 c8 0 15 -7 15 -15 l0 -14 -15 5 -15 6 0 -16 c0 -24 28 -19 36 7 11 36 13 67 3 67 -5 0 -9 -4 -9 -10 0 -5 -8 -10 -17 -10 l-18 0 -18 -32 -18 -31 -12 12 -12 12 17 13 17 13 -6 21 c-6 24 -18 28 -29 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 1540 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2393 1525 c0 -8 4 -12 8 -10 3 3 12 -2 19 -10 7 -8 19 -15 26 -15 l13 0 -6 18 c-4 9 -11 20 -17 24 -18 13 -43 9 -43 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2584 1526 l-7 -17 -14 5 -14 6 3 -17 c2 -10 11 -19 19 -21 l17 -3 6 27 c8 30 0 46 -10 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 1516 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250 1520 c0 -5 -7 -7 -15 -4 -8 4 -15 2 -15 -4 0 -10 23 -22 41 -22 5 0 9 9 9 20 0 11 -4 20 -10 20 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340 1520 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 1504 c-39 -21 -35 -28 5 -8 37 19 44 24 31 24 -5 -1 -21 -8 -36 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890 1502 c0 -5 7 -13 16 -16 l16 -6 -4 12 c-5 15 -28 23 -28 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807 1469 c6 -21 29 -36 39 -26 6 6 -27 47 -37 47 -4 0 -5 -9 -2 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2518 1482 c-20 -4 -23 -17 -7 -28 12 -7 33 10 28 23 -2 5 -12 7 -21 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472 1468 c2 -6 10 -14 16 -16 l12 -4 -6 16 c-7 18 -28 22 -22 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744 1451 c1 -13 7 -26 15 -29 l14 -5 -7 12 c-4 6 -4 16 0 22 l7 11 8 -13 c11 -18 21 -6 13 14 l-6 17 -22 -2 -23 -2 1 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410 1460 c-8 -5 -12 -12 -9 -15 8 -8 39 5 39 16 0 11 -11 11 -30 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 1455 c0 -8 7 -15 15 -15 8 0 15 4 15 9 0 5 -7 11 -15 15 l-15 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2570 1455 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2600 1460 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2702 1449 l-13 -21 6 -29 7 -29 14 0 c8 0 14 -4 14 -9 0 -14 32 -23 44 -11 l10 10 -22 20 c-11 11 -25 20 -31 20 -5 0 -12 7 -15 16 l-6 15 9 -5 c5 -3 11 5 13 19 l5 25 -11 0 c-6 0 -17 -9 -24 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2313 1445 l0 -15 19 0 c10 0 18 -4 18 -10 0 -5 7 -10 15 -10 8 0 15 5 15 11 0 17 -27 39 -48 39 l-19 0 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2762 1448 c2 -6 10 -14 16 -16 l12 -4 -6 16 c-7 18 -28 22 -22 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646 1435 c-3 -8 -1 -15 3 -15 5 0 11 7 15 15 3 8 1 15 -3 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020 1445 c0 -9 43 -55 52 -55 14 0 9 15 -12 38 -19 20 -40 29 -40 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2860 1435 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360 1431 c0 -5 7 -11 15 -15 l15 -5 0 14 c0 8 -7 15 -15 15 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443 1423 c-24 -16 -30 -33 -13 -33 10 0 50 36 50 45 0 9 -14 4 -37 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2820 1431 c0 -17 18 -21 24 -6 l5 15 -14 0 c-8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2550 1415 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2597 1423 c-12 -12 -7 -43 7 -43 13 0 26 20 26 41 0 10 -23 12 -33 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880 1405 l0 -14 15 5 c8 4 15 10 15 15 0 5 -7 9 -15 9 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930 1410 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675 1380 c0 -16 3 -30 6 -30 4 0 9 14 11 30 l5 30 -11 0 c-6 0 -11 -13 -11 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761 1380 c6 -16 14 -30 18 -30 4 0 6 14 3 30 l-4 30 -14 0 -13 0 10 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970 1400 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2863 1395 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9 -1 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2937 1403 c-12 -12 -7 -22 8 -17 8 4 15 10 15 15 0 11 -14 12 -23 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266 1385 c-24 -18 -18 -26 12 -18 12 3 22 12 22 19 0 18 -10 17 -34 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2100 1392 c0 -5 7 -13 16 -16 l16 -6 -4 12 c-5 15 -28 23 -28 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2360 1386 l0 -14 -20 5 -20 5 0 -26 c0 -14 5 -26 10 -26 6 0 10 5 10 10 0 6 7 10 15 10 8 0 15 5 15 11 0 5 5 7 10 4 6 -4 8 -15 5 -26 l-6 -19 9 0 c6 0 13 7 16 16 11 28 6 52 -10 58 -25 9 -34 7 -34 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 1380 c-8 -5 -11 -12 -7 -16 4 -4 13 -2 19 4 15 15 7 24 -12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820 1379 c0 -4 7 -9 15 -13 8 -3 15 -12 15 -19 0 -18 28 -18 35 1 l5 14 13 -11 13 -10 30 8 29 8 -30 8 c-16 4 -38 9 -47 11 l-17 5 -9 -17 -10 -17 -6 20 c-6 18 -36 29 -36 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2533 1378 c1 -7 14 -19 28 -26 l27 -13 -5 -20 -5 -19 11 0 c7 0 9 -4 6 -10 -3 -5 0 -10 8 -10 8 0 17 8 20 19 l5 19 -22 24 c-19 23 -57 48 -70 48 -3 0 -5 -6 -3 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2977 1383 c-4 -3 -7 -15 -7 -25 0 -10 -4 -18 -10 -18 -5 0 -10 -7 -10 -15 0 -8 7 -15 15 -15 8 0 15 7 15 16 l0 16 24 -6 24 -6 6 16 c4 9 1 23 -5 30 -12 15 -41 19 -52 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629 1373 c-6 -33 -5 -52 1 -48 14 9 40 -7 40 -23 l0 -16 16 23 16 23 35 -7 c19 -3 40 -8 47 -11 l13 -5 0 16 0 15 -31 2 c-17 1 -51 2 -76 2 l-45 1 1 18 c2 16 -15 25 -17 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2277 1364 c6 -15 23 -19 23 -5 0 5 -7 11 -14 14 l-15 6 6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1477 1363 c-11 -11 -8 -43 4 -43 l11 0 -11 -14 c-6 -7 -9 -20 -6 -28 7 -18 35 -19 35 -1 0 7 -5 13 -11 13 l-11 0 12 15 c7 8 16 15 21 15 5 0 6 -7 3 -15 -4 -8 -2 -15 4 -15 16 0 20 23 9 48 -10 22 -27 30 -27 12 0 -5 -4 -10 -10 -10 -5 0 -7 7 -4 15 6 15 -7 21 -19 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2000 1360 c0 -13 33 -21 42 -12 l9 9 -25 5 c-14 3 -26 2 -26 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230 1354 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190 1345 c0 -8 7 -15 15 -15 l14 0 -5 15 c-4 8 -10 15 -15 15 -5 0 -9 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 1356 c0 -2 6 -14 13 -27 l12 -24 25 -2 25 -3 -22 19 c-13 11 -23 24 -23 30 0 6 -7 11 -15 11 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2800 1346 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580 1330 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430 1325 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2880 1325 c-7 -9 -10 -18 -7 -21 10 -11 37 5 37 21 0 19 -14 19 -30 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 1315 l0 -14 15 5 c8 4 15 10 15 15 0 5 -7 9 -15 9 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342 1319 c2 -6 8 -10 13 -10 5 0 11 4 13 10 2 6 -4 11 -13 11 -9 0 -15 -5 -13 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2045 1320 c27 -12 35 -12 35 0 0 6 -12 10 -27 9 l-28 0 20 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2680 1326 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 1295 l0 -14 15 5 c8 4 15 10 15 15 0 5 -7 9 -15 9 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 1300 c0 -5 -11 -10 -24 -10 -14 0 -28 -5 -31 -11 -10 -15 -4 -17 31 -7 18 4 34 15 38 23 3 8 1 15 -4 15 -6 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985 1290 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2370 1274 l0 -25 -20 6 -20 6 0 -10 c0 -6 9 -11 20 -11 11 0 23 -7 26 -15 8 -19 44 -20 44 -1 0 7 -10 16 -21 19 l-21 6 6 25 6 26 -10 0 c-5 0 -10 -12 -10 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2495 1288 c-2 -7 -6 -43 -8 -80 l-4 -68 14 0 c7 0 13 7 13 15 l0 14 15 -5 15 -6 0 15 0 16 -22 4 -23 4 23 2 22 1 0 16 0 15 -19 -6 -18 -5 2 22 c2 13 6 31 10 41 l7 17 -11 0 c-7 0 -13 -6 -16 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2651 1291 l-13 -9 7 -21 c3 -11 12 -21 20 -21 16 0 29 35 20 50 -8 12 -16 12 -34 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2776 1291 c-3 -5 1 -11 9 -15 8 -3 15 -1 15 4 0 13 -18 22 -24 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324 1278 l-7 -11 19 -14 19 -14 4 13 c2 6 -1 14 -8 16 -6 2 -9 8 -5 13 3 5 1 9 -5 9 -5 0 -13 -5 -17 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785 1280 c-3 -5 1 -20 9 -32 l16 -22 0 26 c0 29 -15 45 -25 28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2410 1275 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2710 1276 c0 -8 6 -17 13 -19 l12 -5 -12 -1 c-7 -1 -13 -5 -13 -11 0 -12 10 -13 27 -2 l12 8 -6 22 c-6 24 -33 31 -33 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2910 1281 c0 -11 31 -24 39 -16 3 3 -1 10 -9 15 -19 12 -30 12 -30 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088 1261 c-22 -21 -23 -30 -4 -27 14 2 46 30 46 40 0 12 -26 4 -42 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 1268 l0 -13 30 0 30 0 -3 10 c-2 6 -16 11 -30 13 l-27 3 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820 1270 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2097 1264 l5 -14 -18 0 -18 0 11 -11 12 -12 15 16 c20 19 20 23 2 30 l-15 6 6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 1255 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 1255 c0 -9 5 -15 11 -13 6 2 11 8 11 13 0 5 -5 11 -11 13 -6 2 -11 -4 -11 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 1244 c0 -17 22 -14 28 4 2 7 -3 12 -12 12 -9 0 -16 -7 -16 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1245 c0 -8 4 -15 9 -15 5 0 11 7 15 15 l5 15 -14 0 c-8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964 1240 l0 -20 14 0 13 0 -3 17 c-4 24 -24 27 -24 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2134 1245 c-8 -19 5 -38 22 -31 7 3 16 0 20 -6 l7 -11 -11 7 -12 7 0 -24 0 -25 16 -6 c9 -3 22 -6 29 -6 l13 0 -2 25 -1 25 -12 -5 -13 -4 0 17 c0 16 -32 52 -45 52 -3 0 -8 -7 -11 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136 1235 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2037 1244 c-8 -8 1 -24 14 -24 5 0 9 7 9 15 0 15 -12 20 -23 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1926 1233 c-11 -11 -7 -20 9 -20 8 0 15 4 15 8 0 11 -16 20 -24 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2778 1233 c-19 -5 -22 -12 -12 -37 9 -23 24 -20 24 4 l0 20 15 0 c8 0 15 5 15 10 0 10 -12 11 -42 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2891 1223 l-13 -14 18 -14 c25 -19 44 -19 44 1 l0 16 -17 -7 -18 -6 13 12 c6 7 12 16 12 19 0 12 -26 7 -39 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1525 1220 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890 1220 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220 1211 c0 -5 7 -11 15 -15 l15 -5 0 14 c0 8 -7 15 -15 15 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320 1210 c0 -5 -7 -7 -15 -4 l-15 6 0 -11 c0 -6 11 -11 24 -11 14 0 28 -4 31 -10 3 -5 15 -10 26 -10 l19 0 0 14 c0 8 6 16 14 19 l14 6 15 -22 c8 -12 18 -19 22 -15 4 3 -3 16 -15 28 l-23 23 -36 -12 -36 -11 -3 10 c-5 13 -22 13 -22 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556 1205 c-30 -22 -15 -28 27 -10 9 4 17 10 17 14 0 12 -26 9 -44 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640 1205 l0 -14 15 5 c8 4 15 10 15 15 0 5 -7 9 -15 9 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085 1200 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 1194 l0 -14 20 0 c11 0 20 6 20 13 0 7 -9 13 -20 14 l-20 2 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710 1195 c0 -8 7 -15 15 -15 l14 0 -5 15 c-4 8 -10 15 -15 15 -5 0 -9 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 1200 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2436 1195 c4 -8 10 -15 15 -15 5 0 9 7 9 15 0 8 -7 15 -15 15 l-14 0 5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827 1187 l-5 -13 34 4 c19 2 31 8 28 13 -8 14 -51 11 -57 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950 1190 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 1185 c0 -8 7 -15 15 -15 8 0 15 4 15 9 0 5 -7 11 -15 15 l-15 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2667 1193 c-10 -9 -9 -23 2 -23 5 0 11 7 15 15 5 15 -5 20 -17 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2726 1178 c-10 -16 -16 -35 -12 -43 l5 -15 -14 0 c-7 0 -17 -10 -20 -21 l-7 -21 13 -9 c20 -12 26 -11 33 6 l5 15 -12 0 c-7 0 -2 8 11 18 l23 18 -3 40 -3 39 -19 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230 1173 c0 -7 7 -13 15 -13 8 0 15 -4 15 -10 0 -5 7 -10 15 -10 8 0 15 7 15 16 l0 15 -10 -6 c-6 -3 -13 0 -16 8 -6 18 -34 18 -34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2855 1179 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970 1165 l0 -14 15 5 c8 4 15 10 15 15 0 5 -7 9 -15 9 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075 1170 c-4 -6 -11 -8 -16 -5 -5 4 -9 -1 -9 -9 0 -18 16 -21 25 -6 4 6 11 8 16 5 5 -4 9 -2 9 4 0 5 10 12 23 14 l22 4 -32 2 c-17 0 -35 -4 -38 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070 1170 c0 -5 6 -10 14 -10 8 0 18 5 21 10 l6 10 -20 0 c-12 0 -21 -4 -21 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310 1166 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2800 1120 l0 -50 16 0 c8 0 12 4 9 10 l-6 10 15 -6 16 -6 0 21 0 22 -22 9 -23 9 18 0 c21 1 22 17 1 25 -9 3 -18 6 -20 6 -2 0 -4 -22 -4 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2906 1154 c-7 -19 1 -34 19 -34 12 0 25 21 25 41 0 16 -38 10 -44 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 1145 c0 -8 6 -15 13 -15 8 0 14 7 14 15 0 8 -6 15 -14 15 -7 0 -13 -7 -13 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 1150 l0 -11 115 7 115 7 1 -44 c1 -24 1 -73 0 -109 l-1 -65 12 25 c6 14 10 33 9 42 l-2 16 23 5 23 4 -22 2 -23 1 0 15 0 14 58 4 57 3 -57 2 -58 2 0 14 0 15 38 4 37 4 -38 1 -39 2 4 13 5 12 86 7 c48 3 112 6 142 5 30 -1 55 1 55 6 0 4 -121 7 -270 7 l-270 0 0 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2038 1153 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2370 1151 c0 -5 6 -12 13 -15 6 -3 -1 -4 -16 -2 l-28 3 5 -14 6 -14 -20 6 -20 6 0 -10 c0 -6 7 -11 15 -11 8 0 15 -3 15 -7 0 -5 22 -9 48 -10 l48 -3 2 25 2 25 -15 0 c-8 0 -15 -4 -15 -9 0 -14 -26 -20 -41 -9 l-14 10 17 -5 16 -6 6 16 c3 8 4 19 0 24 -7 12 -24 12 -24 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2657 1153 c-3 -4 -7 -23 -9 -42 l-3 -34 11 -4 12 -4 5 38 c2 21 1 42 -3 46 l-8 9 -5 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 1100 l0 -50 -19 0 c-11 0 -23 -4 -26 -10 l-6 -10 25 0 26 0 0 -19 c0 -11 -6 -22 -12 -25 l-13 -6 13 -6 c6 -3 12 -12 12 -20 0 -8 4 -14 9 -14 l10 0 3 105 3 105 -12 0 -13 0 0 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 1095 l0 -55 10 0 c11 0 11 3 14 68 l2 42 -13 0 -13 0 0 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2103 1143 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918 1119 c-18 -19 -24 -49 -10 -49 4 0 15 16 24 35 19 38 13 44 -14 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086 1126 l5 -14 20 5 c27 7 24 23 -6 23 l-24 0 5 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 1120 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0 -20 -4 -20 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455 1120 l-30 -6 24 -8 23 -8 11 11 c15 15 7 18 -28 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204 1060 c1 -33 4 -60 8 -60 4 0 9 26 11 58 l3 57 2 -59 2 -59 -15 -11 c-9 -6 -17 -21 -18 -34 l-1 -22 -14 0 c-7 0 -10 -4 -7 -10 11 -17 24 -11 31 15 3 14 9 23 14 20 12 -8 28 40 23 69 l-6 28 14 9 14 9 -11 8 c-6 4 -13 15 -17 25 -3 9 -12 17 -20 17 l-13 0 0 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2283 1113 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2512 1090 c0 -16 4 -30 9 -30 5 0 9 14 9 30 0 17 -4 30 -8 30 -5 0 -9 -13 -10 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2950 1106 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3010 1105 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151 1054 c-1 -31 -4 -61 -7 -65 -3 -5 5 -19 17 -31 l22 -23 -7 42 -6 41 13 5 12 4 -12 20 -12 20 11 11 c12 12 2 32 -16 32 l-13 0 -2 -56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748 1103 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2463 1103 c-7 -2 -13 -11 -13 -19 l0 -15 18 3 c17 3 32 17 32 31 0 8 -18 8 -37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 1089 c0 -5 5 -7 10 -4 15 10 12 -5 -6 -22 l-15 -16 -65 6 -64 5 0 -9 c0 -5 29 -9 65 -9 l65 0 0 -69 c0 -38 -5 -82 -10 -96 l-10 -27 12 4 c6 2 17 25 25 51 7 25 17 48 22 52 5 3 7 23 4 45 l-6 40 18 26 c9 15 12 23 6 20 -6 -4 -11 -2 -11 3 0 6 -9 11 -20 11 -11 0 -20 -5 -20 -11z m20 -49 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-3 -37 c-4 -3 -10 -3 -14 0 -3 4 0 7 7 7 7 0 10 -3 7 -7z m-3 -38 c-4 -8 -8 -15 -10 -15 -2 0 -4 7 -4 15 0 8 4 15 10 15 5 0 7 -7 4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445 1080 l-40 -6 38 -5 c21 -3 41 -1 44 4 3 4 3 9 2 10 -2 2 -22 0 -44 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805 1071 l-50 -7 53 -4 52 -5 0 13 c0 6 -1 11 -2 10 -2 0 -25 -4 -53 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3000 1070 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2336 1028 c-7 -57 -3 -148 7 -148 4 0 7 43 7 95 0 52 -2 95 -4 95 -3 0 -7 -19 -10 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2185 978 l0 -83 -52 -3 -53 -3 0 -11 0 -10 16 6 c9 3 37 6 64 6 l48 0 -3 43 c-1 23 -3 63 -4 90 -2 81 -16 51 -16 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398 1031 c-26 -4 -49 -9 -51 -11 -2 -3 0 -16 4 -30 l7 -25 1 28 1 27 55 0 55 0 0 10 c0 11 -1 11 -72 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710 1030 l-25 -8 33 -1 c17 -1 32 4 32 9 0 11 -5 11 -40 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 1025 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2806 1013 c-14 -15 -26 -36 -26 -46 l0 -19 13 5 c6 2 11 12 9 22 l-4 18 15 -6 15 -6 7 26 c3 14 4 27 1 30 -2 2 -16 -8 -30 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973 1003 c-7 -3 -13 -9 -13 -15 l0 -9 20 6 20 6 0 -15 c0 -9 5 -16 10 -16 6 0 10 7 10 15 0 17 -29 34 -47 28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838 1003 c-24 -6 -23 -23 2 -23 l20 0 0 15 c0 8 -1 14 -2 14 -2 -1 -11 -3 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2506 1001 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757 982 c-25 -28 -21 -37 9 -17 l26 16 39 -6 39 -7 0 9 c0 6 -6 10 -12 10 -7 0 -29 4 -48 7 l-36 7 -17 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730 990 l-15 -10 28 0 c15 0 27 5 27 10 0 13 -20 13 -40 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 980 l0 -10 28 6 c39 10 40 14 4 14 -18 0 -32 -5 -32 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 986 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678 983 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775 960 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957 956 c-4 -10 -5 -21 -2 -24 9 -9 17 6 13 25 l-4 18 -7 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 955 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698 952 c-16 -2 -28 -8 -28 -13 l0 -9 28 6 c15 4 29 8 31 10 8 7 -4 9 -31 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237 928 c-4 -12 -4 -24 -2 -27 7 -6 11 0 19 27 l7 22 -9 0 c-5 0 -12 -10 -15 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463 942 c-13 -2 -23 -8 -23 -13 0 -13 37 -11 45 2 9 14 5 16 -22 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825 943 c-16 -3 -34 -9 -40 -14 l-10 -10 43 3 42 3 0 13 c0 6 -1 11 -2 11 -2 -1 -16 -4 -33 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 931 c0 -20 63 -28 90 -11 21 13 5 23 -18 11 l-21 -11 -25 10 -26 10 0 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 930 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2800 926 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 920 l-15 -10 23 0 c12 0 22 5 22 10 0 13 -11 13 -30 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149 913 c-1 -10 -3 -35 -5 -56 l-3 -39 13 5 14 6 5 -19 5 -19 -12 2 -11 2 3 -24 4 -23 -10 6 -9 5 5 -24 c2 -14 9 -25 14 -25 l9 0 -6 21 -7 22 10 -7 10 -6 7 47 7 47 -17 12 c-9 7 -14 17 -10 23 3 6 2 11 -3 11 -5 0 -7 11 -4 25 2 14 2 25 -2 25 -3 0 -7 -8 -7 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 786 c0 -79 -3 -151 -6 -160 l-6 -16 26 0 c25 0 35 13 17 24 -4 3 -8 41 -8 85 l0 80 28 6 c16 4 29 11 29 16 l0 9 -30 -6 -30 -6 0 16 c0 9 7 16 15 16 8 0 15 5 15 10 0 6 -7 10 -15 10 l-15 0 0 30 c0 17 -4 30 -10 30 l-10 0 0 -144z m27 -163 c-4 -3 -10 -3 -14 0 -3 4 0 7 7 7 7 0 10 -3 7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725 920 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1990 915 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0 -4 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1668 913 c-10 -2 -18 -9 -18 -15 l0 -10 16 6 c9 3 20 6 25 6 5 0 9 5 9 10 0 10 -3 11 -32 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820 900 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220 896 c0 -9 7 -16 16 -16 9 0 14 5 12 12 -6 18 -28 21 -28 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2287 903 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2483 895 c0 -18 19 -15 25 3 2 7 -3 12 -10 12 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 884 l0 -15 10 6 c6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 884 l0 -15 10 6 c6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 890 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 876 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730 880 c-8 -5 -11 -12 -7 -16 4 -4 13 -2 19 4 15 15 7 24 -12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2757 883 c-2 -5 -4 -21 -5 -37 -1 -16 -7 -35 -12 -41 l-11 -13 16 -6 15 -5 0 14 c0 8 5 15 11 15 l11 0 -13 17 -14 17 12 -7 12 -7 -1 30 c-1 28 -12 40 -21 23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400 870 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2000 865 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0 -4 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655 860 l-20 -9 23 0 c12 -1 22 4 22 9 0 6 -1 10 -2 9 -2 0 -12 -4 -23 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2212 861 c-24 -15 -6 -60 24 -61 l12 0 -3 32 c-3 34 -12 43 -33 29z m15 -28 c-4 -3 -7 0 -7 7 0 7 3 10 7 7 3 -4 3 -10 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260 855 c0 -8 4 -15 8 -15 5 0 13 -12 20 -27 l11 -28 -3 33 -3 32 14 0 c7 0 13 5 13 10 0 6 -13 10 -30 10 l-30 0 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678 853 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 l-40 0 23 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476 845 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0 -6 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953 830 c-1 -17 2 -30 7 -30 6 0 10 14 10 30 0 39 -14 39 -17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2078 849 l-12 -8 17 -7 c9 -3 24 -3 33 0 l15 6 -6 -10 c-3 -6 -13 -10 -21 -10 l-14 0 0 -20 c0 -11 -4 -20 -9 -20 -6 0 -8 9 -6 20 l4 20 -16 0 -15 0 6 -22 c3 -13 6 -31 6 -40 l0 -17 20 4 20 4 0 -16 0 -15 14 5 14 6 -5 -20 c-3 -10 -11 -19 -18 -19 -6 0 -17 -11 -23 -25 -6 -14 -9 -25 -6 -25 2 0 16 7 30 16 l24 17 43 -7 42 -6 -37 18 -38 17 0 71 0 72 18 4 17 5 -3 -39 -4 -38 17 0 18 0 -7 31 c-3 17 -6 37 -6 44 l0 13 -50 -1 c-27 0 -55 -4 -62 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893 843 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843 843 c-18 -7 -16 -20 2 -20 8 0 15 6 15 14 0 7 -1 13 -2 12 -2 0 -9 -3 -15 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621 788 l-1 -58 14 0 14 0 -5 20 -5 20 11 0 c6 0 11 5 11 11 l0 10 -12 -7 -11 -7 6 16 c3 10 2 17 -3 17 -5 0 -11 8 -13 18 -3 9 -5 -9 -6 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2006 825 c4 -8 10 -15 15 -15 4 0 6 7 3 15 -4 8 -10 15 -15 15 -4 0 -6 -7 -3 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 820 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 815 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297 823 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 810 c0 -6 7 -10 15 -10 8 0 18 0 22 -1 4 0 9 3 10 8 2 5 -8 10 -22 11 -14 1 -25 -3 -25 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 804 c0 -4 8 -12 17 -19 18 -13 43 -9 43 7 l0 9 -20 -6 -20 -6 0 10 c0 6 -4 11 -10 11 -5 0 -10 -3 -10 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693 799 c-28 -10 -30 -29 -3 -22 20 5 36 21 29 27 -2 2 -14 0 -26 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 790 l-15 -10 17 0 c9 0 18 -6 21 -12 l5 -13 13 13 14 13 -15 9 c-19 12 -21 12 -40 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 790 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 787 c0 -8 6 -14 13 -14 8 0 14 6 14 14 0 7 -6 13 -14 13 -7 0 -13 -6 -13 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207 780 c-3 -11 -2 -20 3 -20 4 0 10 9 13 20 3 11 2 20 -3 20 -4 0 -10 -9 -13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895 780 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087 770 c-3 -11 -2 -20 3 -20 4 0 10 9 13 20 3 11 2 20 -3 20 -4 0 -10 -9 -13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 780 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 783 c0 -5 7 -16 14 -26 l14 -18 -2 25 -1 26 -12 0 c-7 0 -13 -3 -13 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790 774 l0 -16 -37 4 -36 3 -4 -12 -5 -13 65 0 65 0 6 16 c11 28 7 34 -24 34 l-30 0 0 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930 773 c0 -10 -3 -28 -6 -40 l-6 -23 17 0 17 0 -6 15 -5 15 19 0 c11 0 20 4 20 9 0 23 -14 41 -31 41 l-19 0 0 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020 775 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0 -4 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 770 c-3 -6 1 -13 10 -16 19 -8 30 0 20 15 -8 14 -22 14 -30 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023 773 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430 768 c0 -4 7 -8 15 -8 l14 0 -5 -15 -6 -15 11 0 c6 0 11 4 11 9 0 5 3 16 6 25 l6 16 -26 -2 c-14 -1 -26 -6 -26 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2697 767 l-6 -15 25 2 c13 0 22 6 21 11 -6 16 -34 17 -40 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780 750 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 735 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196 735 c-3 -8 -1 -15 3 -15 5 0 11 7 15 15 3 8 1 15 -3 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2210 738 c0 -5 -7 -16 -15 -24 -22 -22 -18 -34 10 -34 14 0 25 4 25 8 0 5 14 7 30 4 l30 -4 0 10 0 10 20 -5 c11 -3 23 -10 27 -16 l6 -10 -11 6 -10 7 5 -40 6 -40 -17 0 -16 0 0 32 c0 17 -3 28 -7 25 -3 -4 -12 -2 -20 5 -7 6 -16 8 -20 4 -4 -3 3 -13 15 -22 12 -8 22 -21 22 -29 l0 -13 -22 4 c-13 3 -6 -3 14 -12 l37 -16 16 15 15 16 0 45 0 46 -25 6 c-14 3 -25 12 -25 20 0 8 -5 14 -11 14 -6 0 -9 -6 -6 -14 l6 -14 -26 -7 c-14 -3 -28 -4 -31 0 -3 3 2 5 11 5 10 0 17 6 17 14 l0 14 -25 0 c-14 0 -25 -5 -25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077 718 c-4 -12 -4 -24 -2 -27 7 -6 11 0 19 27 l7 22 -9 0 c-5 0 -12 -10 -15 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121 724 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299 723 c0 -10 -1 -35 -2 -56 -1 -20 1 -37 6 -37 4 0 7 11 7 24 0 13 3 38 6 55 l7 31 -12 0 c-6 0 -11 -8 -12 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838 733 c-27 -7 -22 -23 7 -23 l25 0 0 15 c0 15 -2 16 -32 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400 728 c0 -8 7 -15 15 -15 18 0 15 19 -3 25 -7 2 -12 -3 -12 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2664 714 l-7 -26 14 -9 c21 -13 39 -11 39 6 0 8 -4 15 -10 15 -5 0 -10 9 -10 20 0 29 -18 25 -26 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655 723 c-22 -3 -44 -9 -49 -14 l-10 -9 60 0 59 0 -15 10 -14 9 64 4 65 3 -60 0 c-33 1 -78 -1 -100 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 710 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2446 711 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503 713 c-7 -3 -13 -9 -13 -14 0 -6 4 -7 10 -4 l10 6 -6 -15 c-3 -9 -16 -16 -28 -16 l-23 0 0 -15 c0 -18 9 -19 25 -3 l12 12 0 -12 c0 -7 7 -12 15 -12 8 0 15 7 15 15 0 9 8 19 18 23 9 4 19 14 20 22 2 8 0 12 -3 8 -4 -4 -15 -4 -24 1 -9 5 -22 6 -28 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 706 c0 -2 18 -6 40 -8 22 -2 40 0 40 4 0 5 -18 8 -40 8 -22 0 -40 -2 -40 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2597 696 l-6 -15 20 -6 c27 -9 35 0 19 20 -16 19 -26 19 -33 1z m20 -13 c-4 -3 -7 0 -7 7 0 7 3 10 7 7 3 -4 3 -10 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187 678 c-4 -12 -4 -24 -2 -27 7 -6 11 0 19 27 l7 22 -9 0 c-5 0 -12 -10 -15 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633 683 c26 -2 68 -2 95 0 26 2 4 3 -48 3 -52 0 -74 -1 -47 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 645 c0 -19 5 -35 10 -35 6 0 10 16 10 35 0 19 -4 35 -10 35 -5 0 -10 -16 -10 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 670 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 670 c0 -5 12 -10 28 -9 l27 0 -20 9 c-27 12 -35 12 -35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 655 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0 -6 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146 657 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443 658 l0 -13 49 3 c26 2 48 7 48 10 0 4 -22 8 -48 10 l-49 2 0 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687 663 c18 -2 50 -2 70 0 21 2 7 4 -32 4 -38 0 -55 -2 -38 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960 653 c0 -9 3 -14 6 -10 4 3 13 -1 21 -9 21 -20 27 -11 11 15 -15 25 -38 28 -38 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2650 660 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1856 638 l-4 -18 -33 0 c-58 0 -25 -9 44 -12 l67 -3 5 13 c3 8 5 19 5 26 l0 12 -39 -1 -40 0 -5 -17z m64 -8 c0 -5 -11 -10 -25 -10 -14 0 -25 5 -25 10 0 6 11 10 25 10 14 0 25 -4 25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690 640 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10 -16 0 -30 -4 -30 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 640 c0 -12 27 -12 55 0 l20 9 -37 0 -38 1 0 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2365 642 c-13 -13 -3 -22 25 -22 17 0 30 4 30 9 0 10 -47 21 -55 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 625 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410 624 l0 -14 19 0 c30 0 34 17 6 22 l-25 5 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495 630 l-6 -10 30 0 c17 0 31 5 31 10 0 6 -11 10 -24 10 -14 0 -28 -4 -31 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580 630 c0 -5 14 -10 31 -10 l30 0 -6 10 c-3 6 -17 10 -31 10 -13 0 -24 -4 -24 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 620 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050 605 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0 -4 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 603 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2091 553 c1 -62 6 -56 11 15 2 23 0 42 -4 42 -5 0 -7 -26 -7 -57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076 583 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 589 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310 590 c0 -5 11 -10 24 -10 14 0 28 5 31 10 l6 10 -30 0 c-17 0 -31 -4 -31 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433 593 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2165 591 c-11 -20 5 -31 46 -31 l39 0 0 15 0 15 -24 0 c-13 0 -31 3 -39 6 -8 3 -18 1 -22 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 575 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2056 565 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2002 548 c2 -6 10 -14 16 -16 l12 -4 -6 16 c-7 18 -28 22 -22 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 525 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 523 c107 -7 240 -7 240 0 0 4 -64 6 -142 5 -79 -1 -123 -3 -98 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195 510 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251 511 l-14 -9 8 -12 7 -12 23 6 23 6 5 -13 5 -12 13 13 13 12 -17 0 -17 0 0 17 0 16 -20 -18 -21 -19 7 17 c7 19 5 20 -15 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403 493 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 476 l0 -14 14 5 c7 3 13 9 13 14 0 5 -6 9 -13 9 -8 0 -14 -6 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1852 468 c3 -7 19 -14 36 -16 l32 -3 0 11 0 11 -19 -6 c-11 -3 -22 -1 -26 5 -9 14 -28 13 -23 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013 253 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199 253 l43 -4 -5 -20 c-3 -10 -1 -19 4 -19 5 0 9 11 9 25 l0 25 -47 -2 -48 -1 44 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321 243 l1 -18 5 13 c2 6 13 12 23 12 10 0 21 -6 23 -12 l5 -13 1 18 1 17 -30 0 -30 0 1 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523 253 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618 253 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678 210 c-1 -28 0 -50 5 -50 4 0 7 21 7 46 l0 46 20 -5 c11 -3 20 -1 20 4 0 5 -11 9 -24 9 l-24 0 -4 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 256 c0 -2 11 -6 25 -8 14 -3 25 -1 25 3 0 5 -11 9 -25 9 -14 0 -25 -2 -25 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2152 163 l2 -98 3 94 4 93 19 -5 c11 -3 20 -1 20 4 0 5 -11 9 -25 9 l-25 0 2 -97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220 253 c0 -5 11 -8 25 -8 14 0 25 3 25 8 0 4 -11 7 -25 7 -14 0 -25 -3 -25 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310 252 c0 -4 16 -6 35 -4 19 2 35 6 35 8 0 2 -16 4 -35 4 -19 0 -35 -4 -35 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1451 214 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917 213 c-10 -9 -9 -143 1 -143 4 0 7 34 7 75 0 41 0 75 -1 75 0 0 -4 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1940 210 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1977 200 c-3 -11 -1 -20 4 -20 5 0 9 9 9 20 0 11 -2 20 -4 20 -2 0 -6 -9 -9 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350 190 c0 -16 3 -30 8 -30 4 0 7 14 7 30 0 17 -3 30 -7 30 -5 0 -8 -13 -8 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2422 195 l0 -30 5 18 c2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 195 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0 -4 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 190 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311 184 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2660 181 c0 -5 7 -11 15 -15 l15 -5 0 14 c0 8 -7 15 -15 15 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2701 174 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 161 c0 -12 5 -21 10 -21 6 0 10 6 10 14 0 8 -4 18 -10 21 l-10 6 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100 160 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2570 145 c0 -8 4 -15 8 -15 5 0 9 7 9 15 0 8 -4 15 -9 15 -4 0 -8 -7 -8 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657 133 c-4 -3 -7 -11 -7 -17 0 -6 5 -4 10 4 l10 15 0 -12 c0 -7 4 -13 8 -13 5 0 9 7 9 15 0 15 -18 20 -30 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 130 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391 124 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055 120 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678 80 l4 -50 24 0 c13 0 24 4 24 9 0 5 -9 7 -20 4 l-20 -5 0 46 c0 25 -3 46 -7 46 -5 0 -6 -22 -5 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350 100 c0 -16 2 -30 4 -30 2 0 6 13 8 30 3 16 1 30 -4 30 -4 0 -8 -13 -8 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 120 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2650 115 c0 -8 4 -15 8 -15 5 0 9 7 9 15 0 8 -4 15 -9 15 -4 0 -8 -7 -8 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517 90 c-3 -11 -3 -20 -1 -20 2 0 8 9 14 20 l11 20 -9 0 c-6 0 -12 -9 -15 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1940 100 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1982 80 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291 74 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190 81 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2421 74 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1355 70 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 70 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876 55 c4 -8 11 -15 16 -15 l10 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -1 -7 2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 40 l-45 -7 48 -1 47 -2 0 10 c0 6 -1 9 -2 8 -2 0 -23 -4 -48 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 38 c0 -5 11 -8 25 -8 14 0 25 3 25 8 0 4 -11 7 -25 7 -14 0 -25 -3 -25 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 38 c0 -5 11 -8 25 -8 14 0 25 3 25 8 0 4 -11 7 -25 7 -14 0 -25 -3 -25 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 38 c0 -5 20 -8 45 -8 25 0 45 3 45 8 0 4 -20 7 -45 7 -25 0 -45 -3 -45 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310 38 c0 -4 21 -8 48 -7 52 1 48 6 -10 11 -21 2 -38 0 -38 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018 33 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473 33 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618 33 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953 33 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f8c0d8",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1887 2703 c-4 -3 -7 -13 -7 -22 l0 -15 14 19 14 19 26 -12 c14 -6 26 -8 26 -3 0 5 -10 11 -22 15 -30 8 -43 7 -51 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1896 2535 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0 -6 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1929 2513 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1988 2403 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020 2391 c0 -5 7 -11 15 -15 8 -3 15 -1 15 3 0 5 -7 11 -15 15 -8 3 -15 1 -15 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 2383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 2376 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 2323 l-14 -18 17 14 c10 7 25 11 33 7 8 -3 15 -1 15 4 0 17 -37 11 -51 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2071 2304 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 2283 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 2260 c-12 -16 -18 -30 -13 -30 4 0 16 14 25 30 9 17 15 30 13 30 -2 0 -13 -13 -25 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674 2258 l-29 -33 33 29 c17 17 32 31 32 33 0 8 -8 1 -36 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190 2286 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1977 2254 c-20 -27 -14 -32 10 -9 8 8 13 19 11 24 -2 5 -11 -2 -21 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1736 2235 c-3 -8 -1 -15 3 -15 5 0 11 7 15 15 3 8 1 15 -3 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2189 2233 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 2231 c0 -4 11 -6 25 -3 14 2 25 6 25 8 0 2 -11 4 -25 4 -14 0 -25 -4 -25 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850 2230 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 2214 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 2220 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2100 2200 c0 -11 4 -20 9 -20 5 0 7 9 4 20 -3 11 -7 20 -9 20 -2 0 -4 -9 -4 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2012 2185 l0 -30 5 18 c2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 2185 c-7 -8 -16 -12 -21 -9 -5 3 -9 0 -9 -5 0 -17 15 -13 35 9 10 11 16 20 13 20 -3 0 -11 -7 -18 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050 2173 l0 -18 8 11 c4 6 14 14 22 17 l15 5 -22 1 -23 1 0 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505 2180 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464 2168 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336 2124 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608 2115 c-3 -14 -1 -25 3 -25 5 0 9 11 9 25 0 14 -2 25 -4 25 -2 0 -6 -11 -8 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1889 2123 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 2120 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1466 2104 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729 2103 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431 2094 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 2091 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840 2085 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560 2064 c0 -19 4 -33 8 -30 8 5 4 66 -4 66 -2 0 -4 -16 -4 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 2051 c0 -5 7 -12 16 -15 l17 -6 -13 15 c-14 17 -20 19 -20 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221 2034 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1467 2037 c-2 -6 2 -18 9 -25 l14 -13 0 26 c0 26 -14 34 -23 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 2030 c-12 -5 -25 -14 -29 -20 l-7 -12 23 12 c12 7 34 16 48 21 l26 7 -20 1 c-11 0 -30 -4 -41 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901 2024 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284 2028 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687 2005 c10 -13 22 -25 27 -25 5 0 -1 11 -14 25 -30 32 -36 32 -13 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131 2014 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089 2003 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 1994 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602 1967 c-6 -6 -13 -26 -16 -42 l-6 -30 11 30 c7 17 16 36 22 43 12 16 3 16 -11 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981 1964 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1960 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 1950 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 1943 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1552 1940 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741 1934 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990 1910 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1900 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876 1895 c-3 -8 -1 -15 3 -15 5 0 11 7 15 15 3 8 1 15 -3 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 1874 c-4 -14 -5 -28 -3 -31 3 -2 8 8 11 23 4 14 5 28 3 31 -3 2 -8 -8 -11 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 1880 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573 1873 l0 -13 14 11 c7 6 13 12 13 14 0 1 -6 2 -13 2 -8 0 -14 -6 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540 1870 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 1853 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 1850 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399 1843 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 1804 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 1805 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 1789 c-1 -8 11 -26 27 -40 l27 -24 -21 25 c-12 14 -24 32 -27 40 l-5 15 -1 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336 1764 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 1765 c-6 -8 -10 -19 -8 -26 2 -6 9 0 16 15 13 29 10 33 -8 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 1740 c-9 -17 -15 -30 -13 -30 2 0 13 14 25 30 12 17 18 30 13 30 -4 0 -16 -14 -25 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1740 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322 1705 l0 -30 5 18 c2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 1695 l0 -30 5 18 c2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 1679 l-11 -21 10 6 11 6 3 -22 4 -23 5 38 c6 41 -4 48 -22 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 1665 c14 -16 50 -21 50 -6 0 5 -9 7 -20 4 l-20 -5 0 11 c0 6 -5 11 -11 11 l-11 0 12 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310 1640 c0 -5 11 -10 25 -10 14 0 25 5 25 10 0 6 -11 10 -25 10 -14 0 -25 -4 -25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2477 1633 c-13 -12 -7 -23 13 -23 l20 0 0 15 c0 15 -21 21 -33 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2280 1615 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 1610 c0 -9 39 -25 45 -18 2 2 -7 8 -21 15 -13 6 -24 7 -24 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2317 1613 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2622 1608 c6 -18 28 -21 28 -4 0 9 -7 16 -16 16 -9 0 -14 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 1600 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2580 1600 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2660 1600 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2360 1583 c0 -7 5 -13 10 -13 6 0 10 -7 10 -15 0 -9 7 -18 16 -22 l15 -6 -5 -13 c-6 -16 19 -44 40 -44 19 0 18 26 -1 34 -8 3 -15 12 -15 21 0 8 -4 15 -10 15 -5 0 -10 9 -10 21 l0 20 -10 -6 c-5 -3 -10 0 -10 8 0 7 -7 14 -15 14 -8 0 -15 -6 -15 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 1596 c0 -2 7 -9 15 -16 l15 -12 0 16 c0 9 -7 16 -15 16 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 1596 c0 -2 7 -9 15 -16 l15 -12 0 16 c0 9 -7 16 -15 16 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2551 1586 c-16 -19 -11 -29 8 -17 7 5 12 14 9 21 l-4 12 -13 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 1583 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634 1576 c-18 -8 -35 -19 -39 -26 l-8 -12 14 -9 14 -8 7 19 c4 11 14 20 23 20 8 0 15 4 15 9 0 5 9 7 20 4 l20 -5 0 11 c0 15 -28 13 -66 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 1545 c0 -8 -4 -15 -10 -15 -5 0 -10 -4 -10 -10 0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 5 10 10 10 6 0 9 -3 8 -7 -4 -17 14 -53 28 -53 19 0 18 26 -1 34 -8 3 -15 10 -15 16 0 6 4 9 9 5 6 -3 15 4 21 15 6 11 9 20 6 20 -3 0 -16 -4 -31 -10 l-26 -10 6 10 6 10 -15 0 c-9 0 -16 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 1534 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815 1540 l-6 -10 15 0 c9 0 16 -4 16 -10 0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 1528 c0 -8 7 -15 15 -15 18 0 15 19 -3 25 -7 2 -12 -3 -12 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2586 1525 l-5 -15 14 0 c8 0 15 7 15 15 0 8 -4 15 -9 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530 1523 c0 -5 -20 -16 -45 -26 l-45 -19 0 -14 0 -14 60 30 c58 29 76 50 45 50 -8 0 -15 -3 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260 1515 l0 -14 -15 5 -15 6 0 -12 0 -12 23 5 c12 3 39 9 60 12 20 4 37 11 37 16 0 5 -20 9 -45 9 l-45 0 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2640 1515 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2306 1485 l-20 -15 12 -12 12 -12 15 20 c16 21 19 34 8 34 -5 0 -17 -7 -27 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540 1479 c0 -12 29 -38 43 -39 12 0 8 20 -7 36 -17 17 -36 18 -36 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1590 1480 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1712 1479 c-13 -5 -35 -6 -48 -3 l-24 6 0 -15 c0 -22 20 -32 32 -16 l9 14 -3 -30 -3 -30 17 -3 18 -3 -6 30 -6 31 21 0 21 0 0 15 c0 8 -1 15 -2 14 -2 0 -13 -4 -26 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2570 1475 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2337 1474 c-9 -10 2 -24 19 -24 8 0 14 7 14 15 0 15 -21 21 -33 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1606 1454 l-6 -16 12 4 c15 5 23 28 10 28 -5 0 -13 -7 -16 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2610 1460 c0 -5 18 -10 39 -10 22 0 46 -3 55 -6 l16 -6 0 16 0 16 -55 0 -55 0 0 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490 1444 l0 -16 15 12 c8 7 15 14 15 16 0 2 -7 4 -15 4 -8 0 -15 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1809 1454 c0 -5 -2 -17 -4 -26 l-3 -18 14 0 13 0 -5 15 c-9 24 9 17 30 -10 21 -28 36 -32 36 -10 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -4 15 -9 15 -5 0 -16 3 -25 6 -9 3 -16 2 -17 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 1444 c0 -6 9 -14 20 -17 l20 -5 15 15 c8 8 15 16 15 18 0 2 -16 3 -35 2 l-35 -1 0 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2740 1435 l0 -15 20 0 c11 0 20 -4 20 -10 0 -5 5 -10 11 -10 6 0 9 8 7 18 l-4 17 -17 -1 c-9 -1 -14 2 -11 7 3 5 -2 9 -10 9 -9 0 -16 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521 1422 c-7 -13 -11 -26 -8 -28 8 -8 29 25 25 38 l-5 13 -12 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2046 1431 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2320 1425 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2563 1420 c1 -17 47 -58 47 -41 0 5 -4 13 -10 16 -5 3 -10 14 -10 24 0 10 -6 18 -14 18 -8 0 -14 -8 -13 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2620 1430 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2850 1420 l-11 -20 15 0 c16 0 29 27 16 35 -5 3 -14 -4 -20 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 1415 c0 -8 7 -15 15 -15 l14 0 -5 15 c-4 8 -10 15 -15 15 -5 0 -9 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 1422 c0 -12 19 -26 26 -19 2 2 -2 10 -11 17 l-15 12 0 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2660 1415 c0 -8 6 -15 13 -15 7 0 18 -9 25 -20 13 -21 42 -28 42 -10 0 6 -6 10 -14 10 -8 0 -17 11 -20 25 l-6 25 -20 0 -20 0 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400 1398 l0 -14 20 0 c24 0 21 20 -3 24 l-17 3 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1913 1403 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960 1400 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2924 1400 c-12 -5 -25 -13 -29 -19 l-6 -11 15 0 c8 0 21 6 27 13 l13 13 28 -4 c15 -2 31 -9 35 -15 l6 -10 -21 5 -20 6 -6 -21 c-3 -12 -1 -26 3 -30 l9 -9 19 19 c27 27 34 48 20 62 -13 13 -63 14 -93 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274 1385 c-4 -8 -10 -12 -15 -9 -5 3 -9 0 -9 -5 0 -21 33 -6 38 17 3 17 -7 15 -14 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 1390 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 1389 l0 -11 15 6 15 5 0 -13 c0 -14 21 -26 46 -26 8 0 14 5 14 10 0 6 -8 10 -19 10 -10 0 -24 7 -31 15 -15 17 -40 20 -40 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2376 1384 c-4 -9 -4 -19 -2 -22 10 -9 36 8 36 23 0 20 -26 19 -34 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 1380 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2327 1384 c-9 -9 4 -34 18 -34 l13 0 -5 20 c-5 20 -15 25 -26 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2506 1375 l-5 -15 14 0 14 0 -5 15 c-4 8 -7 15 -9 15 -2 0 -5 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2750 1382 c0 -5 7 -15 15 -22 l15 -12 0 10 c0 5 -7 15 -15 22 l-15 12 0 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2820 1375 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 1355 l0 -14 15 5 c8 4 15 10 15 15 0 5 -7 9 -15 9 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405 1359 c-11 -17 1 -21 15 -4 l12 15 -10 0 c-6 0 -14 -5 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546 1355 l-5 -15 13 0 c8 0 16 -6 19 -12 l5 -13 13 13 13 12 -17 0 c-9 0 -17 7 -17 15 0 8 -4 15 -9 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904 1354 c3 -9 6 -20 6 -25 0 -5 5 -9 10 -9 6 0 10 7 10 15 0 8 -5 15 -11 15 -5 0 -7 5 -4 10 3 6 1 10 -5 10 l-12 0 6 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970 1360 l-15 -10 28 0 c15 0 27 5 27 10 0 13 -20 13 -40 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2453 1363 c-7 -3 -13 -11 -13 -19 l0 -14 23 2 c13 1 24 8 24 15 0 14 -17 22 -34 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670 1346 c0 -17 23 -27 40 -16 l13 8 -21 11 c-27 14 -32 14 -32 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020 1350 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250 1347 c0 -8 -6 -18 -12 -21 l-13 -6 13 -6 c6 -3 10 -10 6 -15 -3 -5 2 -9 11 -9 l16 0 -6 21 -7 21 21 -7 21 -6 0 15 c0 9 -4 16 -9 16 -5 0 -16 3 -25 6 l-16 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463 1343 c-23 -8 -13 -23 15 -23 l27 0 -15 -10 c-8 -5 -11 -10 -6 -10 5 0 18 8 29 18 l20 17 -6 -17 -6 -17 15 6 c17 6 17 10 2 27 l-13 14 -22 -9 c-12 -4 -23 -4 -25 0 -2 4 -9 6 -15 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190 1341 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2583 1325 c0 -14 4 -25 9 -25 5 0 7 4 4 9 -4 5 -1 11 6 13 l12 4 -8 12 c-12 20 -23 14 -23 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2907 1341 c-10 -4 -18 -11 -17 -16 0 -6 -6 -11 -14 -13 l-16 -3 0 15 c0 9 -7 16 -15 16 -8 0 -15 -7 -15 -15 0 -8 5 -15 10 -15 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 5 10 10 0 6 8 10 18 10 l17 0 12 27 c7 15 12 27 10 29 -1 1 -10 -1 -20 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 1325 l0 -14 15 5 c8 4 15 10 15 15 0 5 -7 9 -15 9 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2767 1328 l-38 -10 7 -22 c4 -11 8 -23 10 -25 2 -3 11 4 20 15 8 10 12 13 8 5 l-7 -14 11 7 c5 3 12 1 14 -6 l4 -12 7 18 7 17 -10 -6 c-6 -3 -10 1 -10 9 0 9 5 15 11 14 6 -2 14 3 16 10 5 14 2 14 -50 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960 1320 c0 -5 -13 -10 -29 -10 l-29 0 -5 -22 c-6 -23 -1 -38 13 -38 4 0 6 8 3 19 -3 10 1 22 7 26 l12 8 8 -14 c5 -7 6 -17 3 -23 l-6 -9 17 6 c10 4 26 7 37 7 10 0 19 5 19 10 0 6 -11 10 -25 10 -14 0 -25 5 -25 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069 1318 c-1 -7 -1 -16 0 -20 0 -5 -8 -8 -19 -8 -11 0 -20 -4 -20 -10 0 -5 14 -10 31 -10 l31 0 -4 25 -5 24 11 5 c6 2 3 5 -6 5 -10 1 -19 -5 -19 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2930 1305 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2610 1299 c0 -13 25 -39 38 -39 15 0 8 30 -9 41 -19 12 -29 11 -29 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131 1291 l-14 -9 6 -16 c9 -24 22 -19 25 9 1 14 1 25 -1 25 -1 0 -8 -4 -16 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 1287 c0 -10 7 -17 15 -17 8 0 15 -7 15 -15 l0 -14 15 5 c18 7 20 24 3 24 -6 0 -20 7 -30 17 l-18 16 0 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 1285 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735 1291 c-3 -6 -20 -10 -38 -8 l-32 2 -3 -22 -3 -23 10 0 c6 0 11 7 11 15 l0 15 23 -5 23 -6 14 16 c7 8 10 18 7 21 -3 3 -8 1 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 1283 c0 -7 6 -13 13 -13 8 0 14 6 14 13 0 8 -6 14 -14 14 -7 0 -13 -6 -13 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2512 1275 l5 -24 -11 -5 -11 -4 20 -17 c11 -9 15 -14 8 -11 -6 4 -14 2 -18 -4 -3 -5 -1 -10 6 -10 l13 0 -20 -16 -19 -15 22 4 22 5 -6 -14 c-3 -8 -13 -14 -23 -14 l-19 0 -6 -20 c-3 -11 -11 -20 -16 -20 -5 0 -9 -5 -9 -11 l0 -10 30 4 c16 3 36 12 45 20 l15 16 0 85 0 86 -16 0 -16 0 4 -25z m8 -139 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2678 1268 l4 -29 13 11 c15 13 9 47 -9 47 l-12 0 4 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385 1281 c-7 -12 12 -24 25 -16 11 7 4 25 -10 25 -5 0 -11 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 1275 c0 -8 7 -15 15 -15 8 0 15 4 15 9 0 5 -7 11 -15 15 l-15 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094 1264 l-11 -5 6 -31 7 -32 27 -7 27 -7 0 14 0 14 -20 0 -20 0 -1 23 c-1 12 -1 25 0 30 0 4 0 7 -1 6 -2 0 -8 -3 -14 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2410 1245 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2762 1255 c3 -4 -2 -15 -13 -26 l-19 -19 6 -15 c9 -22 21 -18 28 10 4 14 11 25 16 25 16 0 11 17 -7 24 -10 4 -15 4 -11 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473 1223 c-17 -37 -16 -43 7 -43 22 0 27 15 8 23 l-13 5 13 1 c13 1 18 41 5 41 -5 0 -14 -12 -20 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2160 1240 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2710 1234 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1976 1233 c-11 -11 -6 -21 12 -26 l17 -5 -24 -1 -25 -1 10 -9 c5 -5 26 -13 47 -16 l37 -7 -6 16 -6 16 21 0 c24 0 28 15 6 24 l-15 5 -10 -19 c-10 -19 -31 -28 -29 -12 3 18 -2 30 -15 35 -8 3 -17 3 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2815 1232 c-2 -2 -1 -10 2 -18 3 -8 0 -20 -6 -28 -14 -17 -5 -43 14 -43 18 0 20 13 3 21 -7 3 -1 3 13 0 l26 -5 0 15 c0 8 -5 14 -11 13 -6 -1 -11 5 -11 13 l0 15 15 -4 c8 -2 21 -4 28 -4 6 0 12 -6 12 -14 0 -7 5 -13 11 -13 l10 0 -7 23 c-4 12 -12 25 -18 29 -11 8 -73 7 -81 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276 1223 c-4 -4 -25 -6 -46 -4 l-40 3 0 -10 c0 -22 13 -42 26 -42 8 0 14 5 14 10 0 6 -6 10 -12 10 l-13 0 15 10 14 9 7 -10 c3 -6 17 -9 29 -7 l23 3 3 18 c2 17 -7 23 -20 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 1220 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1826 1223 c-11 -3 -25 -11 -33 -18 l-12 -13 14 -12 15 -12 0 15 0 15 30 7 c17 4 30 11 30 16 0 9 -12 10 -44 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2982 1205 c11 -24 28 -34 28 -16 0 21 -13 41 -26 41 l-14 0 12 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993 1208 c-5 -7 -13 -19 -17 -25 l-7 -13 15 0 c8 0 18 9 21 21 8 25 2 34 -12 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633 1200 l-2 -19 18 -6 c20 -6 51 3 51 15 0 4 -7 11 -16 14 l-15 6 6 -10 6 -10 -16 0 -17 0 6 15 5 15 -12 0 c-7 0 -13 -9 -14 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710 1210 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0 -20 -4 -20 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 1210 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 1200 c-21 -13 -3 -27 30 -22 l30 4 0 13 0 13 -24 0 c-13 0 -29 -4 -36 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560 1195 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 1201 c0 -11 26 -22 34 -14 12 12 5 23 -14 23 -11 0 -20 -4 -20 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2238 1198 c7 -7 12 -17 12 -22 l0 -11 -9 13 -8 13 -13 -16 -14 -17 15 -9 c8 -5 22 -9 32 -9 l17 0 0 23 c0 24 -17 47 -34 47 l-10 0 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670 1200 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2152 1189 c2 -7 10 -15 17 -17 l14 -4 -5 13 c-2 7 -10 15 -17 17 l-13 5 4 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510 1180 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2280 1164 l0 -15 10 6 10 6 0 -15 0 -16 20 0 20 0 0 15 0 14 -14 -5 -13 -5 -6 15 c-8 21 -27 21 -27 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 1155 l-12 -15 16 0 c9 0 16 7 16 15 0 8 -2 15 -4 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 1138 l0 -31 18 16 c10 10 25 17 33 17 l14 1 -19 14 c-11 8 -26 15 -33 15 l-13 0 0 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 1149 l0 -17 22 -5 c12 -4 25 -2 28 4 8 11 33 14 110 10 l55 -2 -20 -8 -20 -8 23 -12 22 -12 0 21 c0 11 5 20 10 20 l11 0 -3 -265 -3 -265 10 3 c6 2 11 18 13 35 l3 32 15 0 c8 0 14 5 14 11 l0 11 -16 -6 -16 -6 4 134 c2 74 0 130 -4 123 l-8 -12 0 21 c0 12 3 42 6 68 l7 46 28 0 c16 0 29 5 29 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 11 10 25 10 34 0 32 18 -2 23 l-28 4 28 2 c15 0 27 5 27 11 l0 9 -155 3 -155 3 0 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2060 1160 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1922 896 l-1 -269 -13 -8 -13 -9 13 0 14 0 -4 -75 -3 -75 11 0 11 0 -4 53 c-2 28 -5 64 -7 80 -1 15 1 27 6 27 4 0 8 17 8 38 l0 37 20 12 19 13 -5 -15 -6 -15 12 0 12 0 -7 28 c-4 15 -7 38 -6 50 l1 24 -19 5 -20 5 1 26 c0 15 -1 32 -2 37 -1 6 -2 49 -1 97 l1 87 113 4 112 3 -117 2 -117 2 -4 53 c-2 28 -4 -69 -5 -217z m35 -123 c-4 -3 -10 -3 -14 0 -3 4 0 7 7 7 7 0 10 -3 7 -7z m13 -38 c0 -1 -9 -5 -19 -8 l-20 -5 6 14 c2 7 11 10 19 7 8 -3 14 -6 14 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 1140 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730 1139 c0 -5 27 -9 60 -9 l60 0 0 -10 c0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5 7 -10 15 -10 l15 0 0 -25 0 -25 -55 0 -55 0 0 -10 0 -10 55 0 55 0 0 -54 0 -54 -12 -6 -13 -6 13 -6 12 -6 0 -44 0 -44 -20 0 c-11 0 -20 -4 -20 -10 0 -5 6 -10 14 -10 8 0 17 -3 19 -7 3 -5 -24 -6 -60 -5 l-65 4 6 -11 c4 -6 29 -11 55 -11 l47 0 20 -15 19 -16 -35 6 -35 6 15 -10 15 -11 -17 0 c-10 0 -18 -4 -18 -9 0 -5 -8 -12 -17 -14 l-18 -5 18 -1 18 -1 -7 -11 -7 -12 36 5 36 4 4 -11 c3 -5 3 -51 2 -101 l-3 -91 11 0 12 0 -3 341 -3 341 -69 1 -70 2 0 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2118 1143 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430 1135 c0 -8 7 -15 16 -15 l16 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -4 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2660 1135 c0 -8 7 -15 16 -15 l16 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -4 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3010 1130 l0 -20 -15 0 -15 0 0 -19 c0 -24 13 -33 33 -25 l15 5 0 40 c1 21 -3 39 -9 39 -5 0 -9 -9 -9 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2178 1133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2927 1133 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473 1123 c-15 -5 -17 -23 -4 -23 5 0 11 7 15 15 3 8 4 15 3 14 -1 0 -8 -3 -14 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2218 1108 l6 -23 4 17 c2 9 11 19 20 21 l17 5 -27 1 -26 1 6 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174 1109 c-3 -6 -2 -15 4 -21 13 -13 32 -2 32 18 0 16 -26 19 -36 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2295 1110 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2346 1104 l-5 -14 14 0 c20 0 28 17 11 23 l-14 6 -6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2393 1100 c1 -19 17 -27 30 -14 9 10 -4 34 -18 34 l-14 0 2 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951 1101 l-13 -8 12 -8 c13 -8 24 -1 19 14 l-4 10 -14 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125 1100 c-4 -6 -12 -7 -18 -3 l-12 7 14 -17 13 -17 19 11 19 10 0 -21 c0 -11 5 -20 10 -20 14 0 12 22 -4 43 -15 19 -32 22 -41 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2656 1096 l6 -16 24 2 c32 3 25 22 -9 26 l-27 3 6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2830 1081 c0 -12 5 -21 10 -21 6 0 10 6 10 14 0 8 -4 18 -10 21 l-10 6 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2940 1085 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983 1073 l0 -13 14 11 c7 6 13 12 13 14 0 1 -6 2 -13 2 -8 0 -14 -6 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290 988 l5 -93 -30 0 -30 0 5 88 5 87 -12 0 -13 0 0 -85 0 -85 -16 0 -15 0 6 -10 c3 -5 35 -10 71 -10 l64 0 0 10 c0 6 -4 10 -10 10 l-10 0 0 90 0 90 -12 0 -13 0 5 -92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 1049 c0 -10 5 -21 10 -24 6 -3 10 -2 10 4 0 5 2 16 5 24 l6 14 -16 0 -15 0 0 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2510 1055 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2680 1060 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2926 1051 c-3 -5 1 -11 9 -15 l15 -5 0 14 c0 16 -16 20 -24 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2790 1025 c0 -8 4 -15 8 -15 5 0 9 7 9 15 0 8 -4 15 -9 15 -4 0 -8 -7 -8 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 1020 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 1014 l0 -15 10 6 10 6 0 -24 0 -24 14 0 14 0 -4 20 c-7 38 -44 64 -44 31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 1000 c-3 -33 1 -94 6 -99 12 -12 14 13 6 65 l-10 59 -2 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 990 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 991 c0 -5 10 -11 23 -15 31 -8 37 -7 37 5 l0 11 -15 -6 c-8 -3 -15 -1 -15 4 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 990 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 990 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 984 c0 -27 13 -44 34 -44 l21 1 -18 13 -17 13 5 15 6 15 -16 0 c-8 0 -15 -6 -15 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 980 c0 -5 6 -10 14 -10 8 0 16 -6 19 -12 2 -7 8 -10 12 -5 5 4 0 14 -11 22 -23 17 -34 19 -34 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 980 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 975 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745 969 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710 960 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790 960 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1980 955 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2803 953 c0 -7 6 -13 14 -13 7 0 13 6 13 13 0 8 -6 14 -13 14 -8 0 -14 -6 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 950 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0 -20 -4 -20 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240 951 c0 -6 5 -13 10 -16 l10 -6 0 15 c0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 939 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196 935 l-5 -15 14 0 c8 0 15 7 15 15 0 8 -4 15 -9 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 940 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950 901 l0 -51 10 0 10 0 0 44 c0 25 -4 48 -10 51 l-10 6 0 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 930 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 926 c0 -9 7 -16 16 -16 9 0 14 5 12 12 -6 18 -28 21 -28 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735 930 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 930 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150 930 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410 930 c0 -5 12 -10 26 -10 l25 0 -6 10 c-3 6 -15 10 -26 10 -10 0 -19 -4 -19 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795 930 c3 -5 13 -10 21 -10 8 0 12 5 9 10 -3 6 -13 10 -21 10 -8 0 -12 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113 914 c-3 -8 -1 -20 6 -27 l11 -11 0 27 c0 30 -7 35 -17 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383 923 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 920 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 915 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2783 910 l5 -19 -14 6 c-17 6 -18 -9 -2 -25 17 -17 25 -15 33 11 12 35 11 40 -8 43 l-19 3 5 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 905 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685 910 c3 -5 13 -10 21 -10 8 0 14 5 14 10 0 6 -9 10 -21 10 l-20 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640 900 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2034 888 c3 -13 6 -29 6 -35 0 -7 7 -13 15 -13 l14 0 -5 15 -6 15 16 0 c9 0 16 5 16 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -5 10 -11 10 l-11 0 6 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 881 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 874 l0 -15 11 7 c6 3 15 0 20 -7 10 -17 23 -5 16 16 -4 8 -16 15 -27 15 l-20 0 0 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175 858 l-7 -23 -5 18 c-2 9 -9 17 -14 17 -16 0 -10 -18 17 -47 15 -15 25 -21 22 -13 -3 8 -1 23 4 34 l10 18 -10 10 -9 9 -8 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410 870 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360 860 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670 860 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2240 861 c0 -5 6 -11 13 -14 l12 -4 -14 -16 -14 -17 -12 16 -12 17 0 -16 c0 -20 22 -29 53 -21 25 6 31 23 14 40 l-11 11 23 -3 c13 -1 26 -3 31 -3 4 -1 7 -30 7 -66 l0 -65 10 0 10 0 0 75 0 75 -55 0 c-30 0 -55 -4 -55 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633 853 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 l-30 0 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753 853 c20 -2 54 -2 75 0 20 2 3 4 -38 4 -41 0 -58 -2 -37 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048 853 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100 844 l0 -15 10 6 c6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2000 850 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2103 845 l0 -16 14 6 c8 3 21 5 29 5 8 0 14 5 14 10 0 6 -13 10 -28 10 l-29 0 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2740 846 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988 843 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 835 c0 -8 7 -15 15 -15 l14 0 -5 15 c-4 8 -10 15 -15 15 -5 0 -9 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301 829 c6 -12 7 -19 2 -16 l-9 6 0 -35 0 -34 13 0 13 0 0 50 0 50 -15 0 -16 0 12 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430 818 l0 -32 12 12 12 12 11 -10 11 -9 0 18 0 19 -15 -6 -14 -5 6 16 6 17 -14 0 -15 0 0 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 824 c0 -9 5 -14 12 -12 18 6 21 28 4 28 -9 0 -16 -7 -16 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220 830 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 831 c0 -17 18 -21 24 -6 l5 15 -14 0 c-8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2073 833 c-18 -7 -16 -23 2 -23 8 0 15 7 15 15 0 8 -1 15 -2 14 -2 0 -9 -3 -15 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2173 825 c0 -18 19 -15 25 3 2 7 -3 12 -10 12 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 823 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410 820 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 813 c-7 -2 -13 -11 -13 -19 l0 -13 18 6 c9 3 26 12 37 20 l19 13 -24 -1 c-14 0 -31 -3 -37 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 800 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360 810 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627 803 c-4 -3 -7 -24 -7 -46 0 -52 13 -40 14 13 1 22 1 40 0 40 0 0 -4 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 801 c0 -6 5 -13 10 -16 l10 -6 0 15 c0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 790 c3 -5 13 -10 21 -10 8 0 14 5 14 10 0 6 -9 10 -21 10 l-20 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 790 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915 790 l-20 -8 18 -7 c20 -8 47 0 47 15 0 12 -17 12 -45 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2084 789 c-3 -5 -9 -7 -13 -5 -4 3 -8 -4 -8 -15 l-2 -21 12 10 c7 5 20 12 30 15 l18 7 -6 -10 c-3 -6 -13 -10 -20 -10 -20 0 -29 -43 -18 -77 l10 -28 24 -3 24 -3 -17 14 c-10 8 -15 17 -11 20 3 4 1 7 -6 7 l-13 0 5 20 5 20 -9 -6 c-5 -3 -9 -3 -9 1 0 3 11 10 25 15 l25 10 0 19 0 19 -20 5 c-11 3 -23 1 -26 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190 789 c0 -5 -5 -7 -11 -3 l-11 6 4 -23 c1 -12 9 -24 16 -27 l12 -4 0 16 c0 9 5 16 10 16 6 0 10 7 10 15 0 8 -7 15 -15 15 -8 0 -15 -5 -15 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2706 785 l-5 -15 12 -1 c7 0 20 -2 30 -4 l17 -3 0 15 0 15 -17 -13 -17 -14 7 18 6 17 -13 0 c-8 0 -16 -7 -20 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798 783 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056 775 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0 -6 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150 781 c0 -5 7 -14 15 -21 16 -14 18 -10 9 14 -6 17 -24 22 -24 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251 774 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 780 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2244 760 l2 -30 -23 0 c-45 0 -22 -25 32 -36 l21 -4 1 20 c1 10 -5 24 -13 31 -16 13 -19 34 -4 24 l10 -6 0 15 c0 9 -6 16 -14 16 l-14 0 2 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 770 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008 773 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610 759 c0 -5 11 -9 25 -9 14 0 25 2 25 4 0 2 -11 6 -25 8 -14 3 -25 1 -25 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678 763 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 755 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020 760 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790 750 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0 -20 -4 -20 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2687 754 c-4 -4 3 -14 14 -22 l21 -14 16 16 16 16 -16 0 c-9 0 -23 2 -30 5 -8 3 -17 3 -21 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120 740 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 736 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 721 c0 -12 5 -21 10 -21 6 0 10 6 10 14 0 8 -4 18 -10 21 l-10 6 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241 724 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 725 l0 -16 23 3 c12 2 22 8 22 13 0 6 -10 11 -22 13 l-23 3 0 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143 716 l6 -16 -9 0 c-6 0 -10 -7 -10 -15 l0 -15 20 12 c23 14 23 39 1 46 l-14 5 6 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 716 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2605 719 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2680 711 l0 -20 18 -4 17 -5 -17 -1 c-10 0 -18 -8 -18 -16 l0 -15 28 12 c15 7 29 13 31 14 3 3 -49 54 -55 54 -2 0 -4 -9 -4 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 705 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410 710 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2392 704 c2 -9 13 -20 26 -25 l22 -8 0 14 c0 8 -7 15 -15 15 -8 0 -15 5 -15 10 0 6 -5 10 -11 10 -6 0 -9 -7 -7 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 691 c0 -12 5 -21 10 -21 6 0 10 6 10 14 0 8 -4 18 -10 21 l-10 6 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111 694 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708 703 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540 681 c-5 -11 -10 -22 -10 -25 0 -10 129 -6 135 4 l6 10 -41 0 -41 0 5 9 c6 8 -15 21 -34 21 -5 0 -14 -9 -20 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290 691 c0 -5 7 -11 15 -15 8 -3 15 -1 15 3 0 5 -7 11 -15 15 -8 3 -15 1 -15 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2537 668 c-16 -16 -26 -32 -23 -35 9 -9 46 8 46 22 0 7 4 15 10 17 5 2 6 8 2 15 l-7 12 -28 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 680 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683 683 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040 666 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2160 670 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2232 668 c3 -7 13 -15 22 -16 l18 -4 -4 14 c-3 7 -13 15 -22 16 l-18 4 4 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 656 c0 -8 5 -18 10 -21 6 -3 10 1 10 9 0 8 -4 18 -10 21 -5 3 -10 -1 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2370 655 c0 -6 7 -12 15 -12 8 0 15 6 15 12 0 6 -7 12 -15 12 -8 0 -15 -6 -15 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 645 c0 -8 7 -15 15 -15 8 0 15 4 15 9 0 5 -7 11 -15 15 l-15 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151 634 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730 640 c8 -5 25 -10 38 -10 l23 0 -6 10 c-3 6 -21 10 -38 10 l-32 0 15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1903 643 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974 639 l-7 -12 16 6 17 6 0 -13 0 -14 20 5 c23 6 27 23 6 23 -8 0 -21 3 -29 6 -8 3 -18 0 -23 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366 625 l6 -15 24 0 24 0 0 15 0 15 -30 0 -29 0 5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540 630 c0 -5 14 -10 31 -10 l30 0 -6 10 c-3 6 -17 10 -31 10 -13 0 -24 -4 -24 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 630 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753 613 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2138 613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2228 613 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056 595 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0 -6 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 584 l0 -25 10 6 c6 3 10 15 10 26 0 10 -4 19 -10 19 -5 0 -10 -12 -10 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 600 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1573 603 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 l-30 0 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393 593 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 l-30 0 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050 590 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2175 590 c3 -5 19 -10 36 -10 16 0 29 5 29 10 0 6 -16 10 -36 10 l-35 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2198 563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063 545 l0 -13 14 5 c7 3 13 6 13 8 0 2 -6 5 -13 8 l-14 5 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979 533 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2060 536 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 540 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 530 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282 502 c-6 -2 -12 -8 -12 -13 0 -6 4 -8 9 -5 5 4 11 0 14 -6 l5 -13 10 10 10 10 -12 11 c-6 6 -17 9 -24 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 490 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413 493 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050 468 c0 -4 7 -8 15 -8 8 0 15 4 15 8 0 5 -7 9 -15 9 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058 253 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2194 170 c0 -52 1 -74 3 -47 2 26 2 68 0 95 -2 26 -3 4 -3 -48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2224 170 c0 -52 1 -74 3 -47 2 26 2 68 0 95 -2 26 -3 4 -3 -48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2264 160 c0 -58 1 -81 3 -53 2 29 2 77 0 106 -2 28 -3 5 -3 -53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2314 145 c0 -66 1 -92 3 -57 2 34 2 88 0 120 -2 31 -3 3 -3 -63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2378 253 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1873 145 c0 -44 2 -61 4 -37 2 23 2 59 0 80 -2 20 -4 1 -4 -43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310 200 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381 194 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2382 190 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 175 c4 -8 9 -15 13 -15 4 0 8 7 8 15 0 8 -6 15 -13 15 l-13 0 5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726 148 l1 -41 17 -3 16 -2 0 14 0 15 -11 -7 -12 -7 5 37 4 36 -11 0 -10 0 1 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2748 154 l5 -37 -12 7 -11 7 0 -15 0 -14 16 2 17 3 1 41 1 42 -10 0 -11 0 4 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 169 c0 -5 9 -9 20 -9 11 0 20 2 20 4 0 2 -9 6 -20 9 -11 3 -20 1 -20 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1658 163 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 146 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2665 123 c3 -8 5 -17 5 -19 0 -2 7 -4 15 -4 8 0 15 5 15 10 0 6 -5 10 -11 10 -5 0 -8 4 -5 8 3 5 -2 9 -10 9 l-15 0 6 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 121 c0 -5 9 -7 20 -4 11 3 20 7 20 9 0 2 -9 4 -20 4 -11 0 -20 -4 -20 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1658 123 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 108 c0 -4 11 -8 25 -8 14 0 25 4 25 10 0 5 -11 9 -25 8 -14 -1 -25 -6 -25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 90 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1401 84 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 72 c0 -4 9 -8 19 -8 11 0 17 4 15 8 -3 4 -12 8 -20 8 -8 0 -14 -4 -14 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2150 70 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096 55 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0 -6 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 56 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2409 43 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320 40 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#fbdeeb",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1875 2669 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1978 2645 c2 -14 6 -25 8 -25 2 0 4 11 4 25 0 14 -4 25 -9 25 -4 0 -6 -11 -3 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890 2616 c0 -2 7 -9 15 -16 l15 -12 0 10 c0 5 -7 12 -15 16 -8 3 -15 4 -15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944 2538 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 2349 l-24 -20 22 10 c12 6 25 16 28 21 10 16 -1 12 -26 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2061 2354 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756 2311 l-5 -8 24 5 c14 2 25 6 25 8 0 8 -39 4 -44 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 2289 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 2230 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764 2225 l-1 -36 9 13 c10 16 10 58 1 58 -5 0 -8 -16 -9 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 2235 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 2230 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485 2230 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645 2230 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1956 2224 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2101 2224 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 2203 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 2188 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350 2145 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 2140 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 2138 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436 2134 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 2140 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1900 2139 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1945 2139 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1978 2143 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 2126 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 2110 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1721 2084 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2018 2083 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396 2063 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 2063 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 2042 c0 -5 7 -9 15 -9 8 0 12 4 9 9 -3 4 -9 8 -15 8 -5 0 -9 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 2033 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 2025 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220 2020 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 2020 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764 2008 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 1985 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436 1984 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698 1993 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 1970 c3 -11 7 -20 9 -20 2 0 4 9 4 20 0 11 -4 20 -9 20 -5 0 -7 -9 -4 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 1953 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266 1944 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471 1944 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 1943 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 1924 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1914 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1550 1920 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 1900 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 1900 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 1885 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147 1889 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 1885 c-14 -8 -20 -14 -14 -15 5 0 19 7 30 15 24 18 16 19 -16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 1864 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840 1860 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926 1854 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 1834 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729 1828 l-12 -23 16 13 c9 8 21 11 26 7 l11 -6 -6 15 c-9 22 -21 20 -35 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274 1818 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 1795 c4 -8 11 -15 16 -15 l10 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -1 -7 2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797 1799 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 1790 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 1784 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350 1785 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644 1748 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 1733 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483 1728 c-6 -7 -14 -19 -18 -27 l-8 -14 11 7 c12 7 36 46 29 46 -3 0 -9 -6 -14 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 1664 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 1610 c0 -41 2 -58 4 -37 2 20 2 54 0 75 -2 20 -4 3 -4 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 1653 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310 1635 c0 -16 16 -20 24 -6 3 5 -1 11 -9 15 l-15 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 1640 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2365 1630 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2285 1611 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2467 1613 c-4 -3 -7 -10 -7 -15 0 -14 53 -5 58 10 l4 12 -24 0 c-14 0 -28 -3 -31 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1686 1581 c-8 -12 3 -41 15 -41 5 0 9 4 9 9 0 5 3 16 6 25 l6 16 -15 0 c-9 0 -18 -4 -21 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2320 1579 c0 -4 7 -9 15 -13 l15 -5 0 13 c0 7 -7 13 -15 13 -8 0 -15 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 1574 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2647 1584 c-9 -10 4 -34 18 -34 l14 0 -2 20 c-1 19 -17 27 -30 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2363 1565 c0 -8 4 -12 8 -10 4 3 9 -2 13 -10 6 -17 26 -20 26 -4 0 5 -4 7 -10 4 l-10 -6 0 20 0 21 -13 0 c-8 0 -14 -7 -14 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783 1553 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2455 1550 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 1518 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526 1521 c-3 -5 1 -12 9 -15 l15 -6 -12 -19 c-7 -11 -16 -17 -20 -15 -4 3 -8 0 -8 -6 l0 -12 16 6 c9 3 20 6 25 6 6 0 8 4 5 9 -4 5 0 12 6 15 l13 5 -18 11 c-9 6 -15 15 -12 21 4 5 2 9 -4 9 -5 0 -12 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855 1520 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2255 1520 c3 -5 12 -7 20 -3 21 7 19 13 -6 13 l-20 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2320 1526 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 1520 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646 1513 c-3 -3 3 -18 13 -32 11 -15 21 -35 23 -46 1 -11 14 -26 27 -32 28 -16 31 -16 31 -3 0 6 -7 10 -15 10 -16 0 -24 13 -30 47 -1 10 -8 17 -15 15 l-11 -2 6 10 c7 11 -19 42 -29 33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2365 1510 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1813 1473 c0 -10 5 -21 11 -25 14 -10 41 -10 32 0 -4 4 -13 7 -19 7 -7 0 -12 5 -12 12 0 6 -3 14 -6 17 -3 3 -6 -2 -6 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1915 1480 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 1480 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2550 1474 l0 -15 10 6 c6 3 10 1 10 -6 0 -16 13 -3 16 16 l2 15 -19 0 -19 0 0 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 1475 c0 -12 33 -55 41 -55 18 0 8 28 -12 33 l-21 6 7 10 c3 6 1 11 -4 11 -6 0 -11 -2 -11 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2605 1460 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670 1461 l-35 -7 36 -5 36 -5 0 13 c0 7 -1 12 -1 12 -1 -1 -17 -5 -36 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360 1435 l-12 -15 10 0 c12 0 26 19 19 26 -2 2 -10 -2 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005 1440 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1453 1432 c-6 -4 -14 -19 -18 -33 l-6 -26 30 5 c17 2 31 8 31 13 0 5 -3 8 -7 8 -5 -1 -13 -1 -20 0 l-12 1 5 15 c4 8 10 13 14 10 5 -3 11 -1 15 5 7 12 -14 13 -32 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560 1424 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2046 1425 l-5 -15 15 0 c8 0 12 -4 9 -10 -3 -5 -1 -10 4 -10 15 0 13 11 -3 33 l-14 18 -6 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2385 1431 c-11 -5 -26 -6 -32 -4 -7 3 -13 0 -13 -6 0 -6 11 -11 24 -11 l24 0 6 -16 c4 -9 5 -18 4 -19 -2 -1 -16 -5 -31 -9 l-29 -7 7 22 7 22 -11 -7 c-12 -8 -15 -56 -3 -55 4 0 16 4 27 8 l20 9 13 -10 12 -10 1 13 c1 8 3 31 4 52 2 20 1 37 -3 36 -4 0 -16 -4 -27 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1801 1414 c13 -16 29 -19 29 -5 0 5 -9 11 -21 14 l-20 5 12 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2573 1415 l-13 -14 11 -6 c11 -7 39 12 39 26 0 14 -24 10 -37 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615 1410 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850 1407 c0 -8 6 -14 13 -14 8 0 14 6 14 14 0 7 -6 13 -14 13 -7 0 -13 -6 -13 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895 1410 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2610 1400 c-6 -11 -7 -20 -2 -20 10 0 32 21 32 32 0 16 -19 8 -30 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285 1400 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595 1400 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2490 1385 c0 -14 4 -25 10 -25 5 0 7 7 4 15 l-6 15 11 0 c6 0 11 5 11 10 0 6 -7 10 -15 10 l-15 0 0 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2690 1401 c0 -5 8 -19 18 -31 l19 -23 13 8 13 8 -21 8 -22 8 6 16 6 15 -16 0 c-9 0 -16 -4 -16 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2840 1400 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767 1393 c-10 -9 -9 -23 2 -23 5 0 11 7 15 15 5 15 -5 20 -17 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2970 1390 c20 -13 40 -13 40 0 0 6 -12 10 -27 10 l-28 0 15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635 1380 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2860 1380 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245 1370 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2125 1370 c-3 -5 1 -13 10 -16 22 -9 29 1 11 15 l-14 12 -7 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517 1364 c-7 -7 2 -34 12 -34 4 0 7 9 8 20 2 19 -8 26 -20 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1980 1362 c0 -5 7 -9 15 -9 8 0 15 4 15 9 0 4 -7 8 -15 8 -8 0 -15 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2567 1363 c-11 -11 -8 -23 6 -23 8 0 14 7 14 15 0 16 -9 19 -20 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1666 1345 l-6 -16 -12 7 -13 7 12 -13 11 -12 16 9 15 8 -8 13 -8 14 -7 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2806 1349 c2 -4 0 -10 -5 -13 -12 -7 -2 -46 11 -46 6 0 8 7 5 15 -4 8 -2 17 3 20 15 9 12 32 -5 32 -8 0 -12 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191 1337 c-15 -19 -7 -24 29 -19 l31 4 -12 14 -12 14 -15 -12 -16 -13 8 13 c10 16 1 15 -13 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372 1335 l-24 -13 10 -6 c15 -9 42 4 42 20 0 8 -1 14 -2 13 -2 -1 -14 -7 -26 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1863 1335 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9 -1 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2426 1323 c9 -36 12 -39 27 -24 l12 14 -12 4 c-7 3 -13 11 -13 19 0 8 -5 14 -10 14 l-10 0 6 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2650 1334 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2750 1335 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2944 1333 c-4 -10 -8 -22 -8 -26 -1 -4 -8 -12 -16 -17 -8 -5 -12 -11 -9 -14 3 -3 15 3 26 14 l22 19 5 -12 4 -12 11 15 c12 17 4 33 -12 23 l-12 -7 14 17 13 17 -15 0 c-8 0 -18 -8 -23 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3006 1338 c3 -4 9 -8 15 -8 5 0 9 4 9 8 0 5 -7 9 -15 9 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602 1329 c2 -7 10 -15 17 -17 l14 -4 -5 13 c-2 7 -10 15 -17 17 l-13 5 4 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805 1330 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 1330 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 1315 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2593 1315 c0 -8 4 -15 9 -15 4 0 8 -6 8 -13 0 -8 7 -14 15 -14 8 0 15 7 15 14 0 8 -4 12 -9 9 -5 -3 -11 3 -14 14 -6 23 -24 27 -24 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700 1320 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2843 1307 c3 -7 10 -11 17 -9 l13 3 -13 -15 -12 -16 10 0 c9 0 22 22 22 39 0 4 -9 7 -21 8 l-20 2 4 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 1295 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265 1300 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 1291 l0 -21 -24 15 -24 16 -5 -16 c-4 -8 -16 -15 -27 -15 -11 0 -20 -4 -20 -10 0 -5 5 -10 10 -10 6 0 10 -7 10 -16 l0 -15 10 6 c6 4 8 10 5 15 -3 4 6 15 20 24 l25 16 0 -14 0 -14 20 5 20 5 -3 19 c-5 28 -17 36 -17 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2523 1296 l6 -14 -21 6 -21 5 5 -14 c2 -8 14 -15 26 -17 l22 -3 0 25 c0 14 -5 26 -11 26 -6 0 -9 -6 -6 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2656 1294 l-6 -16 12 4 c15 5 23 28 10 28 -5 0 -13 -7 -16 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 1290 c0 -5 5 -10 12 -10 6 0 20 -7 30 -17 10 -9 18 -12 18 -7 0 12 -37 44 -50 44 -6 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700 1290 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570 1278 c0 -4 7 -8 15 -8 8 0 15 4 15 8 0 5 -7 9 -15 9 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635 1280 c-3 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -5 l0 -12 25 6 25 6 0 -10 c0 -5 4 -10 9 -10 5 0 8 8 7 18 -3 20 -31 28 -41 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964 1274 l6 -15 -10 6 c-6 3 -10 2 -10 -2 0 -5 -10 -13 -22 -18 -12 -6 -23 -16 -26 -22 l-4 -13 17 0 17 0 -6 16 -6 15 9 -6 c5 -3 12 -1 16 5 8 13 35 13 35 0 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -9 0 -15 39 -9 45 6 l5 13 27 -6 28 -7 -11 12 c-6 7 -21 13 -33 14 -23 1 -26 8 -11 23 l10 10 -21 1 -21 2 6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 1278 c0 -11 22 -10 40 2 l15 10 -27 -2 c-16 -1 -28 -6 -28 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130 1274 c0 -17 22 -14 28 4 2 7 -3 12 -12 12 -9 0 -16 -7 -16 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2300 1280 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695 1269 c7 -11 35 -12 35 -1 0 4 -9 8 -20 9 l-20 2 5 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845 1270 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2737 1265 c-4 -8 -2 -17 3 -20 l10 -6 -9 -18 -10 -18 14 0 15 0 -4 23 c-3 13 0 24 7 27 l11 3 -8 12 c-10 16 -23 15 -29 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 1244 l0 -26 16 13 16 13 -11 4 c-6 2 -9 8 -5 13 3 5 0 9 -5 9 -6 0 -11 -12 -11 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235 1260 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 1262 c0 -4 9 -8 20 -9 11 -1 20 2 20 8 0 5 -9 9 -20 9 -11 0 -20 -4 -20 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1590 1240 c0 -5 5 -10 10 -10 l10 0 -4 -25 -5 -25 20 0 c24 0 25 17 2 24 -10 3 -2 4 17 2 37 -4 60 1 60 13 0 3 -19 6 -42 6 l-41 0 -5 13 c-4 14 -22 16 -22 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2084 1239 l-7 -12 18 7 18 6 18 -16 17 -16 -2 19 -3 18 -25 3 c-15 2 -30 -2 -34 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2355 1240 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2970 1235 c0 -8 7 -15 16 -15 l16 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -4 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344 1224 l6 -15 -10 6 -10 6 0 -21 0 -22 16 6 15 6 -6 -10 c-9 -14 9 -12 23 2 16 16 15 29 0 26 l-13 -3 1 18 2 17 -15 0 -15 0 6 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2173 1233 l8 -12 -21 -11 c-11 -6 -25 -8 -30 -5 -5 3 -11 1 -15 -5 -3 -5 -2 -10 4 -10 6 0 8 -7 5 -15 l-6 -15 18 0 c9 0 15 3 12 6 -7 6 23 39 42 46 l12 4 -18 14 -18 15 7 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2520 1231 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2810 1230 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 1220 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097 1217 c-8 -21 2 -27 28 -16 l20 8 -17 0 c-9 1 -18 6 -20 13 l-4 12 -7 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540 1220 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 1219 c0 -5 9 -9 20 -9 l20 0 0 -20 0 -20 18 1 17 1 -13 5 c-6 2 -9 9 -6 14 l6 10 14 -12 c8 -6 14 -8 14 -3 0 16 -15 31 -30 32 -8 0 -25 3 -37 6 -13 2 -23 1 -23 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213 1213 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 l-30 0 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496 1204 c-8 -20 -8 -24 2 -24 4 0 13 9 20 20 l12 20 -14 0 c-8 0 -17 -7 -20 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713 1207 c2 -6 12 -11 22 -9 l17 3 -7 -10 -6 -11 15 0 c27 0 18 17 -15 29 l-30 10 4 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2923 1201 l12 -15 -12 8 -13 7 0 -16 c0 -9 9 -19 20 -22 11 -3 20 -12 20 -19 0 -8 5 -14 10 -14 13 0 13 3 -5 48 l-16 39 -14 0 -15 0 13 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268 1203 c-31 -8 -19 -23 17 -23 36 0 47 13 19 24 -9 3 -16 5 -17 5 -1 -1 -10 -3 -19 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930 1200 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503 1203 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984 1192 c6 -9 -29 -42 -44 -42 -6 0 -10 -4 -10 -10 0 -15 14 -12 37 9 12 11 24 17 27 14 3 -4 6 3 6 15 0 12 -5 22 -11 22 -5 0 -8 -4 -5 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 1188 c0 -4 8 -8 18 -9 9 0 25 -2 35 -4 9 -2 17 1 17 6 0 5 -3 9 -7 10 -42 4 -63 3 -63 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680 1190 c-8 -5 -18 -6 -22 -4 -4 3 -8 0 -8 -5 0 -6 6 -11 13 -11 16 0 43 18 36 24 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895 1190 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2254 1185 c3 -8 1 -15 -4 -15 -19 0 -10 -17 15 -28 l25 -12 0 16 0 15 -10 -6 c-5 -3 -10 -1 -10 4 0 6 5 11 11 11 l11 0 -12 15 c-7 8 -17 15 -22 15 -6 0 -8 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436 1178 c3 -4 9 -8 15 -8 5 0 9 4 9 8 0 5 -7 9 -15 9 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2167 1184 c-13 -13 -7 -20 19 -22 l26 -2 -5 13 c-4 14 -30 21 -40 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 1185 c0 -3 12 -10 26 -15 l25 -10 -6 -10 -6 -10 23 -1 23 0 -22 -11 c-13 -6 -23 -16 -23 -21 0 -6 3 -7 7 -4 3 4 13 1 21 -6 l16 -12 -7 12 c-4 6 -3 14 3 18 5 3 10 18 10 33 l0 26 -11 -11 -11 -11 -21 19 c-19 18 -47 26 -47 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2783 1174 c0 -14 29 -12 34 2 2 5 -5 10 -15 10 -10 0 -19 -6 -19 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070 1165 c0 -16 16 -20 24 -6 3 5 -1 11 -9 15 l-15 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2825 1157 l-20 -20 20 10 c11 6 27 12 34 15 l15 4 -15 6 -14 5 -20 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088 1160 c-3 -8 0 -21 8 -27 l13 -13 6 10 c3 5 12 7 19 4 8 -3 17 0 22 7 l7 12 -31 -6 -31 -6 -3 17 -4 17 -6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368 1152 l-28 -3 0 -70 c0 -38 4 -69 9 -69 4 0 7 14 5 30 l-4 30 18 0 17 1 -17 10 c-23 13 -23 29 -1 29 l17 0 -20 15 -19 16 68 -3 c37 -2 67 0 67 3 0 8 -74 15 -112 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253 1143 l47 -4 -2 -45 -1 -44 -19 0 -19 0 6 -11 c4 -6 13 -8 20 -5 l14 5 4 -17 c3 -9 5 13 6 50 l1 66 13 5 c6 3 -17 5 -53 4 l-65 -1 48 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 1140 l0 -10 53 1 c28 1 63 5 77 9 l25 8 -77 1 -78 1 0 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1852 1133 l-2 -23 -25 0 c-14 0 -25 -5 -25 -11 l0 -11 25 6 25 6 0 -29 0 -30 -17 -10 -18 -10 18 -1 c9 0 17 -6 17 -14 l0 -14 -55 5 -55 5 0 -10 c0 -5 8 -9 18 -9 9 0 33 -1 52 -2 l36 -1 2 -35 3 -35 -12 0 -11 0 10 -12 c6 -7 9 -34 9 -61 -2 -48 8 -65 14 -24 2 12 2 94 -1 182 -3 88 -7 150 -8 138z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2133 1143 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2386 1134 l-6 -15 9 6 c5 3 11 -1 14 -7 l5 -13 13 13 14 13 -15 9 c-21 13 -27 12 -34 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2740 1134 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2903 1124 c0 -8 6 -14 14 -14 7 0 13 4 13 9 0 5 -6 11 -13 14 l-14 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3010 1124 l0 -16 -15 6 c-8 3 -15 1 -15 -3 0 -5 8 -12 17 -15 l16 -7 8 12 c4 7 5 18 2 26 -7 18 -13 16 -13 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 1123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2674 1114 c3 -9 6 -18 6 -21 0 -3 6 0 14 6 l14 12 8 -12 7 -12 -10 6 c-6 4 -14 0 -17 -9 -9 -22 -8 -24 10 -24 l15 0 -6 10 c-3 6 -1 10 4 10 6 0 11 9 11 19 0 19 -18 31 -47 31 l-15 0 6 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2815 1115 c-3 -8 -7 -22 -10 -31 l-5 -15 9 6 c6 3 14 -3 20 -12 l9 -18 9 8 8 9 -18 9 c-9 6 -17 15 -17 20 0 6 5 7 10 4 l10 -6 0 20 c0 24 -18 28 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181 1111 c-8 -5 -21 -7 -30 -4 l-16 6 13 -14 12 -13 0 -51 0 -51 -20 -1 c-11 -1 -20 2 -20 8 0 5 -7 9 -15 9 -8 0 -15 -4 -15 -10 0 -6 5 -9 11 -7 6 1 14 -4 17 -12 l5 -14 -10 6 c-5 3 -10 0 -10 -8 l0 -15 18 16 17 15 7 -10 c9 -16 22 -13 29 7 3 9 9 24 12 32 l6 15 -10 -13 -9 -14 0 51 0 51 16 12 16 13 -14 -17 -13 -18 10 0 c14 0 33 25 25 33 -8 9 -15 9 -32 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456 1111 c-3 -5 1 -11 9 -15 8 -3 15 -1 15 4 0 13 -18 22 -24 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2304 1109 c-3 -6 -6 -57 -5 -114 l2 -104 -23 -3 -23 -4 48 -5 47 -4 -4 10 c-2 5 -11 9 -20 9 l-16 -2 0 102 0 102 12 12 12 12 -11 0 c-7 0 -15 -5 -19 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980 1097 c0 -8 6 -14 13 -14 8 0 14 6 14 14 0 7 -6 13 -14 13 -7 0 -13 -6 -13 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 1100 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220 1001 l0 -102 -10 6 c-5 3 -10 1 -10 -5 0 -6 7 -10 16 -8 l16 3 0 99 c-1 54 -3 101 -6 104 -3 3 -6 -41 -6 -97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905 1080 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 1081 c0 -5 7 -11 14 -14 l15 -6 -6 15 c-6 15 -23 19 -23 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120 1080 c0 -5 -8 -10 -17 -10 l-17 0 11 -11 11 -11 23 21 23 21 -17 0 c-9 0 -17 -4 -17 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2471 1054 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2505 1050 l6 -20 -15 0 c-9 0 -16 -5 -16 -11 l0 -11 16 6 c9 3 20 6 25 6 5 0 8 11 7 25 l-2 25 -14 0 -13 0 6 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1931 1025 c-2 -22 -3 -43 -3 -46 1 -4 2 -35 3 -69 1 -34 5 -56 9 -50 l8 12 4 -13 c10 -27 13 -3 7 46 l-6 50 -3 -40 -4 -40 -6 95 -6 95 -3 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2168 1053 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2790 1045 c0 -8 5 -15 11 -15 l11 0 -16 -25 c-19 -29 -20 -35 -5 -35 5 0 8 4 4 9 -3 5 0 13 6 17 6 3 15 1 19 -6 l8 -12 7 12 7 11 -16 18 c-9 10 -16 23 -16 29 0 7 -4 12 -10 12 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1036 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 1032 c0 -5 14 -7 30 -4 17 2 30 6 30 8 0 2 -13 4 -30 4 -16 0 -30 -4 -30 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2333 990 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 982 c0 -23 3 -42 8 -42 9 0 8 68 -2 77 -3 3 -6 -12 -6 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235 997 c-5 -7 -11 -19 -13 -26 l-2 -12 24 18 c14 10 26 21 26 26 0 11 -24 7 -35 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965 983 c3 -8 5 -17 5 -19 0 -2 7 -4 16 -4 l16 0 -11 13 c-6 8 -9 16 -6 19 3 2 -2 5 -10 5 l-16 0 6 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2463 965 l0 -35 13 11 14 11 -12 22 c-6 11 -12 22 -13 24 -1 1 -2 -14 -2 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 979 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274 979 c-7 -12 -1 -90 7 -95 4 -2 7 15 7 38 l0 42 11 4 c6 2 11 7 11 11 0 10 -30 10 -36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375 980 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 971 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 960 c-8 -5 -12 -11 -9 -14 7 -8 49 5 49 15 0 12 -21 11 -40 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240 961 c0 -6 5 -13 10 -16 l10 -6 0 15 c0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785 960 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 960 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1983 950 c-1 -11 2 -20 6 -20 5 0 11 9 14 20 l5 20 -12 0 c-6 0 -12 -9 -13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298 943 c-5 -26 3 -63 14 -63 l9 0 -7 38 c-8 45 -11 49 -16 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2201 944 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640 940 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 932 c0 -14 11 -21 26 -15 8 3 11 9 8 14 -7 11 -34 12 -34 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726 931 l-20 -8 11 -6 c7 -4 14 -3 18 3 4 6 11 8 16 5 5 -4 9 -1 9 4 0 12 -7 13 -34 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 930 l-14 -9 8 -8 9 -8 4 13 c3 6 10 9 15 6 l11 -7 -7 11 c-9 14 -7 14 -26 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339 782 c-2 -89 -1 -162 4 -162 7 0 8 15 8 142 l0 78 16 8 16 9 -12 7 c-6 4 -12 4 -13 -1 0 -4 -4 12 -8 37 l-6 45 -5 -163z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404 928 l-7 -11 14 5 c8 3 26 2 41 -3 l27 -7 4 11 4 12 -38 2 c-22 0 -42 -4 -45 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778 933 c-10 -2 -18 -9 -18 -14 0 -12 17 -11 25 1 l7 11 21 -6 22 -6 -15 10 c-8 6 -17 10 -20 10 -3 -1 -13 -3 -22 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2491 926 l-11 -13 15 -13 15 -12 0 26 c0 14 -2 26 -4 26 -2 0 -9 -6 -15 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2793 899 l-1 -41 8 8 c14 15 16 74 3 74 -5 0 -9 -19 -10 -41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 918 c0 -4 7 -8 15 -8 8 0 15 4 15 8 0 5 -7 9 -15 9 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735 920 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 906 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680 916 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2766 911 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176 890 c-10 -11 -23 -17 -27 -14 -5 3 -9 -3 -9 -12 l0 -18 12 12 c16 16 28 15 28 -3 0 -8 5 -15 10 -15 l10 0 -6 25 -6 25 11 0 c6 0 11 5 11 10 0 15 -13 11 -34 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640 900 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 888 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790 890 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114 878 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040 872 l0 -14 16 6 c9 3 23 6 31 6 26 0 5 13 -22 15 l-25 1 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 873 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410 868 c0 -11 12 -10 30 2 l15 9 -23 -2 c-12 0 -22 -5 -22 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 863 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 858 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305 840 c4 -17 3 -30 -2 -29 -4 1 -16 1 -25 0 l-17 -1 6 -17 7 -17 4 12 c2 7 11 12 19 12 l15 0 -5 -32 c-3 -18 -2 -42 3 -53 l9 -20 0 88 1 87 -11 0 -11 0 7 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2227 859 l11 -11 19 11 18 10 -29 1 -30 0 11 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 856 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033 853 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 850 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2006 851 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 852 c0 -4 19 -8 42 -10 23 -1 39 0 35 4 -9 9 -77 15 -77 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2332 835 l0 -30 5 18 c2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2045 840 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2747 843 c-12 -12 -7 -43 7 -43 l14 0 -2 25 c-1 25 -7 31 -19 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406 825 c7 -17 20 -20 29 -5 9 15 48 12 71 -5 21 -16 34 -19 34 -7 0 13 -63 32 -103 32 l-36 0 5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145 830 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430 825 c0 -8 7 -15 16 -15 l16 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -4 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 820 c19 -13 30 -13 30 0 0 6 -10 10 -22 10 l-23 0 15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 820 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405 820 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430 820 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775 820 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2110 821 c0 -6 5 -13 10 -16 l10 -6 0 15 c0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2193 814 c0 -8 6 -14 14 -14 7 0 13 4 13 9 0 5 -6 11 -13 14 l-14 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250 816 c0 -9 7 -16 16 -16 9 0 14 5 12 12 -6 18 -28 21 -28 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093 800 c1 -11 5 -20 9 -20 3 0 6 9 5 20 -1 11 -5 20 -9 20 -3 0 -6 -9 -5 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640 810 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930 800 l0 -19 15 5 15 6 0 -17 0 -17 -14 5 -14 6 -1 -75 -1 -74 11 0 c5 0 8 4 5 9 l-6 9 37 -5 c21 -2 51 -5 68 -5 l30 -1 12 -16 c6 -9 15 -13 19 -8 4 4 2 7 -4 7 -17 0 -15 37 3 44 8 3 15 15 15 26 l0 20 -25 0 c-14 0 -25 -3 -25 -6 0 -3 5 -14 10 -25 l11 -19 -15 0 c-8 0 -16 6 -18 12 l-5 13 -11 -22 -12 -22 -15 5 c-8 4 -15 15 -15 25 0 10 -4 19 -10 19 -5 0 -10 -10 -10 -22 l-1 -23 -10 18 -10 17 -11 -6 -11 -7 9 14 c11 18 14 39 5 39 -4 0 -7 9 -8 20 l-2 20 12 -3 c7 -1 16 -11 21 -22 l8 -20 5 13 c3 7 0 19 -7 27 l-12 14 7 20 6 20 -20 10 c-27 15 -31 14 -31 -9z m180 -124 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 800 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 790 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 788 c0 -4 4 -8 9 -8 6 0 12 4 15 8 3 5 -1 9 -9 9 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 790 c0 -6 6 -10 14 -10 8 0 21 -3 29 -6 l14 -5 6 14 5 14 -34 1 c-19 1 -34 -3 -34 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 790 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 780 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783 783 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2077 776 l-6 -14 20 5 c10 3 16 9 13 14 -8 13 -21 11 -27 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340 759 l0 -31 -20 -5 c-11 -3 -20 -10 -20 -15 0 -5 -4 -7 -9 -3 -5 3 -12 1 -15 -4 -4 -5 -1 -13 5 -17 l12 -7 9 16 c5 9 14 14 22 11 l13 -5 1 -38 2 -39 -15 -12 -14 -12 -13 8 -13 7 11 -13 12 -12 21 7 21 6 0 95 c0 52 -2 94 -5 94 -3 0 -5 -14 -5 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 768 c5 -15 28 -23 28 -10 0 5 -7 13 -16 16 l-16 6 4 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978 773 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 768 c0 -4 14 -8 30 -8 17 0 30 -5 30 -11 0 -5 4 -8 9 -5 5 4 12 0 14 -6 3 -7 6 -2 6 12 l1 25 -45 1 c-25 0 -45 -3 -45 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2170 764 l0 -11 27 1 c14 1 28 6 30 13 l4 12 -30 -2 c-17 -1 -31 -7 -31 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2463 765 c0 -8 4 -12 9 -9 4 3 8 9 8 15 0 5 -4 9 -8 9 -5 0 -9 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 760 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703 763 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821 761 l-13 -8 9 -6 c6 -4 19 0 29 8 l19 14 -15 1 c-8 0 -21 -4 -29 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047 763 c-4 -3 -7 -13 -7 -21 l0 -14 15 12 c8 7 15 16 15 21 0 11 -14 12 -23 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715 760 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2026 761 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 746 c0 -8 5 -18 10 -21 l10 -6 0 20 c0 12 -4 21 -10 21 -5 0 -10 -6 -10 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120 750 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 745 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2095 740 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137 720 l-5 -20 9 6 c13 7 11 -10 -2 -23 l-11 -11 11 -7 11 -6 -2 13 c-2 7 3 12 9 11 l13 -3 -4 23 c-3 12 -5 25 -5 30 -2 15 -19 6 -24 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2210 728 c0 -5 11 -8 25 -8 14 0 25 3 25 8 0 4 -11 7 -25 7 -14 0 -25 -3 -25 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2438 733 c-20 -5 -23 -18 -7 -29 6 -3 18 0 26 9 17 16 7 26 -19 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2607 727 l-5 -14 14 0 c8 0 14 6 14 14 0 7 -4 13 -9 13 -5 0 -11 -6 -14 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 719 c0 -6 6 -9 14 -6 8 3 17 1 20 -6 l4 -12 1 18 1 17 -20 0 c-11 0 -20 -5 -20 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1639 719 l-14 -9 33 0 c17 0 32 2 32 4 0 9 -39 13 -51 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820 720 c0 -5 8 -11 18 -14 9 -3 2 -4 -15 -2 -40 3 -44 -11 -5 -17 l27 -4 -30 -2 -30 -2 35 -12 35 -12 -3 -23 c-2 -12 1 -22 6 -22 5 0 8 10 6 23 -1 12 -3 36 -3 53 l-1 32 -20 5 c-11 3 -20 1 -20 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2033 709 c-1 -10 2 -19 8 -19 11 0 12 27 1 34 -4 2 -9 -4 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 711 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400 710 c-8 -5 -11 -12 -7 -16 4 -4 13 -2 19 4 15 15 7 24 -12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2510 710 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2677 707 c-3 -9 -2 -17 2 -17 5 0 16 -3 25 -6 l16 -6 0 17 0 17 -14 -5 c-8 -3 -16 -1 -19 6 l-3 11 -7 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 701 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2180 694 l0 -16 -15 6 -15 5 0 -14 c0 -19 14 -19 30 0 l12 15 18 -10 c31 -16 37 -11 11 10 -28 24 -41 25 -41 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 690 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 674 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526 680 l-20 -7 17 -6 c8 -3 44 -8 79 -11 35 -3 52 -3 38 0 -14 3 -34 9 -45 14 -36 15 -50 17 -69 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2481 683 c-1 -7 -8 -13 -18 -13 -29 0 -6 -11 31 -15 l36 -3 0 15 0 15 -20 -5 -19 -5 -5 12 -4 11 -1 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2573 683 c-7 -2 -13 -11 -13 -19 l0 -15 20 11 c11 6 20 15 20 20 0 11 -7 11 -27 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2632 673 c2 -10 12 -19 23 -22 l19 -3 -12 14 c-6 8 -9 18 -5 21 3 4 -1 7 -11 7 l-17 0 3 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 651 c0 -12 5 -21 10 -21 6 0 10 6 10 14 0 8 -4 18 -10 21 l-10 6 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 649 c0 -5 -4 -8 -8 -5 -5 3 -9 -1 -9 -8 l0 -13 29 0 28 0 0 19 0 18 -20 0 c-11 0 -20 -5 -20 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 640 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1679 641 c12 -8 51 -4 51 5 0 2 -15 4 -32 4 l-33 0 14 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778 638 c5 -5 16 -8 23 -6 l13 4 -23 7 -24 6 11 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041 635 c-6 -26 -7 -75 -1 -75 3 0 11 5 18 12 l12 12 0 -10 c0 -5 -3 -14 -7 -20 -5 -5 -1 -3 7 4 l15 13 -17 13 c-9 6 -18 23 -21 36 -2 14 -5 21 -6 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500 636 c0 -2 11 -6 25 -8 14 -3 25 -1 25 3 0 5 -11 9 -25 9 -14 0 -25 -2 -25 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 610 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 626 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404 619 c-3 -5 6 -9 20 -9 31 0 34 6 6 13 -11 3 -23 1 -26 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1598 623 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 l-40 0 23 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713 613 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 l-30 0 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2000 610 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2153 613 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2198 613 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 595 c0 -8 4 -15 8 -15 5 0 9 7 9 15 0 8 -4 15 -9 15 -4 0 -8 -7 -8 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533 603 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 l-30 0 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 593 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2158 589 l-13 -8 13 -13 12 -12 0 15 0 16 30 -5 c17 -2 30 -2 30 1 0 9 -59 14 -72 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349 528 l-4 -48 10 0 11 0 -4 38 c-6 58 -9 61 -13 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1990 550 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2062 519 c-1 -16 2 -29 8 -29 12 0 14 47 2 54 -4 2 -9 -9 -10 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1854 491 l1 -34 13 -5 c6 -2 12 1 12 8 0 6 -4 9 -9 5 l-10 -5 -4 32 -4 33 1 -34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498 513 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 500 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 495 c-14 -16 -3 -20 19 -6 l13 9 -10 6 c-5 3 -15 -1 -22 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424 498 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1936 484 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 485 c7 -8 17 -15 22 -15 l10 0 -12 15 c-7 8 -17 15 -22 15 l-10 0 12 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333 463 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1724 145 c0 -66 1 -92 3 -57 2 34 2 88 0 120 -2 31 -3 3 -3 -63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2072 168 c-1 -54 1 -98 6 -98 4 0 6 30 4 67 -5 119 -9 131 -10 31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046 212 c7 -4 14 -16 17 -27 l5 -20 1 28 1 27 -17 0 -18 0 11 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201 188 l2 -33 4 27 4 27 22 4 22 4 -27 2 -28 1 1 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 210 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561 204 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2358 213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493 140 c0 -41 2 -58 4 -37 2 20 2 54 0 75 -2 20 -4 3 -4 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1941 194 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749 196 c-8 -8 3 -96 12 -96 5 0 9 23 9 50 0 44 -7 60 -21 46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 151 l0 -51 10 0 10 0 0 40 c0 22 0 43 1 47 0 4 -4 9 -10 11 l-11 4 0 -51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301 154 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2358 163 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094 148 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 150 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 131 c0 -12 5 -21 10 -21 6 0 10 6 10 14 0 8 -4 18 -10 21 l-10 6 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 100 c0 -16 4 -30 8 -30 5 0 7 13 4 30 -2 17 -6 30 -8 30 -2 0 -4 -13 -4 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2362 124 c9 -3 19 -15 22 -27 l4 -22 -1 25 -2 25 -20 2 -20 2 17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658 108 l-13 -8 28 0 c15 0 27 4 27 8 0 11 -25 11 -42 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109 92 l-6 -33 10 10 c5 5 7 19 5 32 l-4 24 -5 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2659 109 l-14 -9 28 0 c29 0 35 5 14 13 -8 3 -20 1 -28 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1941 94 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561 74 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360 60 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2112 50 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 60 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 40 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410 40 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964 38 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#fdf6f9",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1885 2700 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950 2690 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870 2620 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 2600 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904 2548 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890 2520 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2015 2390 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040 2380 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 2370 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 2349 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961 2323 c0 -6 -4 -20 -7 -30 l-7 -18 12 11 c7 7 11 20 8 30 -3 11 -5 14 -6 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795 2310 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 2300 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705 2290 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1833 2283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 2263 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1937 2263 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745 2250 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2095 2240 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 2229 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1963 2233 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 2223 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496 2214 c-9 -24 -7 -28 9 -14 17 14 20 30 6 30 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640 2219 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730 2219 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405 2210 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1837 2213 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1896 2194 c-10 -14 -16 -28 -13 -30 2 -3 12 7 21 22 10 14 16 28 13 30 -2 3 -12 -7 -21 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1926 2180 c-14 -22 -23 -40 -19 -40 10 0 56 70 50 76 -2 2 -16 -14 -31 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2127 2213 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625 2189 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2157 2193 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053 2183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377 2183 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513 2183 c-7 -2 -13 -9 -13 -15 l0 -10 14 11 14 12 7 -11 c3 -5 11 -10 17 -10 l10 0 -12 15 c-13 16 -17 17 -37 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 2173 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 2170 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 2163 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 2146 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443 2143 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850 2135 c-7 -9 -11 -18 -8 -20 3 -3 11 1 18 10 7 9 11 18 8 20 -3 3 -11 -1 -18 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 2133 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427 2123 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 2120 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745 2120 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 2103 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 2116 c0 -2 7 -9 15 -16 l15 -13 -6 17 c-3 9 -10 16 -15 16 -5 0 -9 -2 -9 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870 2105 c-7 -9 -11 -18 -8 -20 3 -3 11 1 18 10 7 9 11 18 8 20 -3 3 -11 -1 -18 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1954 2105 c11 -8 24 -15 30 -15 5 0 1 7 -10 15 -10 8 -23 14 -29 14 -5 0 -1 -6 9 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815 2100 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 2089 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1592 2080 c-7 -11 -9 -20 -4 -20 4 0 13 9 20 20 7 11 9 20 4 20 -4 0 -13 -9 -20 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889 2076 l12 -14 -11 -7 c-5 -3 -10 -10 -10 -15 0 -9 19 -8 37 3 6 4 19 4 30 1 l18 -6 -19 16 c-10 8 -22 13 -26 11 -5 -3 -10 2 -14 10 -3 8 -11 15 -17 15 l-11 0 11 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447 2073 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745 2060 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820 2055 l-12 -15 10 0 c5 0 15 7 22 15 l12 15 -10 0 c-5 0 -15 -7 -22 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 2050 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777 2033 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 2032 c-18 -13 -38 -42 -29 -42 5 0 17 12 27 25 19 26 19 30 2 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 2019 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 2013 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 2020 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277 2023 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053 2013 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587 2013 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020 1975 c-13 -14 -19 -25 -13 -25 12 0 48 38 41 45 -2 3 -15 -6 -28 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225 1960 c-10 -11 -13 -20 -8 -20 13 0 38 29 31 35 -3 3 -13 -4 -23 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 1945 c-7 -9 -10 -18 -7 -21 3 -3 10 4 17 15 13 25 8 27 -10 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 1945 c-7 -9 -11 -18 -8 -20 3 -3 11 1 18 10 7 9 11 18 8 20 -3 3 -11 -1 -18 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310 1940 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375 1930 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414 1908 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885 1910 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 1909 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655 1890 c-10 -11 -13 -20 -8 -20 13 0 38 29 31 35 -3 3 -13 -4 -23 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 1900 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 1892 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430 1885 c-7 -9 -11 -18 -8 -20 3 -3 11 1 18 10 7 9 11 18 8 20 -3 3 -11 -1 -18 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 1879 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 1873 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 1829 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443 1833 c-18 -7 -16 -20 2 -20 8 0 15 6 15 14 0 7 -1 13 -2 12 -2 0 -9 -3 -15 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377 1823 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880 1809 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853 1793 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 1783 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 1770 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 1773 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655 1760 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383 1753 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327 1743 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 1720 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 1710 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 1703 c0 -8 5 -13 12 -11 18 6 21 25 3 25 -8 0 -15 -7 -15 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1705 c0 -5 9 -21 20 -35 11 -14 20 -20 20 -15 0 6 -9 21 -20 35 -11 14 -20 21 -20 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 1691 l-13 -8 10 -7 c5 -3 12 1 16 9 6 17 6 18 -13 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 1680 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 1670 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 1669 c-11 -17 1 -21 15 -4 l12 15 -10 0 c-6 0 -14 -5 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 1660 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 1620 c14 -10 27 -17 29 -14 6 5 -31 33 -44 33 -5 1 1 -8 15 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 1620 c-10 -11 -16 -22 -13 -25 3 -3 13 4 23 15 10 11 16 22 13 25 -3 3 -13 -4 -23 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416 1611 c-4 -6 3 -15 14 -21 l20 -11 0 9 c0 5 -6 15 -14 21 l-14 12 -6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2490 1595 c0 -6 6 -12 13 -12 8 0 14 6 14 12 0 6 -6 12 -14 12 -7 0 -13 -6 -13 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2595 1600 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 1590 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2346 1584 c-8 -21 -8 -21 10 -28 l15 -6 -6 9 c-3 5 4 12 15 16 l20 6 -6 11 -6 10 -9 -13 -9 -14 0 13 c0 17 -17 15 -24 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2560 1579 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1649 1580 c0 -3 -2 -13 -4 -22 l-3 -18 14 0 c8 0 14 3 14 8 0 9 -19 39 -21 32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 1564 c0 -8 6 -22 14 -30 l15 -14 6 10 c3 6 -1 13 -10 16 l-16 7 5 13 c3 8 1 14 -4 14 -6 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 1559 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700 1553 c0 -7 7 -13 15 -13 8 0 15 6 15 13 0 8 -7 14 -15 14 -8 0 -15 -6 -15 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825 1540 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2665 1530 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1545 1520 l6 -10 -25 0 -26 0 1 -17 1 -18 4 12 5 12 24 -11 c14 -6 22 -15 19 -19 -3 -5 -1 -9 4 -9 6 0 12 7 16 15 l5 15 -21 0 -21 0 18 20 18 20 -17 0 -17 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 1511 c0 -11 5 -23 10 -26 l10 -6 0 15 c0 9 0 19 1 23 0 4 -4 9 -10 11 -6 2 -11 -5 -11 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1589 1518 c0 -2 -2 -20 -4 -41 l-4 -38 9 6 c4 3 10 -1 13 -7 2 -7 8 -10 12 -5 5 4 0 13 -10 21 l-18 13 17 10 17 9 -7 17 c-3 9 -10 17 -15 17 -5 0 -9 -1 -10 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2210 1505 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2256 1497 l-5 -21 12 -8 12 -7 7 17 c10 25 9 29 -6 35 l-14 6 -6 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 1512 c0 -11 37 -32 44 -25 3 3 -2 12 -12 19 -19 15 -32 18 -32 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2456 1505 l-5 -15 14 0 c8 0 15 7 15 15 0 8 -4 15 -9 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2571 1507 l-11 -14 15 0 c8 0 15 6 15 14 0 7 -2 13 -4 13 -2 0 -9 -6 -15 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645 1496 c-13 -16 -17 -36 -7 -36 5 0 17 8 26 19 l17 19 -13 5 c-7 2 -18 -1 -23 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 1500 l-15 -10 13 0 13 0 -21 -22 c-22 -24 -23 -27 -11 -47 l9 -13 6 11 c4 6 2 11 -4 11 -6 0 -1 13 11 29 12 16 20 34 18 40 l-4 10 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875 1500 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480 1491 c0 -7 -4 -9 -10 -6 -5 3 -10 1 -10 -4 0 -6 4 -11 9 -11 13 0 25 20 17 27 -3 4 -6 1 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 1490 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 1494 c0 -8 32 -33 43 -34 4 0 7 5 7 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -4 10 -10 10 -5 0 -10 -3 -10 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2832 1478 c5 -13 38 -20 38 -8 0 4 -7 11 -16 14 -22 9 -26 8 -22 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436 1471 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2336 1473 c-4 -5 -13 -8 -18 -8 -6 0 -13 -5 -15 -11 l-4 -11 23 2 23 2 3 16 c4 18 0 21 -12 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2443 1473 c4 -3 1 -13 -6 -22 l-12 -16 18 14 c20 15 22 31 5 31 -6 0 -8 -3 -5 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2750 1455 c7 -8 17 -12 22 -9 l10 7 -13 8 c-22 14 -33 10 -19 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480 1450 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 1449 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2513 1449 c2 -8 10 -13 16 -11 7 1 10 -2 7 -7 -4 -5 -1 -13 5 -17 l12 -7 14 18 13 19 0 -12 c0 -7 5 -12 11 -12 19 0 3 25 -17 26 -10 1 -30 4 -43 9 l-23 7 5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2707 1453 c-10 -10 -8 -25 2 -19 5 3 12 -1 15 -10 l6 -15 -10 6 -10 6 6 -15 c3 -9 11 -16 18 -16 6 0 2 -7 -8 -15 -22 -17 -17 -29 8 -19 l17 7 -3 26 -3 26 28 0 c15 -1 27 3 27 7 0 9 -14 11 -43 9 -9 -1 -20 5 -23 13 -7 17 -16 20 -27 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843 1443 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2820 1434 l0 -15 10 6 c6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313 1414 c-32 -16 -36 -31 -15 -56 l12 -14 -13 -14 -12 -13 17 6 c10 3 20 2 23 -3 3 -5 14 -8 25 -7 24 2 15 17 -11 17 l-19 0 0 19 c0 11 -4 22 -10 26 -10 6 -3 35 8 33 22 -2 42 3 42 12 0 14 -9 12 -47 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 1414 c3 -9 6 -23 6 -32 l1 -17 14 19 15 19 -11 14 c-16 18 -32 16 -25 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 1421 c0 -5 7 -12 16 -15 l17 -6 -13 15 c-14 17 -20 19 -20 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1842 1404 l-2 -25 10 6 c12 7 14 45 2 45 -4 0 -9 -11 -10 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2402 1425 c4 -4 0 -14 -10 -21 l-17 -13 16 -1 c21 0 32 27 16 36 -7 4 -9 4 -5 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2455 1419 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2660 1423 c0 -13 14 -28 29 -31 l13 -3 -6 16 c-3 9 -6 19 -6 21 0 2 -7 4 -15 4 -8 0 -15 -3 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665 1410 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875 1410 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1940 1410 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2053 1413 c9 -2 17 -9 17 -14 0 -5 8 -9 18 -9 l17 1 -19 14 c-11 8 -27 14 -35 14 l-16 -1 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2300 1410 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1626 1395 c4 -8 10 -15 15 -15 5 0 9 7 9 15 0 8 -7 15 -15 15 l-14 0 5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2990 1400 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445 1390 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260 1385 c0 -8 4 -15 9 -15 5 0 11 7 15 15 l5 15 -14 0 c-8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 1384 l0 -15 10 6 c6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2490 1389 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2525 1390 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2816 1385 c4 -8 10 -12 15 -9 14 8 10 24 -6 24 l-14 0 5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2906 1385 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0 -6 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820 1380 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1555 1371 c-6 -11 9 -23 19 -14 9 9 7 23 -3 23 -6 0 -12 -4 -16 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335 1360 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360 1359 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483 1355 c0 -8 4 -12 9 -9 4 3 8 9 8 15 0 5 -4 9 -8 9 -5 0 -9 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526 1361 c-3 -5 1 -11 9 -14 l14 -6 -6 15 c-6 16 -10 17 -17 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1915 1350 c2 -9 -1 -23 -5 -30 l-8 -14 -14 11 c-7 6 -25 13 -40 17 l-28 6 0 -10 c0 -5 9 -10 20 -10 l20 0 16 -25 16 -25 18 23 c9 12 20 34 23 48 l7 26 -14 0 -14 0 3 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1975 1360 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130 1359 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2279 1352 c-21 -22 -42 -63 -32 -61 4 1 20 -1 35 -5 l26 -8 5 -19 c3 -10 10 -19 16 -19 29 0 -5 45 -46 61 l-24 9 6 10 c4 6 11 7 17 4 l11 -7 -6 10 c-4 6 0 13 8 17 8 3 15 10 15 16 0 15 -13 11 -31 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2631 1344 l24 -25 3 11 c5 15 -17 40 -36 40 l-15 0 24 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2960 1355 l-12 -15 16 0 c9 0 16 7 16 15 0 8 -2 15 -4 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 1352 c0 -5 7 -13 16 -16 l16 -6 -4 12 c-5 15 -28 23 -28 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 1350 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2915 1350 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1686 1341 c-3 -5 6 -8 20 -8 l26 0 -13 8 c-18 11 -26 11 -33 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762 1341 l-14 -8 16 -6 16 -6 0 14 c0 17 -1 17 -18 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2223 1343 c-17 -6 -17 -23 0 -23 8 0 14 7 14 15 0 8 -1 15 -1 14 -1 0 -7 -3 -13 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2325 1340 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2510 1335 l-12 -15 10 0 c12 0 26 19 19 26 -2 2 -10 -2 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154 1315 l-19 -14 16 -1 c9 0 22 7 29 15 16 19 0 19 -26 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 1320 c0 -5 5 -10 12 -10 6 0 1 -12 -13 -27 l-24 -26 20 8 c11 4 25 8 31 8 l12 0 -10 29 c-10 27 -28 39 -28 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2065 1320 l-9 -14 12 -4 c7 -2 12 -10 12 -18 0 -16 16 -19 25 -4 3 6 2 10 -3 10 -5 0 -13 10 -19 22 l-9 22 -9 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2378 1320 c-4 -8 -6 -23 -5 -33 l0 -18 10 10 c5 5 7 19 5 32 l-4 24 -6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2847 1323 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 1301 c0 -6 5 -13 10 -16 l10 -6 0 15 c0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2740 1291 c-14 -27 -13 -41 4 -41 l14 0 -3 18 c-1 9 2 23 8 30 l9 12 -10 0 c-6 0 -16 -9 -22 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 1289 c0 -4 7 -10 16 -13 22 -8 24 -8 18 7 -5 14 -34 19 -34 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1995 1290 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430 1274 l0 -25 10 6 c6 3 10 15 10 26 0 10 -4 19 -10 19 -5 0 -10 -12 -10 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2933 1293 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115 1280 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169 1277 l13 -17 29 0 c16 0 29 4 29 9 0 5 -10 9 -22 8 -13 0 -32 4 -43 8 l-20 9 14 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480 1280 l-14 -9 8 -8 9 -8 4 13 c3 6 9 10 13 7 5 -3 11 -1 15 5 8 13 -15 13 -35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643 1283 c-7 -2 -13 -10 -13 -16 l0 -11 11 11 c6 6 18 9 25 6 8 -3 14 0 14 6 0 11 -16 13 -37 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953 1283 c4 -3 -1 -12 -11 -19 -9 -7 -14 -16 -9 -20 4 -4 16 2 27 13 18 20 17 33 -3 33 -6 0 -7 -3 -4 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2012 1265 l-12 -25 16 0 c8 0 13 4 9 9 -3 5 -1 12 5 16 12 7 13 25 2 25 -5 0 -14 -11 -20 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2143 1275 c0 -8 4 -12 9 -9 4 3 8 9 8 15 0 5 -4 9 -8 9 -5 0 -9 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503 1275 c0 -8 7 -15 15 -15 7 0 12 5 10 12 -6 18 -25 21 -25 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820 1268 c0 -4 4 -8 9 -8 6 0 12 4 15 8 3 5 -1 9 -9 9 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265 1260 l-6 -10 16 0 16 0 -11 -21 c-7 -11 -14 -18 -17 -15 -4 3 -13 -3 -21 -15 -19 -27 -9 -35 20 -15 12 9 18 16 13 16 -6 0 -1 7 10 16 22 16 26 35 10 46 -14 10 -23 10 -30 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2100 1255 l-12 -15 16 0 c9 0 16 7 16 15 0 8 -2 15 -4 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2620 1260 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1234 c-6 -14 -10 -27 -10 -29 0 -2 9 -3 20 -2 21 1 29 17 9 17 l-11 0 5 20 c7 29 -2 25 -13 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1489 1258 c-6 -18 -4 -48 3 -48 5 0 8 -8 6 -17 l-3 -18 24 0 c14 0 26 6 29 14 l4 13 -21 -7 -21 -6 -2 18 c0 10 -1 26 0 36 1 9 -3 17 -8 17 -6 0 -10 -1 -11 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2186 1251 c-3 -4 -17 -7 -31 -6 -14 2 -25 -1 -25 -6 0 -5 5 -9 11 -9 5 0 8 -4 5 -9 -3 -5 1 -11 9 -15 l15 -5 -3 11 c-1 7 8 17 21 23 12 5 22 13 22 17 0 11 -18 10 -24 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2962 1236 c15 -13 24 -27 21 -30 -4 -3 -1 -6 5 -6 7 0 12 -3 11 -7 -2 -16 14 -53 22 -53 12 0 12 17 0 24 -5 3 -12 17 -15 31 -8 33 -36 65 -56 65 l-15 -1 27 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039 1234 l-13 -16 18 3 c11 2 21 10 24 17 5 17 -13 15 -29 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176 1241 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337 1232 c-10 -10 -14 -22 -10 -25 3 -4 1 -7 -5 -7 -7 0 -12 -5 -12 -10 0 -6 13 -9 28 -8 l29 2 0 13 c0 17 -14 17 -20 1 l-5 -13 -1 18 c-1 10 6 20 14 23 8 4 15 10 15 15 0 15 -16 10 -33 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2043 1244 c3 -4 2 -16 -4 -26 l-11 -20 13 4 c6 2 16 14 20 26 l8 22 -16 0 c-9 0 -13 -3 -10 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2370 1240 c0 -10 26 -20 34 -13 11 12 6 19 -14 20 -11 1 -20 -2 -20 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2681 1213 c-32 -39 -38 -53 -21 -53 6 0 10 7 10 15 0 9 7 18 15 21 8 4 15 12 15 19 0 7 6 15 13 18 6 2 9 7 6 11 -4 4 -21 -10 -38 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2775 1240 c-4 -6 -5 -13 -4 -14 2 -2 21 -6 41 -9 l38 -6 6 11 7 11 -15 -6 c-9 -3 -21 0 -27 6 -6 6 -11 7 -11 3 0 -5 -6 -3 -14 3 l-14 12 -7 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793 1233 c-17 -6 -17 -23 0 -23 8 0 14 7 14 15 0 8 -1 15 -1 14 -1 0 -7 -3 -13 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 1230 c0 -5 0 -13 0 -17 0 -5 3 -8 8 -8 4 0 13 -4 21 -9 l14 -9 -6 17 c-4 10 -7 22 -7 27 0 5 -7 9 -15 9 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2745 1231 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604 1219 l-5 -9 27 0 c15 0 24 3 20 7 -11 11 -35 12 -42 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860 1220 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2213 1209 c2 -13 8 -24 14 -26 l10 -4 -1 22 c0 12 -7 24 -14 27 l-12 4 3 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1832 1200 c14 -21 38 -27 38 -9 0 5 -5 7 -10 4 -6 -3 -13 1 -16 9 -3 9 -10 16 -15 16 -5 0 -4 -9 3 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1995 1210 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2174 1203 c0 -10 -4 -17 -10 -16 -6 1 -11 -5 -11 -13 0 -7 4 -14 9 -14 4 0 8 5 8 10 0 6 7 10 15 10 l14 0 -5 -13 -5 -14 16 0 c19 0 19 6 -2 29 l-16 18 12 0 c7 0 9 5 6 10 -10 17 -33 11 -31 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988 1193 c-9 -10 -24 -24 -33 -32 -9 -7 -14 -16 -11 -19 3 -3 14 2 24 11 l18 17 12 -10 12 -10 -10 12 -10 12 17 18 c21 23 3 24 -19 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 1195 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186 1195 l-5 -15 14 0 c16 0 20 16 6 24 -5 3 -11 -1 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566 1196 c7 -19 35 -29 47 -17 5 5 16 7 25 4 l15 -6 -7 11 -7 11 -29 -6 -30 -5 0 11 c0 6 -4 11 -10 11 -5 0 -7 -6 -4 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049 1184 l-13 -16 18 3 c11 2 21 10 24 17 5 17 -13 15 -29 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 1190 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1975 1190 c3 -5 13 -10 21 -10 8 0 12 5 9 10 -3 6 -13 10 -21 10 -8 0 -12 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2263 1182 c10 -10 17 -26 17 -35 0 -9 5 -17 11 -17 l10 0 -7 22 c-7 23 -28 48 -40 48 -4 0 0 -8 9 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2830 1191 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 1179 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670 1179 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 1180 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040 1180 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2863 1175 c0 -8 4 -12 9 -9 4 3 8 9 8 15 0 5 -4 9 -8 9 -5 0 -9 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2490 1170 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2710 1170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2740 1166 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2910 1171 c0 -5 -3 -18 -6 -28 l-6 -18 15 18 c17 21 31 22 23 2 l-5 -15 19 0 c11 0 20 2 20 5 0 7 -43 45 -52 45 -4 0 -8 -4 -8 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 1147 c0 -13 -5 -28 -10 -33 l-11 -11 15 0 c8 0 14 5 13 10 -1 6 8 16 21 22 29 15 42 30 20 22 -10 -3 -20 -2 -23 3 -11 18 -25 10 -25 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 1142 c0 -5 7 -13 16 -16 l16 -6 -4 12 c-5 15 -28 23 -28 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 1140 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 1141 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2417 1143 c-4 -3 -1 -13 6 -21 l12 -16 -12 8 -13 7 0 -15 c0 -21 17 -20 28 2 15 27 -2 55 -21 35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2475 1140 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2691 1127 l-11 -14 15 0 c8 0 15 6 15 14 0 7 -2 13 -4 13 -2 0 -9 -6 -15 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225 1120 c-4 -6 -10 -8 -14 -6 -4 3 -8 -1 -8 -9 l0 -15 19 17 c18 16 22 23 14 23 -3 0 -8 -5 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2510 1120 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2826 1115 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2913 1123 c-18 -6 -16 -23 1 -23 17 0 30 16 19 23 -5 2 -14 2 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964 1105 c-4 -8 -11 -12 -17 -8 l-10 6 7 -11 c9 -15 36 -4 36 14 0 18 -9 18 -16 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990 1110 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020 1100 c-14 -11 -20 -20 -15 -20 6 0 21 9 35 20 14 11 21 20 15 20 -5 0 -21 -9 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 1100 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2490 1100 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 1090 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910 1080 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2505 1081 c-3 -6 -15 -8 -27 -6 -11 3 -18 1 -14 -2 4 -4 18 -9 31 -10 l25 -4 0 16 c0 17 -6 19 -15 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2963 1065 c5 -14 29 -13 34 2 l4 12 -20 -2 c-12 -1 -20 -6 -18 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2820 1060 c-8 -5 -11 -12 -7 -16 4 -4 13 -2 19 4 15 15 7 24 -12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256 1042 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735 1030 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2475 1019 c-11 -17 1 -21 15 -4 l12 15 -10 0 c-6 0 -14 -5 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2800 1005 c0 -6 7 -12 15 -12 8 0 15 6 15 12 0 6 -7 12 -15 12 -8 0 -15 -6 -15 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759 984 c-17 -21 5 -23 31 -4 l25 19 -23 -2 c-13 -1 -28 -7 -33 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 990 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 990 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 980 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120 970 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1996 971 c-3 -5 1 -11 9 -15 l15 -5 0 14 c0 16 -16 20 -24 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1776 962 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2783 956 c5 -15 24 -18 24 -3 0 8 -6 14 -14 14 -7 0 -12 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 956 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903 939 l-2 -20 12 4 c7 2 13 11 15 20 l3 17 -13 0 c-8 0 -14 -9 -15 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 940 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 940 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404 928 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1824 928 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 923 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 925 c0 -2 7 -8 15 -15 l15 -12 0 14 c0 8 -7 15 -15 15 -8 0 -15 -1 -15 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235 921 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465 920 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1726 922 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765 920 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669 903 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2493 895 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145 889 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2183 893 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445 880 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 880 c0 -5 9 -10 19 -10 11 0 23 5 26 10 l6 10 -25 0 c-14 0 -26 -4 -26 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808 863 c-10 -2 -18 -9 -18 -14 l0 -10 23 6 c12 4 26 11 32 16 l9 9 -14 -1 c-8 -1 -23 -3 -32 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2745 861 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103 854 c3 -4 2 -15 -4 -25 l-10 -19 11 0 c5 0 10 4 10 9 0 5 3 16 6 25 l6 16 -13 0 c-7 0 -9 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 844 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190 850 l-15 -9 10 -10 10 -10 15 9 15 9 -10 10 -10 10 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2437 853 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 844 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2780 844 l0 -15 10 6 c6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1703 832 c-40 -15 -57 -32 -32 -32 l11 0 -12 -15 -12 -15 11 0 c10 0 15 14 12 34 -1 5 7 6 19 3 11 -3 18 -2 15 3 -3 4 6 11 20 14 14 4 25 11 25 16 0 13 -6 12 -57 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005 840 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785 828 c-16 -6 -37 -13 -45 -16 l-15 -4 13 -5 c18 -7 102 17 102 28 0 11 -16 10 -55 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2077 825 c-7 -16 8 -29 23 -20 15 9 12 35 -4 35 -8 0 -16 -7 -19 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 815 c0 -8 4 -12 9 -9 4 3 8 0 8 -6 0 -6 5 -8 10 -5 6 3 10 11 10 17 0 6 -3 8 -7 5 -3 -4 -11 -2 -18 3 l-12 10 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 815 c0 -9 5 -15 11 -13 6 2 11 8 11 13 0 5 -5 11 -11 13 -6 2 -11 -4 -11 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396 822 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 820 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2267 809 c-10 -11 -15 -25 -11 -30 l6 -10 14 27 c8 15 13 28 11 30 -2 2 -11 -6 -20 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 810 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2207 814 c-13 -13 -7 -23 13 -21 11 1 19 6 17 11 -4 13 -21 18 -30 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2443 813 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615 800 l-6 -10 16 0 16 0 -6 -10 c-3 -5 -1 -10 4 -10 15 0 14 15 -3 29 l-14 12 -7 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2715 800 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457 779 c6 -22 20 -26 20 -4 0 8 -6 16 -13 19 l-12 5 5 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805 790 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 781 c0 -17 18 -21 24 -6 l5 15 -14 0 c-8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456 781 c-3 -5 1 -11 9 -14 l14 -6 -6 15 c-6 16 -10 17 -17 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2411 768 c-5 -13 -11 -34 -15 -48 l-7 -25 15 19 c9 11 16 25 17 30 0 6 2 19 4 29 5 24 -4 21 -14 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230 766 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 759 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046 761 c-4 -5 -2 -12 3 -15 5 -4 12 -2 15 3 4 5 2 12 -3 15 -5 4 -12 2 -15 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365 760 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 750 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2025 751 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190 745 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2267 747 l-5 -14 14 0 c8 0 14 6 14 14 0 7 -4 13 -9 13 -5 0 -11 -6 -14 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2730 750 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970 734 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2104 738 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2675 741 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083 725 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446 725 c-10 -8 -23 -12 -27 -9 -5 3 -9 0 -9 -6 0 -6 -4 -8 -10 -5 -5 3 -10 1 -10 -4 0 -6 2 -11 5 -11 13 0 85 36 85 42 0 12 -13 9 -34 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2615 730 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684 718 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2423 704 c0 -8 6 -14 14 -14 7 0 13 4 13 9 0 5 -6 11 -13 14 l-14 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2530 712 c0 -5 7 -9 15 -9 8 0 12 4 9 9 -3 4 -9 8 -15 8 -5 0 -9 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234 698 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 700 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2035 701 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2115 700 c-8 -13 -1 -24 14 -19 l10 4 -8 14 -8 13 -8 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2283 693 l0 -13 14 11 c7 6 13 12 13 14 0 1 -6 2 -13 2 -8 0 -14 -6 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2486 693 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957 693 c-3 -5 -1 -17 4 -28 4 -11 8 -16 8 -11 1 5 11 1 23 -10 l23 -19 -14 18 c-8 9 -11 20 -8 24 8 7 -11 33 -24 33 -4 0 -10 -3 -12 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2640 690 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266 673 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2175 681 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185 671 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2374 668 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2530 667 c0 -8 7 -14 15 -14 8 0 15 6 15 14 0 7 -7 13 -15 13 -8 0 -15 -6 -15 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2605 670 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2676 671 c-3 -5 6 -8 19 -8 14 0 25 3 25 8 0 5 -9 9 -19 9 -11 0 -22 -4 -25 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260 659 c0 -11 27 -12 34 -1 2 4 -4 9 -15 9 -10 1 -19 -2 -19 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2463 655 c-19 -21 -1 -25 20 -3 l17 18 -12 0 c-7 -1 -19 -7 -25 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404 649 c-3 -6 -1 -16 6 -22 l13 -12 -6 16 -6 17 21 -6 21 -5 -7 11 c-9 15 -33 15 -42 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 644 l0 -16 -15 6 -15 5 0 -10 0 -11 23 5 c12 4 29 2 37 -3 8 -5 19 -6 24 -2 l11 6 -25 6 c-14 4 -24 12 -22 18 1 7 -2 12 -8 12 -5 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2493 643 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087 613 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2277 609 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 610 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 600 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005 580 l8 -12 -12 -8 -12 -7 13 -11 14 -11 2 24 c1 13 -3 27 -10 31 l-11 7 8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155 580 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 551 c0 -6 4 -12 8 -15 5 -3 9 1 9 9 0 8 -4 15 -9 15 -4 0 -8 -4 -8 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143 520 c-2 -24 12 -27 21 -4 8 22 8 24 -7 24 -7 0 -13 -9 -14 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 524 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960 515 c-7 -9 -11 -18 -8 -20 3 -3 11 1 18 10 7 9 11 18 8 20 -3 3 -11 -1 -18 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 496 l0 -24 19 5 19 5 -16 19 c-9 10 -18 19 -19 19 -2 0 -3 -11 -3 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020 506 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905 460 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885 249 c-11 -17 1 -21 15 -4 l12 15 -10 0 c-6 0 -14 -5 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1545 240 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970 241 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2410 241 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 190 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 190 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2660 191 c0 -18 18 -21 30 -6 l12 15 -21 0 c-11 0 -21 -4 -21 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 190 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1973 183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304 168 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 151 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772 78 c-40 -39 -70 -73 -67 -76 3 -4 38 26 77 66 40 39 70 73 67 76 -2 3 -37 -27 -77 -66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2637 69 c40 -40 75 -70 78 -67 6 6 -120 131 -138 137 -7 2 20 -30 60 -70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2656 131 c-3 -5 1 -11 9 -14 l14 -6 -6 15 c-6 16 -10 17 -17 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055 120 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 110 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 109 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540 106 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375 80 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 70 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1915 70 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1545 50 l-18 -20 11 0 c6 0 16 9 22 20 6 11 9 20 7 20 -2 0 -12 -9 -22 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2150 61 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093 43 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f398c0",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1883 2613 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1915 2600 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 2366 c0 -2 7 -9 15 -16 l15 -12 0 10 c0 5 -7 12 -15 16 -8 3 -15 4 -15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2060 2331 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825 2290 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 2254 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 2260 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2205 2259 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1996 2247 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 2250 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2156 2244 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493 2223 c4 -3 2 -12 -4 -20 l-11 -13 11 0 c6 0 11 2 11 4 0 2 3 11 6 20 l6 16 -13 0 c-7 0 -9 -3 -6 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2175 2220 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2121 2198 l-14 -23 22 19 c22 20 25 26 13 26 -4 0 -13 -10 -21 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 2190 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2150 2185 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 2186 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369 2163 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 2154 l0 -16 15 12 c8 7 15 14 15 16 0 2 -7 4 -15 4 -8 0 -15 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 2139 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 2129 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 2125 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1849 2123 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215 2110 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1869 2103 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 2089 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2045 2090 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 2069 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 2055 c-3 -9 -6 -22 -5 -28 0 -7 5 -1 10 12 5 13 8 26 5 28 -2 2 -6 -3 -10 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889 2053 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439 2053 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1819 2053 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 2056 c0 -2 7 -9 15 -16 l15 -12 0 10 c0 5 -7 12 -15 16 -8 3 -15 4 -15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605 2040 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580 2005 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 1999 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670 2006 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 1990 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614 1978 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021 1970 c-13 -11 -19 -20 -14 -20 6 0 18 9 28 20 23 25 17 25 -14 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231 1958 l-14 -23 22 19 c22 20 25 26 13 26 -4 0 -13 -10 -21 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 1965 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1555 1969 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 1959 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045 1950 c-10 -11 -14 -20 -9 -20 5 0 15 9 22 20 7 11 11 20 9 20 -2 0 -12 -9 -22 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315 1940 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23 20 -3 0 3 -9 13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 1943 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 1929 c-11 -16 -1 -19 13 -3 l13 14 -10 0 c-5 0 -13 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 1928 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606 1908 l-17 -33 20 24 c18 20 27 41 18 41 -1 0 -11 -15 -21 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 1920 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654 1888 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429 1873 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294 1868 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735 1840 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 1830 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425 1820 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 1810 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660 1810 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369 1803 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783 1803 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405 1789 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 1778 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660 1765 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 1740 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1717 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 1723 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386 1704 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434 1668 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 1641 c0 -5 7 -12 16 -15 l17 -6 -13 15 c-14 17 -20 19 -20 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 1623 l-24 -28 28 24 c15 14 27 26 27 28 0 8 -8 1 -31 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2475 1640 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290 1615 c0 -8 9 -19 19 -25 l20 -10 6 10 c8 13 -13 40 -31 40 -8 0 -14 -7 -14 -15z m35 -5 c3 -5 4 -10 1 -10 -3 0 -8 5 -11 10 -3 6 -4 10 -1 10 3 0 8 -4 11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2602 1608 l-10 -13 33 -2 34 -1 -6 15 -6 15 -8 -14 -9 -13 0 13 c0 6 -4 12 -9 12 -5 0 -13 -6 -19 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2426 1591 c10 -10 21 -17 23 -15 6 6 -20 34 -32 34 -6 0 -2 -8 9 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2473 1596 l18 -14 -12 -26 c-7 -14 -9 -29 -4 -34 4 -4 10 -1 12 6 3 6 9 10 14 6 5 -3 9 4 9 14 l0 20 20 -5 20 -5 0 12 0 12 -15 -6 c-8 -3 -15 -1 -15 5 0 6 -4 8 -9 5 -5 -4 -11 -1 -13 6 -2 6 -13 12 -24 14 l-19 3 18 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653 1555 c-23 -22 -31 -41 -14 -30 5 3 12 -3 14 -12 l5 -18 1 21 c0 12 8 27 16 34 l15 12 14 -11 c7 -6 16 -25 20 -41 6 -33 22 -41 22 -11 l0 20 -11 -7 c-5 -3 -4 2 4 11 l13 17 -11 0 -12 0 7 12 7 11 -16 -6 -17 -6 0 14 0 15 -17 -1 c-10 -1 -28 -11 -40 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2653 1565 c0 -8 7 -15 15 -15 l14 0 -12 15 c-7 8 -13 15 -15 15 -1 0 -2 -7 -2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830 1532 c0 -12 19 -26 26 -19 2 2 -2 10 -11 17 l-15 12 0 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2602 1528 c-25 -12 -24 -31 1 -36 18 -4 47 20 47 37 0 14 -18 13 -48 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680 1520 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260 1498 c0 -5 7 -16 15 -25 l16 -15 25 17 c14 9 24 18 22 20 -1 1 -20 5 -40 8 l-38 5 0 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2466 1502 c-3 -6 -1 -14 5 -17 15 -10 25 3 12 16 l-11 11 -6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2540 1496 c0 -9 7 -16 16 -16 17 0 14 22 -4 28 -7 2 -12 -3 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1550 1490 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593 1486 l0 -14 14 5 c7 3 10 9 7 14 -8 14 -21 11 -21 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925 1480 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653 1466 l0 -14 14 5 c7 3 10 9 7 14 -8 14 -21 11 -21 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474 1449 c0 -10 6 -19 13 -19 7 0 13 4 13 9 0 5 -6 13 -13 19 l-13 11 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1966 1455 c4 -8 16 -15 28 -15 l21 1 -19 14 c-25 19 -37 19 -30 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2337 1463 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2697 1444 c-23 -31 -21 -45 3 -16 l19 22 6 -21 7 -21 19 21 c25 26 24 34 -2 26 l-22 -7 6 9 c13 20 -20 8 -36 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2850 1450 c-6 -11 -9 -20 -8 -21 2 0 10 -2 18 -4 l16 -3 1 19 c2 27 -14 33 -27 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 1445 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2545 1450 c-3 -5 -1 -10 5 -10 l12 0 -6 -16 -6 -15 10 6 c13 8 13 45 1 45 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 1441 c0 -5 -9 -13 -20 -16 -11 -3 -20 -11 -20 -16 l0 -10 23 13 c12 7 25 11 30 10 4 -1 7 5 7 13 0 8 -4 15 -10 15 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2365 1430 c3 -5 13 -10 21 -10 8 0 14 5 14 10 0 6 -9 10 -21 10 l-20 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517 1415 c-4 -8 -13 -15 -22 -15 -8 0 -15 -4 -15 -10 0 -5 6 -9 13 -7 14 2 41 36 34 43 -2 3 -7 -2 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310 1420 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2462 1418 c-14 -14 -16 -28 -3 -28 9 0 24 30 18 36 -2 2 -9 -2 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2623 1411 c1 -21 14 -23 34 -4 19 17 16 23 -11 23 l-25 0 2 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541 1401 l-11 -19 19 5 c9 2 18 11 18 19 0 20 -14 17 -26 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1632 1411 l-14 -8 17 -7 c23 -9 25 -8 25 9 0 17 -9 19 -28 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737 1413 c-12 -12 -7 -22 8 -17 8 4 15 10 15 15 0 11 -14 12 -23 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 1411 l0 -13 -15 6 c-8 3 -15 1 -15 -5 0 -6 10 -9 23 -8 12 2 27 0 33 -4 l12 -7 6 16 6 16 -14 -5 c-7 -3 -19 0 -25 6 l-11 11 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2788 1415 c-7 -8 3 -54 13 -61 11 -7 12 36 1 54 -5 7 -11 10 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 1394 l0 -16 15 12 c8 7 15 14 15 16 0 2 -7 4 -15 4 -8 0 -15 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1903 1403 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2575 1400 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2085 1390 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2253 1388 c-12 -17 -11 -38 2 -37 6 1 9 5 8 10 -2 5 1 9 5 9 5 0 9 7 9 15 0 18 -11 19 -24 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2360 1392 c0 -5 7 -9 15 -9 8 0 15 4 15 9 0 4 -7 8 -15 8 -8 0 -15 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 1376 c0 -4 7 -18 16 -31 l16 -24 14 14 c17 17 18 28 2 22 -7 -2 -21 2 -30 11 -10 8 -18 12 -18 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556 1355 l-7 -26 -9 6 c-6 3 -10 2 -10 -4 0 -5 5 -13 10 -16 6 -3 10 -1 10 5 l0 11 22 -7 23 -7 -14 16 c-7 9 -11 24 -7 32 3 8 2 15 -3 15 -5 0 -12 -11 -15 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1897 1369 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2297 1373 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2610 1375 c0 -2 11 -15 24 -28 12 -13 25 -30 28 -38 l5 -14 9 9 9 9 -12 4 c-7 3 -13 10 -13 17 0 7 -8 20 -18 29 -18 16 -32 22 -32 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2853 1367 c-36 -12 -43 -32 -14 -40 l18 -4 28 28 27 29 -14 -1 c-7 -1 -28 -7 -45 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221 1361 c-8 -5 -16 -17 -17 -26 -1 -9 0 -14 3 -11 4 3 12 1 20 -6 7 -6 17 -8 20 -4 4 4 2 11 -5 15 l-13 8 7 16 c7 19 5 20 -15 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2395 1360 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2489 1368 c-4 -8 -5 -68 -2 -68 2 0 13 9 25 20 12 11 18 23 15 27 -4 3 -7 1 -7 -5 0 -7 -5 -12 -11 -12 l-10 0 6 20 6 20 -10 0 c-6 0 -12 -1 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2967 1357 l-6 -17 24 0 c13 0 27 5 31 12 l7 11 -21 -5 -21 -6 -4 11 -3 11 -7 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635 1340 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1691 1341 l-13 -8 10 -7 c5 -3 12 1 16 9 6 17 6 18 -13 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2196 1335 c5 -13 17 -17 40 -14 4 0 10 -5 14 -11 l7 -12 6 16 6 16 -20 0 c-11 0 -29 5 -39 10 l-20 10 6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2422 1332 c-1 -9 -4 -33 -8 -53 l-6 -36 16 0 c16 0 18 8 19 59 l0 26 14 -5 13 -5 0 14 0 14 -23 2 -23 1 -2 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2566 1335 c4 -8 10 -15 15 -15 5 0 9 7 9 15 0 8 -7 15 -15 15 l-14 0 5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2760 1326 c0 -13 7 -26 15 -30 l15 -5 0 23 c0 13 -7 26 -15 30 l-15 5 0 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369 1321 l-24 -20 23 6 c23 5 38 20 29 29 -2 2 -15 -4 -28 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423 1332 c1 -4 -14 -23 -34 -42 -20 -19 -39 -44 -43 -55 l-6 -20 42 46 c24 26 51 49 61 52 23 8 22 22 -3 24 -11 1 -19 -1 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 1325 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9 -1 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839 1329 l-14 -9 23 0 23 0 21 -50 c11 -27 25 -50 30 -50 5 0 7 3 5 8 -3 4 5 15 18 24 l23 17 6 -14 c3 -8 13 -15 21 -15 l16 0 -6 -11 c-4 -6 -13 -8 -21 -5 -8 3 -14 2 -14 -3 0 -5 11 -11 24 -13 l24 -5 0 24 0 23 -19 0 c-11 0 -19 6 -19 14 0 8 -8 17 -17 20 -10 4 -14 4 -10 0 9 -10 -24 -33 -39 -27 -7 3 -10 11 -7 19 6 16 -11 40 -37 54 l-16 9 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 1320 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2899 1323 c-1 -5 -1 -12 0 -17 1 -5 -5 -4 -13 4 l-16 12 0 -16 0 -17 22 3 23 3 3 18 c2 9 -1 17 -7 17 -6 0 -12 -3 -12 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2970 1320 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2507 1292 c-17 -19 -14 -32 8 -32 l13 0 0 25 c0 14 -1 25 -3 25 -1 0 -9 -8 -18 -18z m10 -19 c-4 -3 -10 -3 -14 0 -3 4 0 7 7 7 7 0 10 -3 7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080 1285 l0 -14 15 5 c8 4 15 7 15 9 0 2 -7 5 -15 9 l-15 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2723 1286 c5 -16 27 -19 27 -3 0 7 -7 14 -15 14 -9 0 -14 -5 -12 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237 1283 c-10 -9 -9 -23 2 -23 5 0 11 7 15 15 5 15 -5 20 -17 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461 1272 c-21 -21 -3 -27 20 -6 l20 18 -6 -27 c-9 -35 0 -35 13 1 l10 28 -22 0 c-13 0 -28 -6 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1592 1278 c6 -18 28 -21 28 -4 0 9 -7 16 -16 16 -9 0 -14 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782 1281 l-14 -8 14 -6 15 -5 0 14 c0 8 -1 14 -1 14 -1 0 -7 -4 -14 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2300 1282 c0 -12 19 -26 26 -19 2 2 -2 10 -11 17 l-15 12 0 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633 1273 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2648 1273 c-22 -5 -23 -19 -3 -27 8 -3 15 -1 15 5 0 6 5 7 10 4 6 -3 10 -2 10 4 0 13 -12 18 -32 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 1260 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2102 1253 l-14 -14 -14 12 -14 11 0 -11 c0 -6 3 -11 8 -12 39 -4 72 -3 72 2 0 4 -6 11 -12 17 l-13 10 -13 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2940 1262 c0 -4 9 -13 20 -20 22 -13 27 -3 8 16 -14 14 -28 16 -28 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059 1240 c-13 -10 -19 -19 -12 -20 11 0 43 26 43 36 0 8 -8 4 -31 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155 1240 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2360 1245 c0 -2 10 -10 23 -16 l22 -12 -14 16 c-13 16 -31 23 -31 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283 1228 c-14 -23 -13 -46 2 -52 17 -6 19 2 6 23 l-10 15 17 13 17 12 -12 1 c-6 0 -15 -6 -20 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2215 1220 c10 -11 20 -18 23 -15 7 6 -18 35 -31 35 -5 0 -2 -9 8 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2880 1229 c0 -5 -4 -7 -10 -4 -5 3 -10 2 -10 -4 0 -5 5 -13 12 -17 l12 -8 4 12 c2 7 8 10 13 6 5 -3 9 2 9 10 0 9 -7 16 -15 16 -8 0 -15 -5 -15 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145 1220 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700 1221 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 1215 c-14 -16 -10 -18 14 -9 9 3 16 10 16 15 0 14 -16 11 -30 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830 1220 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860 1220 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2756 1222 l-7 -12 15 -22 c9 -12 17 -19 17 -15 1 4 2 10 3 15 1 4 5 13 10 21 l9 14 -16 -6 -16 -6 -4 12 -3 11 -8 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987 1187 l-18 -32 25 27 c27 28 32 38 19 38 -5 0 -16 -15 -26 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 1212 c0 -10 36 -9 46 1 4 4 -5 7 -19 7 -15 0 -27 -4 -27 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1628 1213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2185 1210 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2680 1205 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2930 1205 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 1193 c-14 -9 -31 -25 -38 -35 -7 -10 -19 -18 -27 -18 -8 0 -21 -10 -29 -22 l-16 -22 11 -7 11 -6 29 28 c37 36 92 99 87 99 -2 0 -15 -8 -28 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144 1185 l-19 -14 17 -1 c9 0 20 5 23 11 11 17 0 20 -21 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 1190 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425 1190 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 1190 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2104 1183 l-11 -18 41 -2 c23 0 32 1 21 4 -11 3 -24 10 -30 15 l-10 11 13 -7 12 -7 0 10 c0 17 -24 13 -36 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2257 1181 l5 -20 14 6 c8 3 14 6 12 7 -2 1 -11 7 -20 14 l-16 13 5 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2510 1179 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2806 1174 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2180 1166 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2715 1170 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3000 1171 c0 -6 5 -13 10 -16 l10 -6 0 15 c0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2300 1159 c0 -5 -4 -7 -10 -4 -5 3 -10 2 -10 -4 0 -19 16 -19 28 0 l12 19 -10 0 c-5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2333 1156 l0 -14 29 2 c16 1 32 -3 36 -8 6 -10 52 -18 52 -9 0 7 -55 26 -72 25 -10 0 -20 3 -23 9 -9 14 -22 11 -22 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 1139 l0 -10 12 7 11 7 -7 -19 -7 -19 12 12 c6 6 8 16 5 22 -9 14 -26 14 -26 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 1140 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203 1143 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625 1140 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2483 1143 c-15 -5 -17 -23 -4 -23 5 0 11 7 15 15 3 8 4 15 3 14 -1 0 -8 -3 -14 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200 1129 c0 -5 9 -9 20 -9 11 0 20 2 20 4 0 2 -9 6 -20 9 -11 3 -20 1 -20 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049 1113 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350 1120 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2515 1120 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700 1121 c0 -5 7 -11 15 -15 l15 -5 0 14 c0 8 -7 15 -15 15 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423 1113 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2463 1103 c-18 -7 -16 -20 2 -20 8 0 15 6 15 14 0 7 -1 13 -2 12 -2 0 -9 -3 -15 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2665 1101 c3 -5 0 -13 -7 -17 l-12 -7 20 -8 c30 -12 41 -10 41 6 0 8 -4 12 -9 9 -4 -3 -8 2 -8 10 0 9 -7 16 -16 16 -8 0 -13 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2810 1100 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347 1083 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2501 1073 c-16 -18 -8 -28 13 -16 l15 8 -7 12 -7 11 -14 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 1065 l-12 -15 14 0 c8 0 15 7 15 15 0 8 -1 15 -2 15 -2 0 -8 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293 1073 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2940 1060 c0 -24 15 -27 24 -4 9 22 8 24 -9 24 l-15 0 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970 1059 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673 1063 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793 1063 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2826 1054 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105 1020 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176 1015 c4 -8 7 -15 9 -15 2 0 5 7 9 15 l5 15 -14 0 -14 0 5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373 1023 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2475 1019 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2506 1015 l6 -15 -11 0 c-6 0 -11 -4 -11 -10 0 -5 8 -10 17 -10 9 0 13 3 10 6 -3 4 -2 15 4 25 l10 19 -15 0 -15 0 5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2790 1005 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473 995 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 990 c-8 -5 -11 -12 -7 -16 4 -4 13 -2 19 4 15 15 7 24 -12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 991 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844 988 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 980 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643 983 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2815 981 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2006 965 c4 -8 10 -15 15 -15 4 0 6 7 3 15 -4 8 -10 15 -15 15 -4 0 -6 -7 -3 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 961 c0 -5 6 -12 13 -14 l12 -5 -12 -1 c-7 -1 -13 -5 -13 -11 0 -5 7 -7 15 -4 8 4 15 12 15 19 0 7 -7 15 -15 19 -8 3 -15 1 -15 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815 960 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 950 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212 953 c-6 -2 -10 -9 -6 -14 3 -5 0 -9 -5 -9 -6 0 -11 -7 -11 -15 0 -26 18 -16 29 15 5 17 9 30 8 29 -1 0 -8 -3 -15 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 949 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 939 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621 936 l-12 -14 9 -6 c6 -3 13 1 16 10 9 23 2 28 -13 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2496 935 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 930 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768 923 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 910 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2025 910 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2796 905 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0 -6 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2195 900 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2446 895 l-5 -15 13 0 c7 0 13 7 13 15 0 8 -4 15 -8 15 -4 0 -9 -7 -13 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775 890 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2320 896 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166 882 c-3 -5 1 -9 9 -9 8 0 15 4 15 9 0 4 -4 8 -9 8 -6 0 -12 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277 884 c-8 -9 11 -44 23 -44 6 0 10 7 10 15 0 8 -6 14 -12 13 -7 -2 -12 3 -10 10 2 13 -1 15 -11 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 880 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700 870 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943 873 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 855 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2775 859 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 845 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2184 844 l-19 -16 18 6 18 6 -6 -10 -6 -10 15 6 15 6 -6 14 c-3 8 -6 14 -7 14 -1 0 -11 -7 -22 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266 844 c-9 -8 -16 -20 -16 -26 0 -5 -7 -8 -15 -4 l-15 6 10 -20 c12 -23 21 -25 38 -8 16 16 15 31 0 22 l-13 -7 8 9 c5 5 13 9 19 9 6 0 12 8 14 18 3 21 -10 22 -30 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 851 c0 -6 5 -13 10 -16 l10 -6 0 15 c0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003 843 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2056 843 c-3 -3 -6 -15 -6 -25 l0 -19 18 10 c9 5 22 9 27 10 6 1 10 6 10 13 0 12 -38 21 -49 11z m24 -13 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144 828 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445 830 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693 829 c-18 -5 -33 -14 -33 -18 l0 -9 35 11 c19 6 35 14 35 19 0 4 -1 8 -2 7 -2 0 -18 -5 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930 830 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2740 827 c0 -8 7 -14 15 -14 l15 0 -11 14 c-6 7 -13 13 -15 13 -2 0 -4 -6 -4 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 816 c0 -2 7 -9 15 -16 l15 -12 0 10 c0 5 -7 12 -15 16 -8 3 -15 4 -15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 810 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1355 810 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 808 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2170 811 c0 -10 24 -21 43 -21 7 0 3 7 -7 15 -22 17 -36 19 -36 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 803 c-17 -6 -16 -23 1 -23 8 0 16 7 20 15 6 15 1 17 -21 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707 796 l-6 -15 15 6 c7 3 14 9 14 14 0 14 -17 10 -23 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 785 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669 783 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830 796 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 791 c0 -6 5 -13 10 -16 l10 -6 0 15 c0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 783 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 769 l11 -18 18 10 c10 5 18 11 18 13 0 2 -13 6 -29 8 l-29 4 11 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790 780 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1932 765 l0 -30 5 18 c2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423 773 c-7 -2 -13 -8 -13 -12 0 -11 49 -1 56 10 5 9 -22 11 -43 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2171 764 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2223 766 l6 -15 -13 5 -13 5 0 -16 c0 -18 7 -19 28 -2 17 13 15 37 -3 37 -6 0 -8 -7 -5 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 761 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2270 755 c7 -9 15 -13 17 -11 7 7 -7 26 -19 26 l-10 0 12 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2406 744 c-8 -20 -8 -24 2 -23 4 1 15 1 25 0 l18 -1 -7 -11 c-3 -6 -17 -9 -30 -6 l-23 4 -6 -15 -5 -14 25 6 c14 4 25 5 25 4 0 -2 -4 -18 -9 -36 l-10 -32 18 0 c10 0 18 6 19 13 1 6 3 34 6 60 l5 48 -21 -7 -21 -6 6 16 c4 9 2 16 -2 16 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2696 752 c-12 -11 -5 -24 10 -18 l15 6 -6 -10 c-3 -6 -2 -10 3 -10 6 0 12 6 15 14 l6 14 -19 5 c-10 3 -21 2 -24 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147 743 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651 741 l-13 -8 10 -7 c6 -3 14 -1 17 5 9 14 2 20 -14 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1968 732 l-5 -19 12 0 12 0 -5 19 c-2 10 -6 18 -7 18 -1 0 -5 -8 -7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2074 715 c2 -16 5 -34 5 -40 1 -5 8 1 17 13 l15 22 11 -6 11 -7 -5 14 c-3 8 -13 14 -24 14 -10 0 -22 5 -27 10 l-7 10 4 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 720 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1606 714 c-11 -8 -16 -14 -10 -14 13 0 39 18 34 24 -3 2 -14 -2 -24 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2616 713 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 711 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2516 694 l6 -24 -11 -14 -12 -14 10 -6 c6 -4 15 2 21 13 l10 20 14 -5 c8 -3 16 -2 19 3 2 4 -11 18 -29 30 l-34 22 6 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145 699 c-9 -14 -2 -20 14 -10 l13 9 -10 6 c-6 3 -14 1 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 695 l0 -14 15 5 c8 4 15 7 15 9 0 2 -7 5 -15 9 l-15 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364 696 l-19 -15 20 4 c11 2 23 4 28 4 10 1 9 21 -1 21 -5 0 -17 -6 -28 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544 688 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960 696 c0 -2 7 -9 15 -16 l15 -12 0 16 c0 9 -7 16 -15 16 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2110 685 l0 -14 20 2 c11 1 20 4 20 8 0 4 -9 9 -20 12 l-20 5 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2694 692 l6 -11 -17 -10 -18 -9 9 -9 9 -8 4 13 c3 6 11 12 20 12 17 0 13 22 -7 28 l-13 5 7 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476 681 c-12 -19 1 -25 26 -12 13 6 15 9 6 7 -9 -3 -18 0 -21 7 l-3 11 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310 680 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1956 671 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2495 670 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2630 670 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261 650 l-1 -25 25 -1 c14 -1 25 2 25 7 0 8 -7 10 -27 8 -4 0 -10 8 -14 18 l-8 18 0 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433 663 c-15 -5 -17 -23 -4 -23 5 0 11 7 15 15 3 8 4 15 3 14 -1 0 -8 -3 -14 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 660 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2123 653 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2035 639 c-3 -4 -2 -10 3 -13 11 -7 52 4 52 14 0 10 -49 10 -55 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2364 638 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206 593 c-9 -26 -12 -43 -7 -38 11 13 32 77 27 82 -2 2 -11 -17 -20 -44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1494 628 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444 618 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1933 623 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853 613 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2085 610 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2325 610 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285 600 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2000 590 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230 594 c0 -5 4 -15 9 -23 l9 -13 6 10 c3 5 -1 15 -9 22 -8 7 -15 9 -15 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2160 573 c0 -7 4 -13 9 -13 5 0 11 6 14 13 l5 14 -14 0 c-8 0 -14 -6 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103 560 c-34 -14 -28 -21 7 -9 17 6 30 13 30 15 0 6 -12 4 -37 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1959 513 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 495 c0 -8 7 -15 16 -15 l16 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -4 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208 483 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530 256 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1889 243 l-14 -18 20 15 c11 8 22 16 24 17 2 2 0 3 -6 3 -6 0 -17 -8 -24 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515 210 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655 191 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 190 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2695 190 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2750 190 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055 170 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670 155 l-12 -15 14 0 c8 0 15 7 15 15 0 8 -1 15 -2 15 -2 0 -8 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772 81 c-39 -41 -71 -76 -69 -77 2 -2 36 30 77 71 41 41 72 76 69 77 -2 2 -37 -30 -77 -71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2675 140 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2644 73 c39 -40 72 -70 75 -68 2 3 2 6 0 7 -3 2 -36 32 -74 68 l-70 65 69 -72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 110 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2750 110 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 80 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236 65 c8 -19 14 -19 14 0 0 8 -4 15 -10 15 -5 0 -7 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400 70 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496 68 c3 -4 9 -8 15 -8 5 0 9 4 9 8 0 5 -7 9 -15 9 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930 70 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540 45 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084 38 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f28db9",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1925 2700 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1975 2619 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 2380 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2043 2373 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 2296 c7 -14 13 -23 15 -21 7 6 -9 45 -18 45 -4 0 -3 -11 3 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2075 2290 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1946 2273 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745 2250 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 2223 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 2220 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2006 2217 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830 2205 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1945 2209 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391 2194 c-7 -8 -11 -17 -9 -20 3 -2 13 5 23 16 10 11 14 20 9 20 -5 -1 -15 -8 -23 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 2179 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096 2165 c9 -14 20 -25 25 -25 5 0 -1 11 -13 25 -12 14 -23 25 -25 25 -2 0 4 -11 13 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491 2143 l-11 -28 15 19 c8 11 15 23 15 28 0 15 -7 8 -19 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2004 2158 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 2150 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860 2139 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425 2119 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1940 2121 c0 -5 7 -12 16 -15 l17 -6 -13 15 c-14 17 -20 19 -20 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434 2108 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203 2113 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 2098 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2065 2100 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604 2088 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855 2090 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 2060 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 2066 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 2050 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276 2013 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 2020 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 2021 c0 -5 7 -12 16 -15 l17 -6 -13 15 c-14 17 -20 19 -20 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894 2008 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725 2000 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1983 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849 1974 c-5 -15 -8 -29 -5 -31 2 -2 8 10 14 26 13 38 5 41 -9 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746 1963 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333 1923 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 1893 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974 1898 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1889 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535 1849 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 1838 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 1840 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744 1838 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446 1813 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883 1813 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 1770 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505 1769 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 1730 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 1710 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 1700 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 1665 c4 -8 11 -15 16 -15 l10 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -1 -7 2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395 1640 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350 1640 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2285 1631 c-6 -11 9 -23 19 -14 9 9 7 23 -3 23 -6 0 -12 -4 -16 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 1620 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 1600 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2570 1600 c-20 -12 -5 -24 16 -12 l17 9 -10 6 c-5 3 -15 2 -23 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2627 1594 c3 -7 9 -14 14 -14 14 0 10 17 -5 23 l-15 6 6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 1590 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340 1585 l0 -15 20 0 20 0 0 -17 c0 -9 3 -14 6 -10 4 3 13 -1 22 -9 l15 -15 8 12 8 13 -17 17 -17 16 -7 -11 -8 -11 0 17 0 17 -17 -6 -16 -6 7 11 7 12 -15 0 c-9 0 -16 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652 1578 c-7 -7 -12 -8 -12 -4 0 5 -7 3 -15 -4 -8 -7 -15 -21 -15 -32 0 -10 -7 -21 -15 -24 -8 -4 -12 -10 -9 -15 8 -14 24 -10 24 6 0 8 5 15 11 15 l10 0 -6 20 -6 20 14 0 c8 0 20 7 27 15 15 18 9 20 -8 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695 1580 l-20 -9 14 0 13 -1 -6 -15 -5 -15 14 0 c8 0 15 -4 15 -9 0 -6 -9 -8 -20 -6 -11 2 -20 0 -20 -6 0 -5 11 -9 25 -9 l25 0 0 14 c0 8 -4 18 -10 21 -5 3 -10 12 -9 18 l1 12 5 -12 c2 -7 11 -13 19 -13 l15 0 -7 -12 -7 -13 13 12 14 13 -24 20 c-13 11 -23 20 -24 19 -1 0 -10 -4 -21 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2476 1555 c-3 -8 -1 -15 4 -15 13 0 22 18 11 24 -5 3 -11 -1 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2520 1554 l0 -15 10 6 c6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2624 1546 l-31 -11 4 -12 5 -13 17 10 c10 5 21 6 25 2 7 -6 26 16 26 31 0 9 -6 8 -46 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548 1530 c-20 -11 -39 -24 -42 -28 l-5 -9 24 5 c14 2 23 8 20 12 -3 4 9 10 25 14 17 3 30 10 30 16 0 14 -9 12 -52 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646 1535 c4 -8 10 -12 15 -9 14 8 10 24 -6 24 l-14 0 5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777 1514 c6 -15 23 -19 23 -5 0 5 -7 11 -14 14 l-15 6 6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870 1510 c0 -9 16 -14 23 -8 1 2 17 -7 35 -20 17 -13 32 -19 32 -15 0 9 -71 53 -84 53 -3 0 -6 -4 -6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2363 1513 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 1500 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2215 1500 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2473 1493 c0 -15 19 -12 24 3 2 6 -3 11 -10 11 -8 0 -14 -6 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560 1490 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2275 1490 c-3 -5 3 -18 14 -29 l19 -19 6 14 5 14 -12 -3 -12 -2 3 18 c3 18 -13 24 -23 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2524 1476 c-6 -13 -8 -29 -5 -35 l7 -11 20 16 c10 8 13 13 7 9 -7 -3 -13 -2 -13 4 0 5 5 11 12 13 l12 4 -8 12 c-11 18 -20 15 -32 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 1480 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537 1483 c-11 -11 -8 -20 7 -20 l14 0 -5 14 c-6 15 -7 15 -16 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1656 1482 c-4 -7 -14 -11 -21 -10 -8 2 -15 -1 -17 -7 -2 -5 8 -12 21 -13 l23 -4 -6 11 -7 11 31 -6 30 -6 0 12 0 12 -20 -5 -19 -5 -4 11 -3 11 -8 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 1465 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340 1465 c0 -8 14 -22 31 -30 l30 -16 13 10 c7 6 16 8 19 4 4 -3 7 -1 7 5 0 19 -20 24 -38 11 -9 -7 -14 -9 -10 -5 11 13 -11 36 -33 36 l-19 0 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430 1459 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491 1449 c-13 -10 -18 -19 -11 -19 12 0 45 29 39 35 -2 2 -15 -5 -28 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391 1451 l-13 -9 7 -21 c3 -11 11 -21 16 -21 l10 0 -11 19 -10 19 13 5 c6 2 10 7 7 10 -3 3 -12 2 -19 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1788 1454 c-4 -4 -5 -11 -2 -15 7 -13 34 -11 34 2 0 5 -4 8 -9 5 -5 -4 -11 -1 -13 5 -2 5 -7 7 -10 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1997 1449 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2830 1446 l0 -15 20 2 c24 2 21 21 -3 25 l-17 3 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 1441 c0 -5 7 -12 16 -15 22 -9 24 -8 18 9 -7 16 -34 21 -34 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2613 1428 c2 -7 10 -12 16 -10 6 1 11 -5 11 -13 l0 -15 19 0 c10 0 21 7 25 15 3 8 2 14 -2 13 -4 -1 -20 4 -35 10 -36 15 -40 15 -34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2770 1436 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1846 1415 l-5 -15 -16 6 -15 6 0 -10 c0 -20 15 -21 39 -3 l24 18 -11 7 c-5 3 -12 -1 -16 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2288 1414 c-16 -8 -28 -17 -28 -19 0 -12 30 -3 51 15 28 23 15 25 -23 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2573 1416 l-12 -14 19 -5 19 -5 -2 19 c-1 22 -8 23 -24 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 1410 c-20 -8 -42 -30 -30 -30 13 0 56 24 56 32 0 9 1 9 -26 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700 1410 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 1418 c0 -13 32 -38 41 -33 14 10 10 28 -5 22 -7 -3 -19 0 -25 6 -6 6 -11 8 -11 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 1400 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 1399 c-9 -14 -2 -20 14 -10 l13 9 -10 6 c-6 3 -14 1 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1506 1401 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765 1400 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876 1402 c-3 -6 -1 -14 5 -17 14 -9 20 -2 10 14 l-8 13 -7 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070 1401 c0 -5 7 -12 16 -15 l17 -6 -13 15 c-14 17 -20 19 -20 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2935 1399 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416 1391 l-9 -14 17 -9 c9 -5 14 -13 11 -18 -3 -5 4 -8 15 -7 l21 1 -4 16 -3 15 -16 -3 -16 -3 -4 18 -3 18 -9 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2906 1381 c-3 -5 -16 -7 -28 -3 l-21 5 7 -19 7 -19 -12 13 c-19 18 -36 15 -43 -10 l-5 -23 29 -26 29 -27 5 15 6 14 -9 -6 c-5 -3 -13 0 -16 6 l-7 11 38 39 c21 21 35 39 32 39 -4 0 -9 -4 -12 -9z m-51 -40 c3 -5 1 -12 -4 -15 -5 -3 -11 1 -15 9 -6 16 9 21 19 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 1376 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365 1370 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130 1370 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2362 1371 c2 -7 7 -12 11 -12 12 1 9 15 -3 20 l-12 4 4 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2710 1369 c0 -15 18 -19 23 -6 l5 14 -14 0 c-8 0 -14 -4 -14 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226 1355 l-6 -15 20 10 c23 13 26 20 6 20 -8 0 -16 -7 -20 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 1360 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2280 1355 c-7 -8 -16 -12 -21 -9 -5 3 -9 -2 -9 -10 0 -9 5 -16 10 -16 6 0 10 5 10 10 0 6 7 10 15 10 8 0 15 7 15 15 0 19 -4 19 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 1360 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327 1353 c-10 -10 -8 -33 3 -33 l9 0 -6 17 -6 16 11 -7 12 -7 0 10 c0 12 -13 14 -23 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1551 1351 l-13 -8 10 -7 c6 -3 14 -1 17 5 9 14 2 20 -14 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2752 1341 l3 -16 -18 1 c-10 1 -16 -3 -14 -9 4 -12 47 -21 48 -9 0 4 2 16 3 28 l2 21 -13 0 c-7 0 -12 -7 -11 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2920 1349 c0 -8 5 -21 10 -29 l10 -15 13 16 c6 9 19 18 27 22 l15 5 -22 1 c-12 1 -28 4 -37 7 l-16 6 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 1336 c0 -9 5 -16 11 -16 5 0 7 6 4 13 -4 6 0 4 8 -6 l14 -17 12 13 11 14 -13 0 c-6 0 -20 4 -29 8 l-18 7 0 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 1336 l0 -14 21 5 21 6 -14 8 c-19 13 -28 11 -28 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1914 1325 l-2 -25 24 0 c13 0 24 5 24 10 0 6 -5 10 -11 10 -7 0 -17 7 -23 15 l-11 15 -1 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446 1323 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662 1328 c6 -18 25 -21 25 -3 0 8 -7 15 -14 15 -8 0 -13 -5 -11 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1820 1330 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2575 1331 c-6 -11 9 -23 19 -14 9 9 7 23 -3 23 -6 0 -12 -4 -16 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173 1323 c-15 -5 -17 -23 -4 -23 5 0 11 7 15 15 3 8 4 15 3 14 -1 0 -8 -3 -14 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237 1324 c-12 -12 4 -24 33 -24 29 0 45 12 33 24 -3 3 -12 1 -20 -5 l-13 -11 -13 11 c-8 6 -17 8 -20 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2376 1315 c-3 -8 -1 -15 3 -15 5 0 11 7 15 15 3 8 1 15 -3 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 1320 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2674 1318 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2900 1319 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2965 1319 c-9 -14 -2 -20 14 -10 l13 9 -10 6 c-6 3 -14 1 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2517 1304 l5 -14 -16 0 c-9 0 -16 -5 -16 -10 l0 -11 19 11 c27 14 33 27 16 33 l-14 6 6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250 1306 c0 -2 7 -9 15 -16 l15 -12 0 10 c0 5 -7 12 -15 16 -8 3 -15 4 -15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2805 1300 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385 1291 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2687 1288 c-9 -24 -6 -33 11 -30 23 5 34 25 19 34 -17 11 -24 10 -30 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2892 1289 c2 -7 10 -15 17 -17 l14 -4 -5 13 c-2 7 -10 15 -17 17 l-13 5 4 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176 1275 c4 -8 11 -15 16 -15 l10 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -1 -7 2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685 1280 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 1286 c0 -2 9 -6 20 -9 l20 -5 -6 9 c-5 9 -34 13 -34 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943 1283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115 1270 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313 1265 c-15 -17 -3 -27 17 -15 l15 9 -10 10 -10 9 -12 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417 1265 c3 -8 9 -12 14 -9 12 7 11 11 -5 17 l-15 6 6 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 1270 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795 1269 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843 1273 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885 1270 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2626 1271 c-4 -5 -2 -12 3 -15 5 -4 12 -2 15 3 4 5 2 12 -3 15 -5 4 -12 2 -15 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 1260 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365 1260 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930 1255 c-7 -8 -9 -15 -6 -15 4 0 14 7 22 15 9 8 11 15 6 15 -5 0 -15 -7 -22 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2730 1260 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2347 1249 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2860 1240 c-13 -10 -29 -16 -35 -13 -5 4 -7 3 -3 -2 4 -4 3 -16 -3 -26 l-10 -19 16 0 c8 0 15 -5 15 -12 0 -6 3 -9 6 -6 3 4 1 15 -5 27 l-11 20 11 7 c6 3 16 1 22 -5 16 -16 27 -14 27 6 0 32 15 -6 19 -49 1 -5 7 -7 13 -5 7 1 14 -8 16 -20 l3 -23 -15 0 c-9 0 -16 -4 -16 -10 0 -5 7 -7 15 -4 17 7 19 -4 6 -39 l-9 -24 14 0 c8 0 14 5 15 11 1 17 6 41 14 65 l6 21 -9 0 c-6 0 -8 9 -5 20 l5 20 -17 -7 -18 -6 8 13 8 13 -11 -7 -12 -7 -1 10 c-3 22 -5 27 -19 48 l-16 21 -24 -18z m17 -27 c-4 -3 -7 0 -7 7 0 7 3 10 7 7 3 -4 3 -10 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 1240 c0 -6 -11 -15 -24 -21 l-24 -11 5 -19 c3 -10 10 -19 15 -19 6 0 7 7 4 16 l-6 15 10 -6 c6 -3 10 1 10 9 0 9 5 16 10 16 6 0 10 -5 10 -11 0 -5 5 -7 11 -3 l11 7 -12 7 c-7 4 -9 13 -6 19 4 6 2 11 -3 11 -6 0 -11 -5 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2397 1235 c-7 -16 8 -29 22 -21 5 3 14 -1 21 -9 7 -8 9 -15 4 -15 -5 0 4 -7 20 -15 34 -18 36 -18 36 -5 0 6 -6 10 -14 10 -8 0 -26 16 -42 35 -15 19 -31 35 -35 35 -4 0 -9 -7 -12 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2770 1240 l-15 -10 15 -10 c19 -13 30 -13 30 0 0 6 -5 10 -11 10 -5 0 -7 5 -4 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2970 1241 c0 -7 9 -21 20 -33 11 -12 20 -18 20 -14 0 4 -9 19 -20 33 -11 14 -20 20 -20 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 1220 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333 1224 c-7 -3 -10 -11 -7 -19 l6 -13 -25 2 -25 3 5 -14 6 -14 20 3 21 3 7 28 c4 15 7 27 6 26 -1 0 -7 -3 -14 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 1221 c-8 -6 -18 -7 -24 -4 l-9 6 7 -11 7 -12 20 10 c10 6 19 13 19 15 0 7 -3 6 -20 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 1220 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905 1220 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245 1210 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389 1218 c-1 -2 -3 -13 -4 -25 l-2 -21 12 4 13 5 -5 20 c-5 17 -11 24 -14 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430 1204 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 1210 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1590 1210 c0 -13 11 -13 30 0 l15 10 -22 0 c-13 0 -23 -4 -23 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1973 1213 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990 1190 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1516 1193 l-29 -5 12 -8 c16 -9 51 -1 51 11 0 5 -1 8 -2 8 -2 -1 -16 -4 -32 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595 1191 l-30 -6 12 -8 13 -8 20 11 21 11 15 -12 14 -11 0 10 c0 8 -27 25 -33 21 -1 -1 -15 -4 -32 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727 1189 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1935 1190 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970 1196 c0 -2 9 -6 20 -9 l20 -5 -6 9 c-5 9 -34 13 -34 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2223 1169 l11 -29 8 8 c11 11 0 39 -17 45 l-13 5 11 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673 1183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888 1183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2060 1181 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2175 1180 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2658 1178 c0 -7 -1 -27 -2 -45 l-1 -32 18 -5 17 -4 0 13 c0 8 -5 17 -11 21 -6 3 -9 17 -6 30 2 14 0 27 -4 30 -5 3 -10 -1 -11 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2774 1178 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260 1170 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2733 1165 c4 -8 2 -17 -3 -20 -14 -9 -12 -55 1 -55 l11 0 -5 20 c-3 11 -2 18 3 15 9 -6 18 25 13 43 -3 6 -9 12 -15 12 -6 0 -8 -7 -5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 1155 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994 1138 c-10 -18 -24 -38 -33 -45 l-16 -12 11 -1 c6 0 23 11 38 25 15 14 32 25 38 25 l10 0 -11 13 c-6 8 -8 17 -4 20 3 4 1 7 -5 7 -6 0 -19 -15 -28 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3006 1155 c4 -8 11 -15 16 -15 l10 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -1 -7 2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2505 1150 l-20 -9 23 0 c12 -1 22 4 22 9 0 6 -1 10 -2 9 -2 0 -12 -4 -23 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075 1140 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2163 1133 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 1131 c0 -14 29 -21 36 -9 l7 11 -11 -7 -12 -7 0 10 c0 6 -4 11 -10 11 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2413 1133 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 1130 l-15 -10 13 0 c6 0 12 -8 12 -19 0 -10 8 -25 18 -32 l17 -14 -12 15 c-6 8 -13 27 -15 42 l-3 27 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2520 1120 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2823 1123 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172 1108 l-10 -13 25 -2 c15 0 22 2 17 6 -5 3 -12 10 -15 14 -3 4 -11 2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413 1113 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633 1103 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2370 1105 c0 -2 6 -8 13 -14 l14 -11 0 13 c0 8 -6 14 -14 14 -7 0 -13 -1 -13 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 1090 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094 1088 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 1090 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 1095 c0 -2 7 -8 15 -15 l15 -12 0 14 c0 8 -7 15 -15 15 -8 0 -15 -1 -15 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700 1090 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344 1078 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476 1073 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2826 1082 c-3 -6 -1 -14 5 -17 14 -9 20 -2 10 14 l-8 13 -7 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236 1068 c3 -4 9 -8 15 -8 5 0 9 4 9 8 0 5 -7 9 -15 9 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2682 1068 c5 -15 28 -23 28 -10 0 5 -7 13 -16 16 l-16 6 4 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2976 1065 c-3 -8 -1 -15 3 -15 5 0 11 7 15 15 3 8 1 15 -3 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2233 1063 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 1040 l-11 -20 10 0 c6 0 15 9 21 20 l11 20 -10 0 c-6 0 -15 -9 -21 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2793 1046 l0 -14 23 2 22 1 -10 13 c-14 16 -35 15 -35 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 1029 c0 -15 18 -19 23 -6 l5 14 -14 0 c-8 0 -14 -4 -14 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 1028 c0 -4 12 -8 26 -8 l25 0 -6 9 c-6 11 -45 10 -45 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104 1018 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 1013 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228 992 l-13 -15 27 5 27 5 4 -11 c2 -6 8 -8 12 -3 l9 7 -12 12 c-18 18 -40 18 -54 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2466 1002 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2795 1000 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007 993 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 978 c0 -7 4 -19 9 -27 l9 -13 6 11 7 11 -11 0 c-6 0 -9 4 -5 9 3 5 1 12 -5 16 -5 3 -10 0 -10 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 980 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471 980 c0 -8 4 -24 9 -35 l9 -20 0 15 c0 8 -4 24 -9 35 l-9 20 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2777 961 l-4 -18 12 0 13 0 -6 15 -5 15 11 -7 c6 -3 13 -3 16 2 2 4 -4 8 -14 9 l-18 2 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825 960 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2014 944 c3 -9 6 -19 6 -24 0 -4 6 -10 14 -13 l15 -6 -11 30 c-5 16 -14 29 -20 29 l-10 0 6 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 945 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 950 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 940 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685 940 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 929 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 930 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244 928 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710 909 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764 890 c-12 -5 -25 -13 -28 -18 l-6 -10 20 5 c10 3 25 11 31 19 13 16 12 16 -17 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803 893 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2755 882 c-3 -9 -3 -13 1 -9 4 4 16 0 26 -10 l18 -16 0 11 c0 6 3 17 6 25 l5 15 -25 0 -25 0 -6 -16z m30 -2 c3 -5 4 -10 1 -10 -3 0 -8 5 -11 10 -3 6 -4 10 -1 10 3 0 8 -4 11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 879 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2036 875 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 880 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 868 c-36 -12 -42 -23 -17 -32 l15 -6 -6 10 -6 10 25 10 c14 5 26 12 26 15 0 3 -1 5 -2 4 -2 -1 -18 -6 -35 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 859 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 860 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142 850 c2 -8 14 -16 26 -18 l22 -3 0 18 0 18 -9 -14 -9 -15 -18 15 -17 14 5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2180 849 l0 -10 -12 7 -11 7 7 -11 c4 -6 13 -9 21 -6 8 4 12 10 9 15 -7 12 -14 11 -14 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2276 851 l-20 -8 11 -6 c6 -4 16 0 23 8 14 17 13 17 -14 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2443 847 c-6 -7 -13 -20 -16 -30 l-7 -19 12 5 c7 2 12 11 10 21 l-3 16 21 0 21 0 -6 -10 c-3 -5 -1 -10 4 -10 13 0 14 11 3 25 -11 15 -29 16 -39 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973 843 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 840 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050 839 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2736 828 c-19 -26 -20 -38 -5 -38 l10 0 -7 12 -7 11 11 -7 c7 -4 12 -15 12 -24 l1 -17 14 19 c20 26 19 40 -1 32 l-16 -6 5 20 c3 11 4 20 2 20 -2 0 -11 -10 -19 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 830 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473 833 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 830 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930 826 c0 -13 20 -36 31 -36 4 0 7 9 6 19 -1 11 -9 22 -19 24 l-18 5 0 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2096 824 c-9 -24 -8 -26 14 -14 11 6 18 15 15 21 -9 14 -22 11 -29 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 810 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 805 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476 807 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 810 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2177 813 c-4 -3 -7 -16 -6 -27 l0 -21 10 24 c10 24 8 36 -4 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2254 804 l6 -17 -17 14 -17 14 7 -17 6 -17 -13 5 -14 5 -14 -20 c-8 -12 -18 -18 -21 -14 -4 3 -7 4 -7 0 0 -3 7 -13 16 -21 l15 -16 -10 0 c-6 0 -11 -6 -11 -13 0 -8 7 -14 14 -14 8 0 14 3 13 6 -1 3 4 16 11 28 l12 23 -13 -6 -14 -5 0 16 0 16 13 -5 c8 -3 16 -1 20 5 3 6 13 8 22 4 9 -3 13 -3 9 1 -4 4 -2 13 3 19 l11 13 -17 6 -16 6 6 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2468 793 c-16 -19 -21 -56 -6 -47 5 3 6 10 3 15 -4 5 -2 9 3 9 5 0 12 9 15 20 3 11 4 20 3 20 -2 0 -10 -8 -18 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871 789 c-13 -5 -21 -12 -18 -15 3 -3 14 -1 25 5 11 6 22 7 26 4 3 -3 6 -1 6 5 0 14 -6 14 -39 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 790 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 776 l0 -14 14 5 c7 3 13 9 13 14 0 5 -6 9 -13 9 -8 0 -14 -6 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 780 c-8 -5 -11 -12 -7 -16 4 -4 13 -2 19 4 15 15 7 24 -12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1454 768 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 760 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 761 c0 -5 7 -11 14 -14 l15 -6 -6 15 c-6 15 -23 19 -23 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2064 758 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680 750 c-8 -5 -11 -12 -7 -17 5 -4 12 -1 16 6 5 7 14 10 20 7 6 -4 11 -2 11 3 0 13 -20 14 -40 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2280 744 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 738 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2075 740 l-6 -10 16 6 15 6 -10 -26 -10 -26 16 0 16 0 -6 -15 c-3 -8 -2 -15 3 -15 15 0 21 13 10 26 -6 8 -9 20 -6 28 5 13 -10 36 -24 36 -4 0 -11 -4 -14 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2247 735 c3 -8 9 -12 14 -9 12 7 11 11 -5 17 l-15 6 6 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2680 728 l0 -23 10 15 c13 19 13 30 0 30 -5 0 -10 -10 -10 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430 715 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2325 719 c-10 -15 3 -25 16 -12 l11 11 -10 6 c-6 3 -14 1 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2396 713 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700 710 l-11 -20 11 0 c5 0 10 -7 10 -16 0 -18 22 -14 28 6 l5 13 -11 -7 c-6 -3 -13 -2 -16 3 -4 5 -2 12 4 16 5 3 10 10 10 16 0 16 -19 10 -30 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 708 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240 710 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 700 l-11 -20 15 0 15 0 -2 20 c-1 11 -2 20 -4 20 -1 0 -7 -9 -13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2525 705 c-4 -11 -10 -23 -12 -28 -7 -13 37 -1 50 13 l12 14 -17 -13 -16 -12 -4 23 -4 23 -9 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 701 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2610 706 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472 680 l-12 -20 13 0 c7 0 13 9 14 20 1 11 1 20 0 20 -1 0 -8 -9 -15 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033 675 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106 673 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194 678 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2582 683 c-19 -8 -4 -22 18 -16 11 3 17 9 14 14 -6 10 -12 10 -32 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 669 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080 670 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2323 673 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1946 663 c-11 -11 -7 -20 9 -20 8 0 15 4 15 8 0 11 -16 20 -24 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1980 661 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416 661 c-4 -5 -2 -12 4 -16 6 -4 8 -10 6 -14 -3 -4 1 -8 8 -8 l13 0 -1 20 c-1 22 -21 34 -30 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2513 646 l0 -13 20 1 c29 1 32 21 4 24 l-24 2 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385 640 c-4 -6 -11 -8 -16 -5 l-9 6 6 -15 6 -15 19 12 c10 6 19 15 19 19 0 12 -18 10 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 630 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175 610 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2123 613 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 561 c0 -5 7 -11 14 -14 l15 -6 -6 15 c-6 15 -23 19 -23 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245 530 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 515 c0 -2 9 -9 20 -15 l20 -11 0 16 0 15 -20 0 c-11 0 -20 -2 -20 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1355 480 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 470 c-8 -5 -11 -12 -7 -16 4 -4 13 -2 19 4 15 15 7 24 -12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483 253 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943 253 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 256 c0 -2 7 -9 15 -16 l15 -12 0 10 c0 5 -7 12 -15 16 -8 3 -15 4 -15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 180 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528 183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670 181 c0 -6 4 -12 8 -15 5 -3 9 1 9 9 0 8 -4 15 -9 15 -4 0 -8 -4 -8 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345 170 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415 159 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2212 74 l-13 -14 10 0 c10 0 25 19 20 25 -2 1 -10 -3 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250 55 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241 44 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f6adcd",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1966 2595 c-3 -9 -6 -22 -5 -28 0 -7 5 -1 10 12 5 13 8 26 5 28 -2 2 -6 -3 -10 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 2560 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2000 2406 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970 2380 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 2373 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234 2348 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 2313 l-24 -28 28 24 c15 14 27 26 27 28 0 8 -8 1 -31 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961 2304 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1719 2293 l-14 -18 15 11 c8 6 22 14 30 17 l15 5 -16 1 c-9 1 -23 -7 -30 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 2306 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674 2258 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493 2223 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731 2214 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 2200 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2164 2198 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 2174 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2103 2183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 2144 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041 2144 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123 2143 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2104 2128 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173 2123 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1940 2120 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326 2103 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 2085 c-3 -9 -6 -22 -5 -28 0 -7 5 -1 10 12 5 13 8 26 5 28 -2 2 -6 -3 -10 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 2069 c-7 -11 -10 -23 -7 -25 2 -2 9 7 15 21 14 30 7 33 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885 2080 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404 2078 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910 2047 l-13 -22 19 15 c10 8 20 15 22 16 2 1 -1 4 -5 7 -5 3 -15 -4 -23 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075 2050 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125 2040 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 2040 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424 2038 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1804 2038 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657 2029 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594 2018 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980 2010 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 2000 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414 1958 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980 1948 c0 -4 4 -8 9 -8 6 0 12 4 15 8 3 5 -1 9 -9 9 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 1943 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 1924 c-9 -15 -12 -23 -6 -20 11 7 35 46 28 46 -3 0 -12 -12 -22 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840 1940 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 1929 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 1923 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239 1913 l-24 -28 28 24 c25 23 32 31 24 31 -2 0 -14 -12 -28 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 1910 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 1900 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 1870 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 1868 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414 1858 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457 1853 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674 1818 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765 1820 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 1800 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421 1763 l-11 -28 15 19 c8 11 15 23 15 28 0 15 -7 8 -19 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331 1744 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474 1718 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 1684 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 1678 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2483 1637 l18 -15 -10 -7 c-6 -3 -11 -11 -11 -17 l0 -10 13 11 c8 6 17 7 22 3 4 -4 6 -1 3 7 -2 8 -15 21 -29 29 l-24 14 18 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375 1630 c7 -11 45 -33 45 -26 0 2 -7 12 -16 20 -17 18 -39 22 -29 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2571 1601 l-13 -8 10 -7 c5 -3 12 1 16 9 6 17 6 18 -13 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2653 1603 c-18 -7 -16 -23 2 -23 8 0 15 7 15 15 0 8 -1 15 -2 14 -2 0 -9 -3 -15 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624 1568 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670 1565 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2486 1572 c-3 -5 1 -9 9 -9 8 0 15 4 15 9 0 4 -4 8 -9 8 -6 0 -12 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2651 1551 l-13 -8 12 -8 c13 -8 24 -1 19 14 l-4 10 -14 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580 1540 c0 -6 -4 -8 -10 -5 -5 3 -10 1 -10 -4 0 -13 10 -14 29 -2 l13 9 -11 6 -11 7 0 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633 1543 c-15 -5 -17 -23 -4 -23 5 0 11 7 15 15 3 8 4 15 3 14 -1 0 -8 -3 -14 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 1525 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524 1515 c-10 -8 -14 -15 -8 -15 6 0 17 7 24 15 16 19 9 19 -16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782 1500 c-12 -31 -6 -39 13 -19 l14 14 -9 15 -9 15 -9 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2494 1505 l-6 -15 -22 5 c-11 3 -34 8 -50 11 l-29 7 7 -12 c4 -6 14 -11 22 -11 8 0 14 -4 14 -10 0 -5 7 -10 15 -10 8 0 15 5 15 11 l0 11 13 -11 14 -11 11 25 c6 14 9 25 6 25 -2 0 -7 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2545 1511 c-3 -6 -4 -15 -1 -20 3 -5 -1 -12 -9 -15 l-15 -6 5 -29 5 -30 -21 -6 c-25 -8 -19 -16 16 -19 l26 -3 -5 13 -5 13 17 -5 17 -6 -20 19 c-26 23 -26 45 1 58 l22 11 -13 17 -13 18 -7 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 1500 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250 1484 c0 -8 4 -13 9 -10 5 3 12 -1 15 -10 l6 -16 14 11 c7 6 16 8 19 4 4 -3 7 -1 7 6 l0 13 -14 -5 c-8 -3 -20 1 -26 9 -16 18 -30 18 -30 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 1483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681 1476 l-11 -13 25 0 25 0 -11 13 c-6 8 -13 14 -14 14 -1 0 -8 -6 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581 1463 l-10 -18 -1 13 c0 6 -5 12 -12 12 l-12 0 12 -12 11 -11 -10 -19 -10 -18 11 0 c5 0 10 7 10 15 0 8 4 15 9 15 5 0 11 9 14 20 6 25 1 26 -12 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950 1470 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504 1458 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 1461 c0 -5 7 -11 14 -14 l15 -6 -6 15 c-6 15 -23 19 -23 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815 1449 c-4 -6 -13 -8 -21 -5 l-13 5 6 -15 5 -15 19 17 c19 17 23 24 15 24 -3 0 -8 -5 -11 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2353 1443 c-7 -2 -13 -11 -13 -18 l0 -13 24 11 c13 7 22 15 20 19 -6 9 -13 9 -31 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2763 1435 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2823 1436 l0 -14 14 5 c7 3 10 9 7 14 -8 14 -21 11 -21 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2860 1439 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483 1433 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2586 1431 c-3 -5 1 -11 9 -15 8 -3 15 -1 15 4 0 13 -18 22 -24 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350 1420 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 1420 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2649 1428 c0 -2 -2 -11 -4 -20 l-3 -18 14 0 c16 0 19 26 4 35 -5 3 -10 5 -11 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421 1411 l-13 -9 13 -4 14 -5 -24 -27 c-27 -29 -21 -36 8 -8 33 32 35 73 2 53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646 1406 c3 -9 11 -16 16 -16 13 0 5 23 -10 28 l-12 4 6 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680 1412 c0 -5 7 -9 15 -9 8 0 15 4 15 9 0 4 -7 8 -15 8 -8 0 -15 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875 1401 c2 -9 4 -23 4 -30 l1 -15 13 13 12 14 -13 4 -13 5 10 12 11 13 -14 0 -14 0 3 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1946 1411 c-3 -5 1 -11 9 -15 8 -3 15 -1 15 4 0 13 -18 22 -24 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2281 1411 l-13 -8 10 -7 c5 -3 12 1 16 9 6 17 6 18 -13 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 1400 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 1400 c0 -6 5 -8 11 -5 l10 7 6 -21 c3 -12 10 -21 15 -21 l10 0 -14 22 c-17 25 -38 35 -38 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070 1400 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 1395 c-7 -8 -16 -12 -21 -9 -5 3 -9 -2 -9 -11 l0 -17 -13 5 -14 5 0 -14 c0 -18 11 -18 27 1 7 8 16 12 21 9 5 -3 8 0 7 8 l-3 13 17 -1 16 -2 -5 14 c-3 8 -6 14 -8 14 -1 0 -8 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2690 1402 c0 -17 13 -21 33 -10 l20 10 -6 -16 c-7 -18 8 -32 18 -16 10 16 -14 40 -41 40 -13 0 -24 -4 -24 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130 1375 c13 -14 26 -25 28 -25 3 0 -5 11 -18 25 -13 14 -26 25 -28 25 -3 0 5 -11 18 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2823 1387 c0 -8 6 -14 13 -14 7 0 15 6 18 14 l5 13 -18 0 c-10 0 -18 -6 -18 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490 1375 l-12 -15 10 0 c5 0 15 7 22 15 l12 15 -10 0 c-5 0 -15 -7 -22 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 1370 c0 -5 9 -14 20 -20 11 -6 20 -9 20 -8 0 2 -9 11 -20 21 -11 9 -20 13 -20 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2255 1370 c-4 -6 -10 -8 -14 -6 -4 3 -8 -1 -8 -9 0 -8 4 -12 8 -9 4 2 10 -2 12 -8 l5 -13 1 13 c1 6 1 15 0 18 0 4 5 11 13 15 l13 9 -12 0 c-6 0 -15 -5 -18 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2894 1368 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235 1360 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2515 1361 c-6 -11 9 -23 19 -14 9 9 7 23 -3 23 -6 0 -12 -4 -16 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2992 1354 l-17 -13 30 3 c16 2 31 8 32 13 5 14 -25 12 -45 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204 1348 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 1350 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1973 1353 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2185 1350 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2280 1350 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2560 1350 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2923 1345 c0 -18 19 -15 25 3 2 7 -3 12 -10 12 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483 1335 l0 -13 14 5 c7 3 13 6 13 8 0 2 -6 5 -13 8 l-14 5 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1529 1340 l-11 -7 11 -7 11 -7 0 11 c0 6 4 9 9 5 5 -3 12 -2 15 3 6 10 -19 11 -35 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855 1339 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 1336 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2760 1329 c0 -4 7 -9 15 -13 l15 -5 0 13 c0 7 -7 13 -15 13 -8 0 -15 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2813 1323 l18 -18 9 15 c5 8 7 17 4 19 -3 3 -9 -1 -14 -9 l-10 -15 0 13 c0 6 -5 12 -12 12 l-12 0 17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950 1320 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2023 1323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249 1313 c-1 -4 -1 -11 -1 -15 1 -3 -5 -12 -13 -18 -19 -16 -19 -31 0 -24 8 4 12 10 9 15 -3 5 -1 9 4 9 14 0 23 28 12 35 -6 4 -11 3 -11 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2605 1310 c-3 -5 -3 -10 2 -10 4 0 2 -4 -5 -9 l-14 -8 16 -6 c9 -4 16 -2 16 2 0 5 3 16 6 25 l6 16 -10 0 c-6 0 -14 -4 -17 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2905 1311 l8 -14 -16 6 -17 6 0 -13 c0 -12 20 -26 36 -26 7 0 -2 39 -11 47 l-8 8 8 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150 1295 c0 -8 6 -15 13 -15 8 0 14 7 14 15 0 8 -6 15 -14 15 -7 0 -13 -7 -13 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347 1303 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2073 1295 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9 -1 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2706 1289 c2 -4 -5 -10 -16 -14 -11 -3 -20 -11 -20 -16 0 -13 9 -11 26 6 20 20 34 19 34 -2 l0 -18 9 14 9 14 -11 12 c-12 13 -39 16 -31 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1590 1283 c0 -5 4 -14 9 -22 l9 -13 6 11 7 11 -11 0 c-6 0 -8 5 -5 10 3 6 1 10 -4 10 -6 0 -11 -3 -11 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1647 1283 c-3 -5 10 -8 28 -8 18 0 31 3 28 8 -2 4 -15 7 -28 7 -13 0 -26 -3 -28 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1990 1286 c0 -2 7 -9 15 -16 l15 -13 -6 17 c-3 9 -10 16 -15 16 -5 0 -9 -2 -9 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100 1272 c0 -5 7 -9 15 -9 8 0 12 4 9 9 -3 4 -9 8 -15 8 -5 0 -9 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795 1269 c-4 -6 -5 -12 -2 -15 7 -7 37 7 37 17 0 13 -27 11 -35 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970 1270 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2126 1264 c-9 -22 -8 -23 14 -21 23 2 25 10 6 26 l-14 12 -6 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1878 1263 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2315 1260 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400 1244 l0 -15 10 6 c6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2426 1245 l-5 -15 14 0 14 0 -5 15 c-4 8 -7 15 -9 15 -2 0 -5 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 1239 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2084 1238 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2365 1240 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1230 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2815 1230 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2917 1226 l-6 -16 12 3 12 2 -3 -20 -4 -20 12 12 12 11 -15 22 -15 21 -5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163 1222 l-12 -8 8 -13 9 -13 6 11 c4 6 4 11 -1 11 -4 0 -1 5 7 10 8 5 11 10 5 10 -5 0 -15 -4 -22 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283 1223 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690 1221 c0 -5 7 -11 14 -14 l15 -6 -6 15 c-6 15 -23 19 -23 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1940 1220 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2045 1220 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2880 1220 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005 1210 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387 1206 l-6 -14 16 -6 c9 -4 18 -4 21 -1 3 3 0 5 -7 5 -7 0 -10 4 -6 9 3 5 1 12 -4 15 -5 3 -11 0 -14 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457 1200 l-5 -20 13 0 c7 0 12 7 11 15 -4 24 -13 27 -19 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504 1208 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595 1210 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070 1210 c0 -15 21 -23 32 -12 l9 9 -20 6 c-12 3 -21 1 -21 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2150 1211 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2738 1188 c-16 -17 -28 -33 -28 -35 0 -3 7 -2 16 1 8 3 13 2 10 -2 -2 -4 0 -14 6 -22 l10 -15 -5 17 -6 17 12 5 12 4 -14 1 -14 1 17 19 c10 11 16 24 15 29 -2 6 -16 -4 -31 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 1200 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191 1194 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246 1195 l-5 -14 20 2 c22 2 25 13 5 20 l-14 6 -6 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2825 1200 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3000 1195 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0 -4 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327 1186 l-6 -15 14 6 c8 3 12 9 9 14 -7 12 -11 11 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1614 1188 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 1190 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1840 1190 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1935 1190 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2465 1180 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23 20 -3 0 3 -9 13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2664 1188 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645 1180 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050 1181 c0 -5 7 -11 14 -14 l15 -6 -6 15 c-6 15 -23 19 -23 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2906 1175 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031 1171 l-13 -8 11 -7 c6 -4 8 -13 4 -19 l-7 -12 16 13 c9 8 14 20 11 28 -6 16 -4 16 -22 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067 1163 c3 -7 6 -13 8 -13 2 0 5 6 8 13 l5 14 -13 0 -13 0 5 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2128 1163 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2255 1160 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2834 1158 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 1135 l-12 -25 14 0 c17 0 30 30 18 42 l-9 9 -11 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 1143 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290 1140 c0 -4 11 -10 25 -12 l25 -5 0 11 c0 6 -11 12 -25 12 -14 1 -25 -2 -25 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064 1128 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1823 1133 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 1126 c0 -10 4 -15 9 -12 5 4 12 0 14 -6 l5 -13 1 11 c1 6 -6 17 -14 24 l-15 12 0 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2663 1128 l6 -17 -12 -5 -12 -4 12 -1 c18 -1 27 19 13 32 l-13 12 6 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700 1125 c0 -8 6 -14 13 -12 6 1 11 -4 10 -10 -2 -7 2 -13 8 -13 l11 0 -6 16 c-3 9 -6 20 -6 25 0 5 -7 9 -15 9 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 1120 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2376 1114 l-5 -12 17 2 c9 2 17 7 19 13 5 14 -25 12 -31 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2429 1109 l-11 -21 10 6 c6 3 12 0 15 -6 2 -7 8 -10 12 -6 4 4 3 14 -4 22 l-12 14 13 5 13 5 -12 1 c-7 1 -17 -9 -24 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2935 1121 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2297 1109 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2910 1110 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127 1103 c-10 -9 -9 -23 2 -23 5 0 11 7 15 15 5 15 -5 20 -17 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773 1103 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845 1100 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3000 1101 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 1090 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670 1085 l-12 -15 16 0 c9 0 16 7 16 15 0 8 -2 15 -4 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2283 1073 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2505 1060 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2695 1061 c-3 -5 -1 -12 4 -15 5 -3 11 1 15 9 6 16 -9 21 -19 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2940 1044 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 1036 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 l-10 6 0 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 1030 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2486 1028 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2803 1024 c0 -7 4 -11 9 -8 4 3 8 -2 8 -11 l0 -16 10 6 c15 9 12 19 -8 32 l-19 11 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683 1023 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980 1000 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 989 c0 -5 -4 -7 -10 -4 -5 3 -10 2 -10 -4 0 -5 5 -13 10 -16 6 -3 10 -1 10 5 0 6 4 8 10 5 l10 -6 -6 15 c-7 18 -14 21 -14 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825 990 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1973 993 c-7 -2 -13 -12 -13 -20 l0 -15 14 11 13 11 19 -7 19 -7 -14 17 c-14 18 -18 19 -38 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840 980 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 980 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376 982 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 979 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245 971 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350 970 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845 970 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2465 971 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2815 969 l6 -17 -25 -6 -26 -6 0 -15 c0 -8 2 -15 5 -15 3 0 18 11 33 25 l26 25 -12 12 -13 13 6 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688 963 c-10 -2 -18 -9 -18 -14 l0 -10 18 10 c9 5 21 9 25 9 5 0 11 3 15 6 6 7 -14 6 -40 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220 960 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815 960 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 953 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 949 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 949 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 940 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 930 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2452 928 c2 -6 10 -14 16 -16 l12 -4 -6 16 c-7 18 -28 22 -22 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 919 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 920 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393 923 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2495 920 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 910 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 910 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185 889 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790 889 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2780 885 c-7 -8 -16 -12 -21 -9 -5 3 -9 0 -9 -5 0 -12 27 -10 48 2 14 9 16 27 3 27 -5 0 -14 -7 -21 -15z m20 1 c0 -3 -5 -8 -12 -12 l-11 -7 7 11 c7 12 16 16 16 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 880 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2475 880 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143 863 l0 -13 14 11 c7 6 13 12 13 14 0 1 -6 2 -13 2 -8 0 -14 -6 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845 870 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 871 c0 -6 5 -13 10 -16 l10 -6 0 15 c0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296 855 c-3 -8 -1 -15 3 -15 5 0 11 7 15 15 3 8 1 15 -3 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685 860 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 859 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063 853 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350 850 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953 853 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 840 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 840 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2193 835 l0 -13 14 5 c7 3 13 6 13 8 0 2 -6 5 -13 8 l-14 5 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2769 836 l12 -14 -16 -6 c-9 -3 -14 -10 -11 -15 7 -11 -4 -42 -13 -37 -3 2 -12 -3 -20 -11 l-14 -15 19 4 c18 3 64 71 64 96 0 6 -7 12 -16 12 l-16 0 11 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 833 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 830 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853 833 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2433 821 c0 -11 5 -18 9 -15 4 3 5 11 1 19 -7 21 -12 19 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215 820 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265 820 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1933 804 l0 -26 8 13 8 14 10 -25 10 -25 0 21 c1 12 -6 25 -15 28 -8 3 -12 10 -9 16 3 5 2 10 -3 10 -5 0 -9 -12 -9 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250 819 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2475 820 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360 810 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 810 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 810 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 810 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2115 810 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 791 c-2 -5 4 -11 15 -14 11 -3 20 -2 20 3 0 12 -28 21 -35 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 790 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2076 788 c3 -4 9 -8 15 -8 5 0 9 4 9 8 0 5 -7 9 -15 9 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773 783 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945 780 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 780 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1847 783 c-3 -5 -1 -17 4 -28 l8 -20 0 28 c1 27 -4 34 -12 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628 773 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 770 l-15 -10 28 0 28 0 -6 10 c-8 12 -16 12 -35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260 770 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 770 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663 763 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 759 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 760 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375 760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400 760 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930 760 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2410 760 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087 753 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830 750 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2031 744 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2235 750 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 740 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660 741 c0 -5 9 -11 21 -14 l20 -5 -12 14 c-13 16 -29 19 -29 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625 730 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2180 725 l0 -16 18 3 c21 4 19 22 -2 26 l-16 3 0 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 719 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1937 723 c-4 -3 -7 -15 -7 -25 l0 -18 16 0 16 0 -11 -13 -11 -14 13 0 13 0 0 33 c0 18 -4 30 -8 28 -5 -3 -5 -10 -2 -16 l7 -11 -12 7 c-7 5 -10 14 -7 22 6 15 3 18 -7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2116 716 l7 -19 -11 7 -12 7 0 -10 c0 -5 4 -12 9 -15 14 -9 23 26 11 38 l-11 11 7 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2707 723 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850 704 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2280 712 c0 -5 7 -9 15 -9 8 0 15 4 15 9 0 4 -7 8 -15 8 -8 0 -15 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2640 695 c-13 -14 -18 -25 -12 -25 6 0 14 5 17 10 4 6 10 8 15 5 12 -8 20 9 11 23 l-7 12 -24 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790 700 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2041 694 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2213 703 c-15 -5 -17 -23 -4 -23 5 0 11 7 15 15 3 8 4 15 3 14 -1 0 -8 -3 -14 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2444 703 c3 -6 1 -13 -6 -15 l-12 -4 7 -18 7 -17 11 7 11 7 -12 7 -12 8 13 5 14 5 -14 13 c-8 8 -11 9 -7 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 690 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1558 693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2315 680 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 681 c0 -6 5 -13 10 -16 l10 -6 0 15 c0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 676 c0 -7 7 -13 15 -13 8 0 15 4 15 8 0 4 -7 9 -15 13 l-15 5 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2233 667 c2 -7 12 -14 21 -15 l18 -4 -4 13 c-2 7 -12 13 -22 15 l-17 2 4 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1448 663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 650 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 639 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395 640 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091 614 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 626 c0 -2 9 -6 20 -9 11 -3 20 -1 20 4 0 5 -9 9 -20 9 -11 0 -20 -2 -20 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374 618 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2413 623 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2000 600 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2225 590 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 570 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 559 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186 543 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2060 550 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 540 c-6 -19 -5 -48 2 -44 4 3 8 0 8 -7 0 -7 2 -10 5 -8 2 3 0 18 -4 35 -5 16 -10 27 -11 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145 520 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478 513 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 489 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2073 479 l-2 -21 15 12 c17 15 18 30 1 30 -7 0 -13 -9 -14 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 486 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2045 470 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2775 220 c39 -41 71 -76 73 -79 1 -2 4 -2 7 0 2 3 -30 39 -73 80 l-77 74 70 -75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473 253 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 220 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2665 190 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664 178 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2374 168 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2675 160 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 140 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415 130 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 110 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1550 50 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890 40 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2235 40 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523 33 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f9cee1",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1964 2675 c8 -8 18 -15 22 -15 3 0 1 7 -6 15 -7 8 -17 15 -22 15 -5 0 -3 -7 6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875 2620 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 2363 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 2330 c7 -11 17 -20 22 -20 5 0 1 9 -9 20 -10 11 -20 20 -22 20 -2 0 2 -9 9 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2060 2340 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 2290 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1954 2288 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 2270 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1940 2260 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763 2253 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2170 2209 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797 2168 c-40 -43 -28 -45 13 -3 19 19 30 34 24 34 -5 -1 -22 -15 -37 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 2179 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 2170 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 2158 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 2158 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 2154 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100 2160 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2129 2153 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150 2136 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2084 2108 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 2098 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799 2053 l-24 -26 27 19 c15 10 28 22 28 27 0 12 -5 8 -31 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310 2065 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 2040 c0 -6 4 -9 9 -6 5 4 12 1 14 -4 l6 -10 -3 12 c-3 15 -26 23 -26 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 2030 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 2036 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600 2029 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 2036 c0 -2 7 -9 15 -16 l15 -12 0 10 c0 5 -7 12 -15 16 -8 3 -15 4 -15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790 2029 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 1983 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 1938 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840 1930 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 1915 l-12 -15 10 0 c5 0 12 7 16 15 3 8 4 15 2 15 -2 0 -9 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859 1863 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540 1860 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 1838 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 1839 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904 1828 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 1828 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 1793 l-24 -28 28 24 c25 23 32 31 24 31 -2 0 -14 -12 -28 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 1810 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1730 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 1723 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 1700 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 1691 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 1653 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2292 1638 l-10 -13 7 -19 c4 -11 15 -20 25 -22 l18 -3 -23 25 -24 25 18 -7 17 -6 14 11 c7 6 16 8 19 4 4 -3 7 -1 7 5 0 15 -13 15 -28 0 l-12 -12 0 12 c0 16 -15 15 -28 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 1619 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2505 1620 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415 1600 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2585 1600 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 1590 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707 1576 l-6 -15 15 6 c15 6 19 23 5 23 -5 0 -11 -7 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340 1575 l0 -14 15 5 c8 4 15 7 15 9 0 2 -7 5 -15 9 l-15 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2630 1580 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2498 1569 c-3 -9 -2 -22 2 -30 13 -19 18 -8 10 21 l-6 25 -6 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2530 1564 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2404 1541 c10 -11 15 -25 11 -30 -3 -6 -1 -11 4 -11 14 0 14 27 1 35 -6 4 -8 11 -5 16 4 5 -2 9 -11 9 l-17 0 17 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585 1540 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 1535 c0 -8 7 -15 15 -15 l14 0 -12 15 c-7 8 -13 15 -15 15 -1 0 -2 -7 -2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565 1530 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667 1524 c6 -15 23 -19 23 -5 0 5 -7 11 -14 14 l-15 6 6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2463 1525 c0 -9 4 -14 9 -13 5 2 10 8 10 13 0 5 -5 11 -10 13 -5 1 -9 -4 -9 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2645 1529 c-11 -17 1 -21 15 -4 l12 15 -10 0 c-6 0 -14 -5 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2303 1518 l-22 -11 3 -21 c4 -23 20 -23 43 -1 20 21 4 19 -21 -2 l-20 -18 23 33 c12 17 21 32 19 31 -2 0 -13 -5 -25 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 1509 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715 1510 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787 1513 c-10 -9 -9 -23 1 -23 5 0 9 7 9 15 0 17 -1 18 -10 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890 1499 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2577 1491 l-12 -15 18 7 c10 4 23 7 28 7 5 0 9 4 9 8 0 14 -30 10 -43 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644 1489 c-8 -14 14 -19 25 -6 l11 14 -16 0 c-8 0 -17 -4 -20 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535 1479 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690 1486 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2530 1478 c0 -4 4 -8 9 -8 5 0 13 -9 16 -20 7 -22 25 -18 25 6 0 8 -4 12 -10 9 -5 -3 -10 0 -10 8 0 7 -7 14 -15 14 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2832 1460 c-12 -20 -6 -26 13 -12 12 9 18 32 7 32 -4 0 -13 -9 -20 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425 1460 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1555 1460 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581 1454 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1973 1454 c0 -16 13 -19 21 -5 3 5 0 11 -7 14 l-14 5 0 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2614 1458 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2705 1460 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2730 1466 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400 1450 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 1450 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2329 1444 l-12 -15 11 -11 11 -11 15 16 c20 19 20 23 2 30 -8 3 -20 -1 -27 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684 1438 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2425 1440 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 1430 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524 1428 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603 1433 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2524 1416 l-2 -23 13 0 13 0 -6 15 -5 15 11 -7 c7 -4 12 -5 12 -2 0 3 -8 10 -17 15 l-18 9 -1 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2601 1418 c6 -10 14 -16 19 -13 13 8 2 32 -15 32 l-14 0 10 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 1421 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640 1420 c0 -5 5 -10 11 -10 l11 0 -12 -15 -13 -15 17 6 c18 7 18 7 10 28 -7 18 -24 22 -24 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2466 1414 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566 1408 l7 -11 -17 6 -17 7 6 -9 c3 -6 14 -9 25 -8 l19 1 -11 13 c-13 16 -22 17 -12 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754 1405 c23 -18 36 -19 36 -4 0 5 -4 8 -9 4 -5 -3 -12 -1 -16 5 -3 5 -12 10 -18 10 l-12 -1 19 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1837 1402 l-17 -19 15 0 c8 0 13 3 10 5 -3 3 0 11 6 19 17 20 5 16 -14 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2699 1410 l-11 -7 30 -5 30 -4 -4 11 c-5 13 -27 15 -45 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 1400 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2251 1386 l-23 -25 18 3 c11 2 19 9 19 17 1 8 7 13 14 11 l12 -2 -6 10 c-3 5 -7 10 -9 10 -1 0 -13 -11 -25 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 1400 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2650 1400 l-15 -10 23 0 23 0 -6 10 c-7 12 -6 12 -25 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2821 1401 c-25 -7 -42 -31 -22 -31 6 0 11 4 11 9 0 5 12 11 28 13 15 2 23 6 17 9 -5 3 -21 3 -34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2985 1399 c-9 -14 -2 -20 14 -10 l13 9 -10 6 c-6 3 -14 1 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2100 1390 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340 1392 c0 -5 7 -9 15 -9 8 0 15 4 15 9 0 4 -7 8 -15 8 -8 0 -15 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486 1379 c2 -4 0 -10 -6 -14 -14 -8 -13 -25 2 -25 6 0 8 3 5 7 -4 3 0 14 8 23 l15 17 -15 0 c-8 0 -12 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2610 1376 c0 -9 4 -15 9 -11 5 3 17 -5 25 -17 9 -12 16 -18 16 -12 0 6 -11 21 -25 34 l-25 23 0 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2820 1370 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2884 1371 c6 -10 -18 -34 -26 -26 -2 3 -5 -2 -5 -10 l0 -15 23 21 c13 12 21 26 18 30 -3 5 -7 9 -10 9 -3 0 -3 -4 0 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235 1360 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2154 1358 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430 1366 c0 -9 30 -14 35 -6 l6 10 -20 0 c-12 0 -21 -2 -21 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 1359 c0 -10 23 -17 38 -12 22 8 13 23 -13 21 -14 -1 -25 -5 -25 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215 1350 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 1345 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777 1353 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2186 1348 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 1334 l0 -15 -10 6 c-5 3 -10 1 -10 -4 0 -18 19 -12 30 9 l11 20 -11 0 c-5 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2810 1340 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 1336 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660 1330 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916 1323 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2932 1326 c7 -8 17 -12 22 -9 4 3 2 9 -5 14 -22 13 -31 11 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285 1319 c-10 -15 3 -25 16 -12 l11 11 -10 6 c-6 3 -14 1 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870 1326 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1939 1314 l-10 -12 15 2 c9 1 18 5 22 8 3 4 12 4 20 1 8 -3 14 0 14 6 l0 11 -26 -2 c-14 -2 -30 -8 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2505 1320 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241 1304 c6 -7 16 -11 21 -8 11 7 3 17 -18 20 l-15 2 12 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344 1300 l0 -20 10 10 10 10 -10 10 -10 10 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 1306 c0 -7 6 -19 13 -25 l14 -11 0 15 c0 8 -4 15 -9 15 -5 0 -6 5 -3 10 3 6 1 10 -4 10 -6 0 -11 -6 -11 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2602 1311 l-14 -8 15 -6 c16 -6 27 0 27 15 0 10 -11 10 -28 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2665 1311 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2825 1310 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2776 1293 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2875 1300 c-3 -5 4 -14 16 -20 27 -15 30 -10 8 12 l-18 17 -6 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2803 1293 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523 1277 c5 -15 37 -22 37 -9 0 5 -9 12 -21 15 l-20 5 4 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594 1278 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2027 1283 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2075 1280 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2120 1280 c0 -13 11 -13 30 0 l15 10 -22 0 c-13 0 -23 -4 -23 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396 1268 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815 1270 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2695 1270 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2940 1263 c0 -9 3 -13 7 -10 3 4 13 1 22 -5 l16 -13 -19 23 c-11 12 -21 22 -23 22 -1 0 -3 -7 -3 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 1266 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247 1259 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 1260 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356 1262 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1929 1253 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 1240 c13 -24 17 -25 17 -5 0 8 -6 16 -14 19 l-13 6 10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 1250 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665 1250 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2037 1246 c-3 -8 2 -21 12 -30 20 -19 31 -20 31 -5 0 5 -4 8 -9 5 -5 -3 -14 1 -21 9 l-12 15 16 0 c9 0 16 5 16 10 0 15 -27 12 -33 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2196 1253 c-3 -3 6 -17 20 -30 15 -13 28 -23 29 -21 2 2 -7 15 -20 30 -13 15 -26 24 -29 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2403 1253 c4 -3 -1 -16 -10 -27 l-18 -21 18 14 17 13 0 -11 c0 -6 9 -11 20 -11 l20 0 0 15 c0 8 -7 15 -15 15 -8 0 -15 5 -15 10 0 6 -5 10 -12 10 -6 0 -8 -3 -5 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2650 1251 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 1242 c0 -5 7 -9 15 -9 8 0 15 4 15 9 0 4 -7 8 -15 8 -8 0 -15 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2893 1243 c-7 -2 -13 -9 -13 -14 0 -5 6 -8 13 -6 6 1 11 -4 9 -11 -1 -8 2 -11 7 -8 5 3 7 15 4 26 -3 11 -6 20 -7 19 0 0 -7 -3 -13 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294 1228 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2697 1233 c-4 -3 -7 -13 -7 -21 l0 -14 15 12 c8 7 15 16 15 21 0 11 -14 12 -23 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2790 1222 l0 -14 15 12 c8 7 15 13 15 15 0 1 -7 2 -15 2 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433 1223 c-15 -5 -17 -23 -4 -23 5 0 11 7 15 15 3 8 4 15 3 14 -1 0 -8 -3 -14 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544 1216 c23 -18 36 -20 36 -6 0 6 -4 10 -9 10 -5 0 -18 3 -28 6 l-18 6 19 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685 1220 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755 1220 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1846 1218 c3 -4 9 -8 15 -8 5 0 9 4 9 8 0 5 -7 9 -15 9 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2855 1220 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595 1210 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2144 1211 c4 -5 0 -11 -6 -14 l-13 -4 9 -9 9 -9 4 13 c3 6 9 10 14 7 l9 -6 -6 15 c-3 9 -10 16 -16 16 -5 0 -7 -4 -4 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190 1210 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100 1200 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 1192 c6 -13 13 -22 14 -20 1 1 8 12 16 23 l15 20 -16 -12 -15 -13 -13 13 -13 12 12 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 1202 c0 -7 -7 -12 -15 -12 -8 0 -15 -4 -15 -10 0 -5 4 -10 9 -10 13 0 35 29 27 37 -3 3 -6 1 -6 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277 1203 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713 1193 l0 -13 14 11 c7 6 13 12 13 14 0 1 -6 2 -13 2 -8 0 -14 -6 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2935 1199 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 1184 c-3 -8 -10 -12 -16 -9 -5 3 -10 2 -10 -4 0 -6 -8 -8 -17 -6 -10 3 -2 -2 17 -11 19 -9 36 -16 38 -15 7 3 -1 16 -9 14 -10 -3 -12 11 -2 20 3 4 12 2 20 -4 17 -15 17 -1 -1 16 l-14 14 -6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305 1190 c-8 -13 -1 -24 14 -19 l10 4 -8 14 -8 13 -8 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540 1190 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1945 1190 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2444 1188 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413 1183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510 1179 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 1180 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2227 1184 c-3 -3 1 -13 9 -22 l15 -15 12 13 12 13 -12 -7 -12 -6 -8 15 c-5 9 -12 13 -16 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2950 1171 l0 -12 -12 7 -11 7 8 -12 7 -13 11 11 c6 6 8 14 4 18 -4 3 -7 1 -7 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2650 1160 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2905 1150 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 1139 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 1140 c-8 -5 -11 -12 -8 -16 4 -3 14 1 23 10 18 17 9 21 -15 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2706 1143 c-11 -11 -7 -20 9 -20 8 0 15 4 15 8 0 11 -16 20 -24 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3010 1139 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996 1128 c3 -4 -2 -8 -11 -8 -9 0 -14 -4 -11 -9 8 -13 43 -2 43 13 0 7 -6 13 -13 13 -7 0 -11 -4 -8 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2955 1130 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374 1118 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670 1121 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 1110 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 1101 c0 -8 19 -37 21 -31 0 3 2 12 4 21 l3 16 -14 0 c-8 0 -14 -3 -14 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2730 1100 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3006 1097 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2826 1083 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2930 1071 c0 -6 5 -13 10 -16 6 -4 7 -12 4 -18 l-7 -12 8 8 c5 4 9 16 10 27 l2 20 -14 0 c-7 0 -13 -4 -13 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2983 1073 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 1060 c0 -13 18 -22 24 -11 3 5 -1 11 -9 15 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753 1063 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2153 1053 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2695 1050 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183 1035 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9 -1 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2475 1040 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2793 1033 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673 1023 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785 990 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1969 998 c0 -2 -2 -10 -4 -20 l-3 -16 24 3 c14 1 28 6 32 10 4 4 -4 4 -18 0 l-25 -8 14 17 13 16 -16 0 c-9 0 -16 -1 -17 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2476 985 l-6 -16 11 7 c6 4 15 0 21 -7 l9 -14 -3 19 c-4 25 -24 32 -32 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754 978 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843 975 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970 970 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 970 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 950 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2014 948 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2485 950 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 941 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665 940 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2770 941 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845 930 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 930 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430 930 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 923 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640 900 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1990 895 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2766 902 c-3 -6 1 -13 10 -16 8 -3 12 -11 9 -16 l-7 -11 -16 13 -17 13 12 -16 c7 -9 10 -19 6 -22 -3 -4 1 -7 11 -7 9 0 15 4 11 9 -3 5 -1 12 4 15 12 8 7 39 -6 43 -6 2 -14 0 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785 890 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755 880 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 883 c0 -5 5 -15 10 -23 l10 -15 0 17 c0 9 6 19 13 21 6 3 2 6 -10 6 -13 1 -23 -2 -23 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405 870 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 863 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 860 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 849 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 850 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147 839 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755 840 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2084 838 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2263 835 c0 -6 6 -12 12 -12 6 0 12 6 12 12 0 6 -6 12 -12 12 -6 0 -12 -6 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455 830 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 830 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 830 c0 -5 4 -10 9 -10 6 0 13 5 16 10 l6 10 -15 0 c-9 0 -16 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 820 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630 815 l-12 -15 10 0 c5 0 15 7 22 15 l12 15 -10 0 c-5 0 -15 -7 -22 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685 820 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785 820 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2476 817 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2737 813 l6 -16 -13 8 -13 8 7 -12 c4 -6 12 -9 17 -6 12 8 12 35 -1 35 l-9 0 6 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 809 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367 809 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755 810 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2051 808 c-1 -20 15 -33 24 -18 4 6 11 8 16 5 5 -4 9 0 9 8 0 7 -7 14 -15 14 -8 0 -12 -4 -9 -8 2 -4 0 -10 -5 -13 -5 -4 -12 2 -14 11 l-5 18 -1 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 795 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715 800 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2256 798 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2424 785 c1 -33 16 -33 16 0 0 14 -4 25 -9 25 -5 0 -8 -11 -7 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 790 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 790 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685 790 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2233 785 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 781 c-3 -5 -1 -12 4 -15 5 -3 11 1 15 9 6 16 -9 21 -19 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655 780 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2454 778 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614 768 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 764 c3 -9 9 -12 12 -7 3 4 10 11 15 16 l9 7 -21 0 -21 0 6 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2703 765 l0 -15 14 11 c7 6 13 13 13 15 0 2 -6 4 -13 4 -8 0 -14 -7 -14 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735 760 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400 760 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2275 760 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804 748 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045 730 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2180 708 c0 -37 7 -34 14 5 l5 27 -10 0 c-5 0 -9 -14 -9 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2253 727 l-6 -10 10 6 c6 4 13 0 16 -7 3 -8 1 -16 -6 -19 l-11 -3 15 -6 15 -6 0 27 0 28 -13 0 c-8 0 -17 -5 -20 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400 730 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 720 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2335 720 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700 707 l-13 -22 19 15 c10 8 20 15 22 16 2 1 -1 4 -5 7 -5 3 -15 -4 -23 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 705 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2095 711 c3 -5 -3 -12 -12 -14 l-18 -5 21 -1 c11 0 25 -6 32 -13 l12 -12 -12 27 c-7 15 -17 27 -21 27 -5 0 -6 -4 -2 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2527 713 c-2 -5 -4 -20 -5 -35 l-2 -28 11 0 11 0 -6 16 -6 15 10 -6 c14 -9 12 -32 -2 -38 l-13 -5 11 -1 c6 -1 17 5 23 13 l12 15 -21 21 c-11 11 -18 25 -15 30 4 6 4 10 1 10 -3 0 -7 -3 -9 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134 702 c4 -3 14 -7 22 -8 9 -1 13 0 10 4 -4 3 -14 7 -22 8 -9 1 -13 0 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265 700 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371 701 l-13 -8 11 -7 11 -7 0 11 c0 6 5 8 10 5 6 -3 10 -1 10 4 0 13 -10 14 -29 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957 695 l-18 -13 16 -6 16 -6 -6 9 c-3 5 1 11 7 14 7 2 11 7 8 10 -3 3 -13 0 -23 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2555 700 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1846 692 c-2 -4 -1 -14 5 -22 l9 -15 0 23 c0 23 -5 28 -14 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200 690 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471 677 l-11 -14 13 0 c8 0 14 6 14 14 0 7 -1 13 -2 13 -2 0 -8 -6 -14 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2140 680 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2590 680 c0 -4 9 -10 20 -13 11 -3 20 -2 20 3 0 4 -9 10 -20 13 -11 3 -20 2 -20 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2730 680 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 671 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101 654 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1986 657 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260 659 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2665 660 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185 650 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420 650 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 641 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263 633 l0 -13 14 11 c7 6 13 12 13 14 0 1 -6 2 -13 2 -8 0 -14 -6 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965 640 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2455 640 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540 630 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2367 629 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 610 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084 598 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 600 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2056 591 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2224 588 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175 580 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039 563 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2160 570 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2244 568 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161 536 l-12 -14 11 -7 c7 -4 17 -2 23 4 l11 11 -10 10 -11 11 -12 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 531 c0 -6 5 -13 10 -16 l10 -6 0 15 c0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214 518 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2065 500 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050 470 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070 470 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 460 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 222 c-37 -37 -67 -70 -67 -74 0 -3 31 26 70 66 l69 71 73 -70 73 -70 -70 73 c-38 39 -72 72 -75 72 -3 0 -36 -30 -73 -68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 255 c0 -2 10 -10 23 -16 l22 -12 -14 16 c-13 16 -31 23 -31 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1459 243 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415 230 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870 220 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310 210 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375 210 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1963 183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 170 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 160 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 151 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375 120 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533 103 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560 90 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1940 80 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155 60 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974 48 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073 33 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#fceef4",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1973 2663 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1940 2530 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1907 2509 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1975 2399 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 2383 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 2331 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2183 2283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 2260 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1983 2253 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 2230 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2000 2230 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844 2218 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634 2208 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2173 2213 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 2200 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480 2189 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730 2170 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1963 2143 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 2129 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 2129 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320 2090 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796 2084 c-11 -8 -16 -14 -10 -14 13 0 39 18 34 24 -3 2 -14 -2 -24 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 2070 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 2076 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 2060 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053 2063 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303 2053 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 2040 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 2040 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 2039 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405 2030 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603 2033 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785 2030 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 2010 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545 2000 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570 1989 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703 1983 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1970 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 1970 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243 1973 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 1950 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273 1953 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 1928 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 1910 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605 1910 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175 1880 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933 1863 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 1788 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434 1788 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 1723 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395 1720 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 1680 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325 1680 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2300 1634 l0 -15 -12 7 -11 7 7 -11 c9 -15 33 -5 33 13 0 8 -4 15 -9 15 -4 0 -8 -7 -8 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 1620 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 1611 c0 -5 -3 -18 -6 -28 l-6 -18 11 15 11 15 1 -20 0 -20 8 20 c5 11 6 26 4 33 -6 14 -23 16 -23 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2466 1612 c-3 -5 1 -9 9 -9 8 0 15 4 15 9 0 4 -4 8 -9 8 -6 0 -12 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2615 1610 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2565 1590 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635 1570 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2525 1570 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 1550 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2630 1550 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646 1538 c3 -4 9 -8 15 -8 5 0 9 4 9 8 0 5 -7 9 -15 9 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615 1520 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2255 1520 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2295 1510 c-8 -13 -1 -24 14 -19 l10 4 -8 14 -8 13 -8 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2544 1508 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580 1504 c0 -1 11 -9 24 -17 l24 -16 18 15 19 15 -23 -11 -22 -11 -6 14 c-2 7 -11 14 -19 14 -8 0 -15 -1 -15 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743 1494 c-15 -16 -16 -24 -4 -24 8 0 24 30 19 35 -2 2 -9 -3 -15 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2214 1498 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 1500 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2577 1496 l-6 -15 15 6 c15 6 19 23 5 23 -5 0 -11 -7 -14 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2610 1500 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565 1490 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785 1490 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2484 1488 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250 1480 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430 1480 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2526 1473 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 1469 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2343 1473 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423 1463 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2554 1459 c1 -7 12 -16 24 -20 l22 -8 -12 19 -12 19 -7 -11 -7 -10 -5 11 -5 12 2 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2863 1455 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9 -1 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 1456 c0 -2 9 -6 20 -9 11 -3 20 -1 20 4 0 5 -9 9 -20 9 -11 0 -20 -2 -20 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784 1448 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1984 1448 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2705 1449 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403 1443 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2733 1427 c1 -7 -4 -11 -10 -9 -7 1 -13 -2 -13 -8 0 -14 11 -12 33 4 l18 14 -16 5 -15 6 3 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1419 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643 1423 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1586 1404 l-6 -17 14 12 15 13 12 -8 12 -7 -7 11 c-10 17 -33 15 -40 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895 1410 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944 1408 l-7 -11 11 7 c5 3 12 1 14 -6 l4 -12 7 11 7 11 -15 6 c-8 3 -17 0 -21 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2295 1410 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2524 1408 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2546 1404 c-3 -9 -4 -20 0 -25 3 -5 0 -9 -7 -9 -15 0 -3 -13 15 -16 7 -1 13 5 13 12 0 8 -4 14 -9 14 -5 0 -6 9 -3 20 8 24 0 27 -9 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2784 1408 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310 1400 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763 1395 l0 -13 14 5 c7 3 13 6 13 8 0 2 -6 5 -13 8 l-14 5 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2264 1398 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2455 1400 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2612 1405 c4 -4 3 -14 -3 -21 l-10 -12 9 -6 c6 -3 12 3 15 14 l5 20 -11 7 c-7 3 -9 3 -5 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2846 1398 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875 1390 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2746 1387 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2793 1384 c-3 -8 -1 -20 4 -25 l9 -9 0 25 c0 29 -4 32 -13 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2870 1374 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2975 1379 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2425 1370 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2710 1371 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2000 1360 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2366 1358 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2447 1356 l-7 -17 11 7 11 7 -7 -24 -7 -24 13 12 12 12 -10 23 -9 22 -7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2489 1368 c-7 -24 -4 -38 8 -43 9 -3 18 -3 21 0 3 3 0 5 -7 5 l-12 0 6 20 6 20 -10 0 c-6 0 -11 -1 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2840 1355 c7 -9 15 -13 17 -11 7 7 -7 26 -19 26 l-10 0 12 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3026 1353 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335 1350 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 1350 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560 1350 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2935 1350 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425 1340 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725 1340 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2241 1326 l-12 -14 20 5 c12 3 18 9 15 14 -7 12 -10 11 -23 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224 1322 c4 -3 14 -7 22 -8 9 -1 13 0 10 4 -4 3 -14 7 -22 8 -9 1 -13 0 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473 1323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680 1320 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1963 1323 c-7 -2 -13 -9 -13 -15 l0 -10 14 11 c7 6 21 9 30 5 l16 -6 0 11 c0 11 -25 14 -47 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2745 1320 c-4 -6 -10 -8 -14 -6 -4 3 -8 -1 -8 -8 l0 -14 16 3 c9 2 19 4 22 4 9 1 7 31 -2 31 -4 0 -11 -5 -14 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2966 1314 c-8 -20 -8 -24 2 -24 4 0 8 9 9 20 2 24 -3 26 -11 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 1310 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428 1313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 1310 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2585 1310 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2664 1308 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2780 1310 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283 1303 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 1299 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 1300 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885 1300 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385 1291 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 1279 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683 1283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793 1268 c-1 -11 1 -16 5 -12 4 5 11 12 15 15 5 3 2 9 -5 12 l-14 5 -1 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2117 1277 l-5 -14 14 0 c16 0 19 13 5 21 -5 3 -11 0 -14 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290 1286 c0 -2 7 -9 15 -16 l15 -13 -6 17 c-3 9 -10 16 -15 16 -5 0 -9 -2 -9 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503 1283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2895 1280 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100 1270 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322 1268 l3 -13 -20 3 -20 3 14 -10 c15 -10 41 -4 41 9 0 5 -5 12 -10 15 l-10 6 2 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1550 1270 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2406 1271 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2610 1275 c0 -2 6 -8 13 -14 l14 -11 0 13 c0 8 -6 14 -14 14 -7 0 -13 -1 -13 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2753 1265 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9 -1 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 1262 c0 -5 7 -9 15 -9 8 0 15 4 15 9 0 4 -7 8 -15 8 -8 0 -15 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424 1258 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2935 1260 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670 1250 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905 1250 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2194 1248 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2667 1253 c-12 -12 -7 -22 8 -17 8 4 15 10 15 15 0 11 -14 12 -23 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2874 1248 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2009 1233 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2755 1230 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2900 1230 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755 1220 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005 1210 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326 1207 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394 1212 l6 -11 -20 -6 c-23 -7 -27 -22 -5 -22 8 0 13 3 10 5 -3 3 3 10 12 17 l16 12 -13 8 -13 8 7 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463 1205 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070 1210 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2995 1210 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423 1195 c0 -8 4 -12 9 -9 4 3 8 9 8 15 0 5 -4 9 -8 9 -5 0 -9 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1733 1203 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1804 1188 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860 1192 c0 -5 7 -9 15 -9 8 0 12 4 9 9 -3 4 -9 8 -15 8 -5 0 -9 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2110 1190 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2135 1190 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1180 l-6 -10 20 0 c25 0 27 6 6 13 -8 4 -17 2 -20 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943 1183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005 1180 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050 1179 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2179 1177 c7 -7 22 -12 34 -12 l22 -1 -3 -13 c-1 -7 2 -10 7 -6 14 8 1 37 -14 31 -7 -2 -16 -2 -19 2 -4 3 -14 7 -23 8 l-16 3 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2505 1180 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2663 1175 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2903 1183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3000 1180 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037 1165 c-4 -8 -11 -15 -17 -15 l-11 0 7 12 7 11 -11 -7 c-15 -9 -5 -33 13 -33 8 0 12 4 9 9 -8 13 20 9 36 -4 8 -7 6 -2 -5 12 -11 14 -20 26 -21 28 -1 2 -4 -4 -7 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2076 1158 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2707 1148 c-8 -29 -4 -32 11 -8 l12 19 -9 5 c-5 3 -11 -4 -14 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2295 1150 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 1140 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2933 1125 c7 -14 16 -25 20 -25 5 0 5 5 2 10 -3 6 -1 10 5 10 l11 0 -15 15 c-8 8 -19 15 -24 15 l-10 0 11 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2676 1107 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 1100 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 1100 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2363 1103 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2402 1094 c-14 -16 -5 -18 17 -5 7 5 9 11 5 14 -5 3 -15 -1 -22 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120 1084 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2647 1079 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250 1070 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2930 1070 c0 -5 6 -7 14 -4 8 3 17 1 21 -5 3 -6 11 -11 16 -11 6 0 4 7 -5 15 -16 17 -46 20 -46 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965 1060 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 1060 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243 1063 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743 1063 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2695 1060 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176 1048 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2810 1050 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181 1027 c2 -1 13 -9 24 -17 l20 -15 -14 18 c-7 9 -18 17 -24 17 -6 0 -8 -1 -6 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 1010 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 995 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 980 l-11 -20 14 0 c7 0 13 9 13 20 0 11 -1 20 -3 20 -1 0 -7 -9 -13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 990 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965 990 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 981 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273 974 c-3 -8 -2 -19 3 -24 l9 -9 1 25 c2 27 -4 31 -13 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1833 983 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2814 978 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 970 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1994 968 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714 958 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673 953 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755 950 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640 940 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1985 941 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2775 940 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 924 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 930 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853 933 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 930 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2453 920 c1 -20 27 -29 27 -10 0 6 -5 10 -11 10 -5 0 -7 5 -4 10 3 6 2 10 -4 10 -5 0 -9 -9 -8 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615 920 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020 919 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 913 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 910 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705 910 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200 900 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2787 899 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275 890 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785 890 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1990 891 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303 883 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2085 880 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2445 880 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710 870 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2785 871 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 860 c-8 -5 -13 -10 -10 -11 3 0 13 -2 22 -4 l17 -3 -6 14 c-6 16 -4 16 -23 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103 853 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373 853 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2097 835 c3 -8 9 -12 14 -9 12 7 11 11 -5 17 l-15 6 6 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 836 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725 830 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 830 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2053 827 c0 -8 6 -14 14 -14 l13 0 -11 14 c-6 7 -12 13 -14 13 -1 0 -2 -6 -2 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683 823 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930 826 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2741 818 l-1 -17 19 2 c11 0 17 5 15 9 -3 5 -9 6 -14 3 -4 -3 -11 1 -13 7 l-5 13 -1 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 813 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 810 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655 810 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250 810 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 803 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176 793 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715 800 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 790 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680 796 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2425 790 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 786 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2223 775 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2465 780 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 773 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 773 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2703 773 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 758 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283 763 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374 758 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 750 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 750 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245 749 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660 739 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2706 727 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 720 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 718 c0 -4 4 -8 9 -8 6 0 12 4 15 8 3 5 -1 9 -9 9 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2300 710 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2600 710 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073 692 c0 -12 5 -22 9 -22 11 0 10 12 -2 30 l-9 15 2 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375 700 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970 701 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195 690 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2426 687 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2664 688 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2145 670 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2576 668 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2620 670 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483 663 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2444 658 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415 650 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067 633 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173 603 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297 589 l11 -11 19 11 18 10 -29 1 -30 0 11 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 580 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050 580 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103 553 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045 540 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162 537 l-10 -12 12 -17 12 -17 15 10 14 9 -12 0 -12 0 5 14 c7 19 -11 29 -24 13z m18 -1 c0 -3 -5 -8 -12 -12 l-11 -7 7 11 c7 12 16 16 16 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 529 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248 523 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294 488 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1922 464 l-13 -14 10 0 c10 0 25 19 20 25 -2 1 -10 -3 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 250 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1955 250 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 230 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874 228 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 190 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725 190 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2745 190 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670 150 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660 140 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2840 139 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347 133 c-10 -9 -9 -23 1 -23 5 0 9 7 9 15 0 17 -1 18 -10 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725 110 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396 107 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2750 109 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 100 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213 73 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 l-30 0 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2083 73 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1980 60 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365 50 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885 40 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2240 39 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917 29 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#fce6f0",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295 2380 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2055 2370 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 2350 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 2305 l-12 -15 10 0 c5 0 15 7 22 15 l12 15 -10 0 c-5 0 -15 -7 -22 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 2313 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 2263 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2165 2260 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1924 2238 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2135 2220 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 2195 l-12 -15 10 0 c12 0 26 19 19 26 -2 2 -10 -2 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 2190 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1823 2193 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 2170 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2140 2169 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1614 2148 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865 2150 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765 2140 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953 2143 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 2120 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854 2088 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1840 2075 l-12 -15 10 0 c5 0 15 7 22 15 l12 15 -10 0 c-5 0 -15 -7 -22 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 2070 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895 2070 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 2040 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 2020 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 2000 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 1993 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 1980 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 1978 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 1970 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 1970 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980 1950 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 1940 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 1933 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445 1900 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963 1893 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 1880 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 1840 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455 1839 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733 1833 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 1820 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420 1812 c0 -5 7 -9 15 -9 8 0 12 4 9 9 -3 4 -9 8 -15 8 -5 0 -9 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1520 1800 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 1783 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670 1769 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 1645 c7 -9 15 -13 17 -11 7 7 -7 26 -19 26 l-10 0 12 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1355 1650 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350 1640 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2323 1633 l-12 -4 12 -20 c6 -10 18 -19 26 -19 l14 0 -16 18 c-10 10 -14 22 -10 25 7 8 4 8 -14 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 1613 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2300 1590 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 1583 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665 1580 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723 1565 c0 -8 7 -15 15 -15 7 0 12 5 10 12 -6 18 -25 21 -25 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2523 1563 c4 -3 1 -13 -6 -22 l-12 -16 18 14 c20 15 22 31 5 31 -6 0 -8 -3 -5 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775 1549 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660 1540 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2655 1540 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1824 1525 c26 -20 42 -19 22 0 -8 8 -21 15 -28 15 l-13 -1 19 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2606 1530 c12 -5 25 -13 29 -19 3 -6 11 -11 17 -11 7 0 2 9 -10 20 -12 11 -29 20 -39 19 l-18 0 21 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700 1520 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870 1512 c0 -4 10 -9 22 -9 l23 -2 -15 9 c-18 12 -30 13 -30 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2605 1510 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600 1500 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250 1500 c-13 -9 -7 -14 13 -11 4 0 7 -5 7 -13 0 -8 4 -17 8 -20 4 -2 8 6 8 19 0 13 -3 22 -7 19 -4 -2 -9 0 -11 6 l-3 9 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2537 1503 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310 1489 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 1480 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2840 1480 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 1470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674 1468 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 1476 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2605 1460 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 1450 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745 1450 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2710 1456 c0 -2 7 -9 15 -16 l15 -12 0 10 c0 5 -7 12 -15 16 -8 3 -15 4 -15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1973 1443 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020 1439 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738 1416 c-10 -7 -15 -16 -12 -19 4 -3 13 1 21 9 20 19 13 26 -9 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2753 1423 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320 1410 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1545 1410 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693 1413 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2596 1411 c-8 -12 3 -41 15 -41 5 0 9 5 9 10 0 6 -5 10 -11 10 l-11 0 6 15 c6 16 1 20 -8 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391 1392 l-1 -23 -10 6 c-5 3 -10 1 -10 -4 0 -16 20 -13 26 4 3 8 4 20 1 27 -3 7 -6 3 -6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660 1400 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 1400 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2515 1400 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2943 1403 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480 1390 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 1390 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2984 1388 l-7 -13 8 7 c4 4 15 2 23 -5 l15 -12 -4 14 c-7 20 -26 25 -35 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633 1383 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 1380 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877 1375 c-4 -8 -2 -17 2 -20 5 -2 11 4 14 15 6 23 -8 27 -16 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2410 1374 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2705 1380 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563 1373 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2294 1368 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340 1352 l-25 -25 22 12 c12 6 25 16 28 22 13 20 0 15 -25 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2563 1365 l0 -13 14 5 c7 3 13 6 13 8 0 2 -6 5 -13 8 l-14 5 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930 1360 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2165 1360 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2873 1355 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2930 1350 c8 -5 22 -9 30 -9 l15 0 -20 9 c-27 12 -43 12 -25 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3015 1350 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2842 1341 l-14 -8 14 -6 15 -5 0 14 c0 8 -1 14 -1 14 -1 0 -7 -4 -14 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685 1330 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 1329 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2754 1328 c-5 -7 -9 -22 -11 -33 -1 -11 1 -14 3 -8 3 7 5 15 4 19 -1 4 4 10 11 15 8 4 11 11 7 14 -3 4 -10 0 -14 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2780 1322 l0 -14 15 12 c8 7 15 13 15 15 0 1 -7 2 -15 2 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323 1323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1573 1323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607 1314 c6 -15 23 -19 23 -5 0 5 -7 11 -14 14 l-15 6 6 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1995 1320 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2283 1323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 1320 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2710 1320 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 1310 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15 1 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2060 1310 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2830 1311 c0 -5 7 -12 16 -15 l17 -6 -13 15 c-14 17 -20 19 -20 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 1300 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394 1298 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2625 1297 c4 -8 15 -17 25 -20 l19 -5 5 14 5 13 -15 -6 c-8 -3 -21 0 -29 7 l-15 13 5 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2270 1290 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 1290 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556 1282 c-3 -5 1 -9 9 -9 8 0 15 4 15 9 0 4 -4 8 -9 8 -6 0 -12 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2073 1283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1894 1268 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2935 1270 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600 1255 c-7 -9 -10 -18 -7 -21 3 -3 10 4 17 15 13 25 8 27 -10 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2024 1252 c2 -9 6 -16 9 -14 4 1 14 2 22 2 8 0 15 5 15 12 0 6 -3 8 -6 5 -4 -3 -15 -2 -24 3 l-18 10 2 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2117 1253 c3 -7 6 -13 8 -13 2 0 5 6 8 13 l5 14 -13 0 -13 0 5 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 1250 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 1250 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283 1253 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 1249 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2665 1250 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2753 1253 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 1240 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304 1238 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2864 1239 l-7 -12 11 7 c5 3 13 0 15 -6 l5 -13 1 12 c1 17 -16 25 -25 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416 1225 c-3 -8 -1 -15 3 -15 5 0 11 7 15 15 3 8 1 15 -3 15 -5 0 -11 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2695 1229 c-11 -17 1 -21 15 -4 l12 15 -10 0 c-6 0 -14 -5 -17 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1694 1218 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 1220 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2785 1220 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194 1208 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245 1210 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420 1210 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1555 1210 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2935 1210 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276 1194 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 1199 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304 1188 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456 1192 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360 1180 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580 1180 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230 1171 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2485 1170 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3000 1169 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035 1159 c-4 -6 -14 -8 -24 -4 l-16 6 13 -12 12 -13 17 17 c10 9 14 17 11 17 -4 0 -10 -5 -13 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2185 1160 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2656 1162 c-2 -4 -1 -14 5 -22 l9 -15 0 23 c0 23 -5 28 -14 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2943 1159 c-6 -6 -9 -18 -6 -25 8 -22 18 -16 19 11 1 14 1 25 0 25 -1 0 -7 -5 -13 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2285 1150 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340 1140 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2403 1130 c-1 -11 2 -20 7 -20 4 0 7 7 6 15 -3 23 -12 26 -13 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135 1130 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2195 1130 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383 1123 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2253 1123 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2980 1120 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 1110 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2355 1110 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125 1100 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 1101 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 1092 l0 -11 -15 5 -15 6 0 -11 c0 -6 6 -11 14 -11 17 0 31 18 22 27 -3 4 -6 1 -6 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2514 1088 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395 1080 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3010 1080 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 1070 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 1060 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2490 1061 c0 -6 5 -11 11 -11 5 0 8 -4 5 -9 -3 -5 1 -12 9 -15 l15 -6 -10 20 c-12 23 -30 35 -30 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2935 1060 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193 1053 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 1030 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 1001 l0 -10 -17 6 -16 6 9 -14 c4 -8 10 -23 11 -33 2 -11 6 -22 10 -25 3 -3 3 4 0 17 l-5 22 14 15 14 14 -10 6 c-5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970 990 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705 960 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895 960 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973 963 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2505 960 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 949 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 950 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2815 950 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 940 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675 940 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2025 930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 920 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 920 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813 923 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1990 899 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 884 l0 -15 10 6 c6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405 870 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 870 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 863 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303 863 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670 862 c0 -5 7 -9 15 -9 8 0 12 4 9 9 -3 4 -9 8 -15 8 -5 0 -9 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 859 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2225 860 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383 853 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853 853 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 850 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155 850 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2105 830 c-10 -11 -15 -23 -12 -27 4 -3 7 -1 7 5 0 7 5 11 11 10 6 -2 13 5 14 15 2 9 2 17 1 17 -2 0 -11 -9 -21 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 820 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1947 817 l-5 -14 13 0 13 0 -5 14 c-3 7 -6 13 -8 13 -2 0 -5 -6 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 800 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660 800 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 800 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725 800 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 801 c0 -6 4 -12 8 -15 5 -3 9 1 9 9 0 8 -4 15 -9 15 -4 0 -8 -4 -8 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2226 793 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 799 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 793 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 792 l0 -11 -17 5 -18 6 15 -11 15 -10 9 9 c5 5 7 13 3 17 -4 3 -7 1 -7 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2055 790 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 780 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093 783 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 781 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 780 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430 770 c0 -5 7 -10 16 -10 l15 0 -6 10 c-3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2114 768 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654 758 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 760 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 760 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2212 761 l-14 -8 14 -6 15 -5 0 14 c0 8 -1 14 -1 14 -1 0 -7 -4 -14 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415 760 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403 753 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693 753 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2060 751 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675 740 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2180 741 c0 -5 7 -12 16 -15 l17 -6 -13 15 c-14 17 -20 19 -20 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2436 734 c-11 -7 -18 -16 -15 -18 2 -2 13 2 23 10 11 7 18 16 15 18 -2 2 -13 -2 -23 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2683 736 l0 -14 14 5 c7 3 10 9 7 14 -8 14 -21 11 -21 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625 720 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114 708 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193 713 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2275 710 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2515 710 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574 698 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 690 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2396 691 l-20 -8 11 -6 c6 -4 16 0 23 8 14 17 13 17 -14 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 690 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1584 678 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2210 686 c0 -2 7 -9 15 -16 l15 -12 0 10 c0 5 -7 12 -15 16 -8 3 -15 4 -15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2042 675 c4 -4 3 -16 -2 -25 l-10 -18 14 -11 14 -12 5 15 c4 9 2 18 -4 21 -5 4 -7 10 -4 15 3 5 0 12 -7 16 -7 4 -10 4 -6 -1z m15 -42 c-4 -3 -10 -3 -14 0 -3 4 0 7 7 7 7 0 10 -3 7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2112 671 l-14 -8 14 -6 15 -5 0 14 c0 8 -1 14 -1 14 -1 0 -7 -4 -14 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 665 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2263 663 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2555 660 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960 650 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2054 588 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176 573 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050 540 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159 533 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2010 531 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233 523 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 510 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1945 500 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2076 501 l-20 -8 22 -5 22 -6 0 14 c0 8 -1 14 -2 13 -2 0 -12 -4 -22 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364 478 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1863 453 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2635 220 c-38 -38 -65 -70 -59 -70 5 0 41 32 79 70 38 39 65 70 59 70 -5 0 -41 -31 -79 -70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2410 240 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673 183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728 183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2748 183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 162 c0 -7 -7 -12 -15 -12 -8 0 -15 -4 -15 -8 0 -5 7 -9 15 -9 15 0 30 26 20 35 -3 3 -5 0 -5 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 144 c0 -5 32 -41 70 -79 39 -38 70 -65 70 -59 0 5 -31 41 -70 79 -38 38 -70 65 -70 59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2410 140 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2775 80 c-38 -38 -67 -72 -64 -74 3 -3 36 26 74 64 38 38 67 72 64 74 -3 3 -36 -26 -74 -64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105 120 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 113 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2753 113 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960 106 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510 70 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870 70 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2073 73 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 60 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1883 43 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2167 39 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2243 43 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2393 33 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f285b5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1890 2700 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964 2588 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1914 2568 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1900 2520 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 2343 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 2333 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 2327 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 2303 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1703 2283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2170 2260 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1934 2248 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433 2223 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644 2218 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2140 2220 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1892 2184 c-12 -18 -22 -37 -22 -41 0 -4 12 10 26 30 14 21 24 40 22 42 -2 2 -13 -12 -26 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394 2188 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474 2188 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509 2173 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1915 2164 c-9 -15 -12 -23 -6 -20 11 7 35 46 28 46 -3 0 -12 -12 -22 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2140 2170 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 2158 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 2160 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764 2138 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034 2128 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480 2120 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 2110 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 2078 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320 2080 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803 2083 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839 2073 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895 2070 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 2070 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1590 2070 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 2049 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 2053 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880 2040 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 2038 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 2040 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 2028 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776 2023 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953 2033 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 2028 c0 -4 6 -8 14 -8 8 0 17 4 20 8 2 4 -4 8 -15 8 -10 0 -19 -4 -19 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784 2028 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444 1998 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 1990 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570 1990 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213 1943 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 1930 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 1930 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5 0 -17 -5 -25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610 1910 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 1910 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003 1913 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1454 1898 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 1889 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874 1878 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163 1883 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 1853 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 1850 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1525 1819 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420 1810 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673 1773 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324 1728 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400 1720 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1700 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 1700 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 1650 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2305 1641 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2385 1630 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2494 1631 c4 -5 0 -11 -6 -14 l-13 -4 8 -9 8 -8 9 14 c13 20 12 30 -1 30 -5 0 -8 -4 -5 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 1613 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2660 1601 c0 -6 -8 -11 -17 -11 l-17 0 11 -11 12 -12 15 16 16 16 -10 6 c-5 3 -10 1 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722 1576 l18 -13 -22 -10 -22 -9 18 -7 17 -7 -6 10 c-3 6 1 10 9 10 9 0 16 4 16 8 0 12 -22 32 -34 32 -6 0 -3 -7 6 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2657 1547 l-5 -14 12 0 c7 0 13 6 13 14 0 7 -4 13 -8 13 -4 0 -9 -6 -12 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2464 1535 l20 -15 -13 0 -12 0 7 -11 7 -11 7 13 c11 17 1 39 -19 39 l-16 -1 19 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2627 1543 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1825 1530 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618 1523 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526 1512 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745 1510 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865 1510 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 1513 c0 -12 60 -37 60 -25 0 4 5 0 10 -8 l10 -15 0 19 0 18 -15 -6 -15 -5 0 10 c0 6 -6 9 -14 6 -7 -3 -19 0 -25 6 l-11 11 0 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783 1485 c-19 -21 -16 -27 7 -13 11 7 20 16 20 20 0 12 -14 9 -27 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465 1470 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2278 1473 c6 -2 9 -10 6 -15 l-7 -11 12 7 c13 9 5 26 -12 25 l-12 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2372 1471 c2 -7 7 -12 11 -12 12 1 9 15 -3 20 l-12 4 4 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2849 1472 l13 -10 -13 -4 -13 -4 16 -6 16 -7 -2 17 c-2 9 -9 18 -17 20 l-14 4 14 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2345 1450 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2746 1452 c-3 -5 1 -9 9 -9 8 0 15 4 15 9 0 4 -4 8 -9 8 -6 0 -12 -4 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 1430 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 1426 l10 -10 11 11 12 12 -21 -2 -22 -1 10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2606 1424 l-6 -17 15 13 c17 14 19 20 6 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684 1408 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755 1410 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2685 1410 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447 1399 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1506 1395 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0 -6 -7 -10 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2540 1390 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2596 1385 c4 -8 11 -15 16 -15 l10 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -1 -7 2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2823 1393 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2998 1393 c6 -2 12 -12 12 -21 l0 -16 12 12 13 13 -15 9 c-8 5 -19 9 -25 9 -5 0 -4 -3 3 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2406 1381 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881 1364 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2256 1371 c-3 -5 2 -15 12 -22 l17 -14 -12 16 c-7 9 -10 19 -6 22 3 4 4 7 0 7 -3 0 -8 -4 -11 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2746 1372 c-2 -4 -1 -14 3 -21 l8 -13 6 16 c6 16 -8 32 -17 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2533 1363 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2173 1353 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2565 1350 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 1330 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2650 1330 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2781 1324 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188 1323 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 1308 c-14 -14 -16 -28 -3 -28 9 0 24 30 18 36 -2 2 -9 -2 -15 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2747 1309 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904 1298 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665 1290 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2410 1273 c0 -14 3 -23 7 -19 10 10 11 46 1 46 -4 0 -8 -12 -8 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2890 1290 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463 1275 l-13 -14 10 -6 c6 -3 13 1 16 10 9 21 2 26 -13 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2735 1280 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125 1260 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199 1253 l-14 -18 20 15 c11 8 22 16 24 17 2 2 0 3 -6 3 -6 0 -17 -8 -24 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310 1266 c0 -2 7 -9 15 -16 l15 -12 0 10 c0 5 -7 12 -15 16 -8 3 -15 4 -15 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2933 1263 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 1250 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2150 1251 c0 -5 7 -12 16 -15 l17 -6 -13 15 c-14 17 -20 19 -20 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2520 1240 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2699 1223 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2760 1224 l0 -12 20 5 c11 3 20 8 20 12 0 4 -9 7 -20 7 -11 0 -20 -6 -20 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2855 1230 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020 1215 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 1219 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1550 1216 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040 1210 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2413 1213 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283 1203 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353 1203 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2075 1200 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 1190 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684 1188 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233 1183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2053 1183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3000 1180 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2490 1169 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 1159 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045 1160 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2930 1150 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2717 1133 c3 -7 6 -13 8 -13 2 0 5 6 8 13 l5 14 -13 0 -13 0 5 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133 1133 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2943 1123 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998 1113 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2980 1110 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033 1103 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2335 1100 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913 1083 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945 1080 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3010 1080 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2263 1073 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670 1076 c0 -2 7 -9 15 -16 l15 -13 -6 17 c-3 9 -10 16 -15 16 -5 0 -9 -2 -9 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2825 1070 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963 1053 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2510 1039 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2805 1040 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273 1033 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2825 999 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 996 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273 985 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2810 950 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283 925 l0 -13 14 5 c7 3 13 6 13 8 0 2 -6 5 -13 8 l-14 5 0 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 923 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2453 915 c0 -13 44 -18 51 -6 3 5 -7 11 -22 13 l-29 4 0 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2776 921 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 l-4 13 -8 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084 898 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2133 883 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 880 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 863 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2477 863 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 849 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 850 c-8 -5 -12 -11 -9 -14 2 -3 11 -1 19 4 8 5 12 11 9 14 -2 3 -11 1 -19 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2233 853 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2780 850 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2054 838 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2283 835 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 829 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573 823 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 810 c-10 -11 -14 -20 -9 -20 5 0 15 9 22 20 7 11 11 20 9 20 -2 0 -12 -9 -22 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271 814 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765 810 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 800 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970 800 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1955 800 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 800 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2175 799 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2203 786 l0 -14 14 5 c7 3 10 9 7 14 -8 14 -21 11 -21 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163 783 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745 770 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2716 773 c6 -4 14 -15 17 -23 l7 -15 -3 19 c-1 11 -9 21 -17 23 l-15 5 11 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 760 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2223 757 c0 -8 6 -14 14 -14 l13 0 -11 14 c-6 7 -12 13 -14 13 -1 0 -2 -6 -2 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2695 751 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 738 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2180 740 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 730 l-15 -10 18 0 c9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2189 713 l-14 -16 23 12 c23 12 28 21 13 21 -5 0 -15 -7 -22 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125 710 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2275 710 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2704 708 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265 700 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1583 703 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2235 700 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1982 680 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2655 690 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1930 679 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2520 670 l-11 -20 15 0 15 0 -6 17 -6 16 13 -8 13 -8 -7 11 c-10 16 -14 15 -26 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2702 681 l-14 -8 18 -7 17 -7 11 12 11 12 -12 -7 c-6 -3 -13 -2 -15 4 l-3 9 -13 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230 671 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2593 673 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2625 670 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2436 655 c4 -8 11 -15 16 -15 l10 0 -12 15 c-7 8 -14 15 -16 15 -2 0 -1 -7 2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2554 658 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2668 653 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096 633 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 596 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1993 553 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145 530 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223 523 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 510 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433 503 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944 498 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2645 218 l-70 -73 73 70 c67 64 77 75 69 75 -1 0 -34 -33 -72 -72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965 240 c21 -24 26 -25 19 -6 -3 8 -13 17 -22 21 l-16 6 19 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 210 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760 190 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 190 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344 158 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2695 159 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2661 137 l-13 -22 18 17 c10 10 16 20 13 22 -3 3 -11 -5 -18 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 80 c38 -38 72 -70 74 -70 3 0 -26 32 -64 70 -38 39 -72 70 -74 70 -3 0 26 -31 64 -70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660 140 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 140 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2775 78 l-70 -73 73 70 c67 64 77 75 69 75 -1 0 -34 -33 -72 -72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100 130 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760 110 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 110 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 90 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1915 70 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2160 50 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 40 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 40 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f6b5d2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360 2310 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2144 2228 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594 2078 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395 2030 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064 1968 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 1950 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394 1938 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 1930 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890 1920 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954 1888 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530 1830 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414 1798 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 1710 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 1676 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2620 1610 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2347 1599 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2636 1591 c-3 -5 1 -11 9 -15 8 -3 15 -1 15 4 0 13 -18 22 -24 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731 1573 c16 -27 29 -30 29 -6 0 9 -3 13 -7 10 -3 -4 -13 -1 -21 6 l-15 12 14 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380 1578 c1 -21 28 -51 39 -43 17 10 13 26 -5 23 -10 -2 -19 3 -22 11 l-5 14 13 -8 13 -8 -7 11 c-10 16 -26 15 -26 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673 1573 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2485 1562 c3 -3 0 -11 -6 -18 l-10 -12 12 -8 12 -7 -7 12 -7 11 15 6 c20 8 21 21 1 21 -8 0 -13 -3 -10 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 1548 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2663 1553 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693 1543 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2631 1536 l-12 -15 19 -10 19 -10 -2 19 c-2 28 -10 33 -24 16z m19 0 c0 -3 -5 -8 -12 -12 l-11 -7 7 11 c7 12 16 16 16 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 1530 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1823 1533 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674 1518 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260 1505 l0 -17 -15 12 c-9 7 -18 10 -21 7 -3 -3 4 -10 15 -17 l21 -11 6 16 c4 9 4 19 0 22 -3 4 -6 -2 -6 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375 1510 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2585 1500 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795 1490 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 1490 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2443 1493 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633 1483 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950 1469 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2365 1470 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 l-15 0 6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2550 1470 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2710 1460 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650 1450 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2565 1450 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2760 1450 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2830 1449 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2303 1423 l-1 -26 8 13 c4 7 12 10 18 6 6 -3 14 -1 18 6 l7 13 -8 -8 c-5 -4 -15 -1 -24 7 l-16 15 -2 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400 1438 c0 -4 4 -8 9 -8 6 0 12 4 15 8 3 5 -1 9 -9 9 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2730 1439 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2829 1417 c6 -8 7 -18 3 -22 l-7 -8 13 7 13 8 -12 14 c-6 8 -14 14 -16 14 -3 0 0 -6 6 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320 1409 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593 1413 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1863 1413 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2605 1410 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2453 1403 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2520 1400 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815 1390 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2360 1390 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425 1380 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1503 1383 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765 1380 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2790 1380 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2865 1381 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3015 1380 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843 1363 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1935 1360 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 1350 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 1340 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2756 1337 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2825 1340 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2943 1343 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1586 1331 c-4 -5 1 -8 9 -7 21 3 31 16 12 16 -9 0 -18 -4 -21 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 1334 c0 -13 18 -39 24 -34 2 3 -2 14 -10 24 -8 11 -14 16 -14 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2205 1330 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 1329 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335 1320 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665 1320 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1993 1323 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 l-30 0 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2064 1318 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156 1303 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405 1310 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615 1310 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 1307 l0 -17 18 0 17 0 -10 8 c-5 4 -13 11 -17 16 l-8 9 0 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2370 1300 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2614 1298 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2665 1300 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2960 1300 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515 1291 c-3 -5 -1 -12 5 -16 l10 -6 0 15 c0 18 -6 21 -15 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675 1290 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2690 1289 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570 1280 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2633 1271 c1 -20 17 -23 29 -6 l8 10 0 -12 c0 -7 5 -13 12 -13 l11 0 -18 20 c-10 11 -24 20 -31 20 l-13 0 2 -19z m24 2 c-4 -3 -10 -3 -14 0 -3 4 0 7 7 7 7 0 10 -3 7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855 1270 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2015 1270 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130 1270 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2431 1271 l-13 -8 10 -7 c5 -3 12 1 16 9 6 17 6 18 -13 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456 1258 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495 1260 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596 1243 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 1250 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094 1238 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1983 1243 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2176 1242 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0 -11 -4 -14 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054 1228 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2433 1233 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2761 1224 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860 1220 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425 1210 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543 1213 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1983 1213 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2193 1196 l0 -14 14 5 c7 3 10 9 7 14 -8 14 -21 11 -21 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1955 1190 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 1180 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510 1180 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585 1180 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2727 1170 c-9 -11 -17 -22 -17 -23 0 -2 7 -4 15 -4 8 0 13 3 10 5 -3 3 0 11 7 19 6 7 9 15 6 18 -2 2 -12 -5 -21 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503 1173 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3003 1173 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 1160 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2210 1160 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2654 1158 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2910 1150 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167 1139 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624 1138 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2295 1140 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3013 1143 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670 1120 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 1109 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465 1110 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2405 1110 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2725 1110 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 1098 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143 1103 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2830 1100 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2940 1100 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905 1090 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2343 1093 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 1069 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2936 1071 l-6 -9 20 5 c23 6 26 13 6 13 -8 0 -17 -4 -20 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2833 1063 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 1020 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465 1020 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2825 1010 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2485 990 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 970 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 950 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 938 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723 943 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1991 934 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 920 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2023 923 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653 913 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 904 l0 -15 10 6 c6 4 8 11 5 16 -9 14 -15 11 -15 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 909 c0 -11 27 -12 34 -1 2 4 -4 9 -15 9 -10 1 -19 -2 -19 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237 903 c-4 -3 -7 -13 -7 -22 l1 -16 10 18 c11 19 8 33 -4 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845 900 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1990 905 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25 -5 8 -10 11 -10 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2226 902 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2764 898 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 880 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340 880 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 870 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 850 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 849 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2758 843 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464 828 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 821 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784 818 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2184 818 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2254 818 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217 813 c-4 -3 -7 -11 -7 -17 l0 -10 12 12 c6 6 9 14 7 17 -3 3 -9 2 -12 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 793 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623 793 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480 790 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1823 793 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 790 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2193 780 c2 -11 6 -22 10 -26 3 -4 4 3 2 16 l-4 22 15 -6 15 -6 -6 10 c-3 6 -13 10 -21 10 l-14 0 3 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864 778 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785 780 c-3 -5 -13 -7 -23 -4 l-17 6 14 -10 c15 -11 41 -5 41 9 0 12 -7 11 -15 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845 781 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2265 770 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 759 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 760 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2418 763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 750 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360 749 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475 740 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144 728 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 718 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2325 719 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2423 723 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154 708 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853 705 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965 710 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2223 703 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2496 687 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2145 680 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2203 683 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2625 670 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033 655 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723 663 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184 648 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1935 650 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2403 653 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 640 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220 640 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2060 635 l-13 -15 17 6 c9 3 16 10 16 15 0 13 -6 11 -20 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403 625 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320 619 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 610 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310 590 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2055 580 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171 554 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005 560 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144 518 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175 521 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020 510 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090 500 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373 483 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 250 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2684 188 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543 183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 140 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 140 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2664 138 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523 103 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f5a5c8",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1894 2188 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1934 2188 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874 2158 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1914 2158 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1994 2148 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1794 2078 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1454 2008 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264 1998 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 1947 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135 1900 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1800 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613 1783 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 1620 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2324 1601 l0 -20 13 11 c7 6 10 14 7 19 -9 15 -20 10 -20 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2484 1608 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2634 1588 l-7 -11 11 7 c5 3 12 1 14 -6 l4 -12 7 11 7 11 -15 6 c-8 3 -17 0 -21 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740 1560 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2384 1548 c-3 -4 5 -5 17 -3 30 6 36 14 9 12 -12 -1 -24 -5 -26 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 1546 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0 -15 -2 -15 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2630 1543 c0 -5 5 -15 10 -23 l9 -15 -2 23 c0 12 -5 22 -9 22 -4 0 -8 -3 -8 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503 1533 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605 1519 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700 1516 c3 -3 18 -7 34 -10 16 -3 25 -2 22 1 -4 4 -19 9 -34 11 -15 2 -24 1 -22 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850 1516 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2373 1513 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2580 1510 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415 1500 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 1490 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684 1478 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730 1478 c0 -9 8 -22 18 -29 l17 -14 -15 19 c-8 11 -13 21 -12 23 2 3 1 7 -2 11 -3 3 -6 -2 -6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923 1483 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310 1480 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2550 1480 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965 1470 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2382 1468 l3 -13 -21 1 -20 0 -1 -20 c-1 -12 1 -15 4 -8 3 6 8 10 13 7 4 -2 15 4 24 14 l17 19 -11 7 -10 6 2 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2855 1470 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2515 1460 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2405 1449 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375 1440 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2015 1440 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2835 1440 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2863 1443 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2310 1430 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2584 1428 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445 1419 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 1420 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2640 1419 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2684 1418 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323 1413 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1853 1413 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2835 1410 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723 1403 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1963 1403 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2713 1403 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2336 1383 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2514 1388 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880 1380 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2360 1380 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2870 1380 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3012 1385 c4 -4 3 -14 -3 -22 l-11 -13 10 0 c15 0 23 28 9 36 l-12 7 7 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2395 1370 l-6 -10 16 0 16 0 -6 10 c-3 6 -8 10 -10 10 -2 0 -7 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2755 1370 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2833 1373 c-7 -3 -13 -9 -13 -14 0 -6 5 -7 11 -3 6 3 15 0 20 -7 5 -8 9 -9 9 -4 0 18 -15 32 -27 28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2165 1360 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2493 1363 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324 1348 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2043 1353 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2275 1350 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221 1334 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730 1341 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430 1346 c0 -2 7 -9 15 -16 l15 -13 -6 17 c-3 9 -10 16 -15 16 -5 0 -9 -2 -9 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2573 1335 c0 -8 3 -13 5 -10 3 3 17 -2 31 -11 l26 -17 -24 27 c-28 30 -38 33 -38 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2939 1348 c-6 -21 -5 -38 1 -38 5 0 8 9 7 20 -1 17 -5 26 -8 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603 1333 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660 1330 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333 1323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 1320 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2383 1323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2705 1320 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2895 1320 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405 1310 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2830 1310 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786 1295 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145 1290 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1516 1291 c-3 -5 2 -15 12 -22 l17 -14 -12 16 c-7 9 -10 19 -6 22 3 4 4 7 0 7 -3 0 -8 -4 -11 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1893 1293 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2275 1290 c3 -5 14 -10 23 -10 l17 0 -15 10 c-20 13 -33 13 -25 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2697 1293 c-10 -9 -9 -23 1 -23 5 0 9 7 9 15 0 17 -1 18 -10 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603 1283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2125 1280 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2726 1278 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860 1270 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020 1270 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2413 1267 c0 -8 6 -14 14 -14 l13 0 -11 14 c-6 7 -12 13 -14 13 -1 0 -2 -6 -2 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2664 1260 l0 -20 10 10 10 10 -10 10 -10 10 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1494 1258 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135 1250 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350 1248 c0 -4 4 -8 9 -8 6 0 12 4 15 8 3 5 -1 9 -9 9 -8 0 -15 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2150 1250 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 1240 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2043 1243 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2900 1240 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2423 1233 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2854 1228 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 1220 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1945 1220 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665 1210 c-8 -13 5 -13 25 0 l15 10 -17 0 c-9 0 -20 -4 -23 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190 1206 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2230 1206 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335 1190 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904 1188 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2136 1189 c2 -4 13 -7 24 -6 23 2 17 10 -10 12 -10 1 -17 -2 -14 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220 1179 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585 1180 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2003 1183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2870 1180 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 1170 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2726 1165 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350 1150 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2910 1150 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2940 1150 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934 1138 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303 1143 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2195 1130 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2473 1127 c0 -8 6 -14 14 -14 l13 0 -11 14 c-6 7 -12 13 -14 13 -1 0 -2 -6 -2 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275 1120 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923 1113 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980 1109 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183 1095 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 1098 c0 -9 5 -20 11 -23 17 -11 18 -2 3 19 l-14 20 0 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2945 1100 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123 1085 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2675 1080 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944 1068 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2273 1073 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2796 1005 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7 -7 -4 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255 989 c-11 -16 -1 -19 13 -3 l13 14 -10 0 c-5 0 -13 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 980 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2780 970 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988 963 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644 948 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754 948 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2473 953 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 940 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205 940 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2783 933 c-3 -10 -8 -21 -10 -25 -2 -5 -1 -8 4 -8 4 0 13 11 20 25 l11 25 -9 0 c-5 0 -12 -8 -16 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2454 928 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 920 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704 908 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 900 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 870 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715 870 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1833 870 c-13 -5 -23 -11 -23 -14 0 -7 40 6 46 15 6 10 6 10 -23 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2335 870 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2476 864 c-9 -24 -2 -26 12 -4 7 11 8 20 3 20 -5 0 -12 -7 -15 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 860 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674 858 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 850 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 840 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2123 843 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101 824 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 830 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1724 828 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1724 798 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2185 800 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2424 798 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814 788 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 780 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 770 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774 768 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744 758 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273 763 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2705 750 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 729 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 730 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443 723 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1975 700 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2526 697 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2603 703 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 678 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040 680 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 680 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503 670 c2 -8 12 -16 23 -17 l19 -3 -15 7 c-8 3 -19 11 -23 17 l-9 11 5 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2564 668 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2655 660 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035 640 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423 643 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2024 628 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 620 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325 620 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050 620 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2004 558 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050 540 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443 503 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320 250 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100 230 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1980 220 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490 210 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 180 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684 148 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 130 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#fad5e5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1720 2160 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480 2040 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564 1978 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2493 1633 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2315 1620 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2655 1590 l-6 -10 15 0 c9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0 -13 -4 -16 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744 1568 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390 1556 c0 -2 8 -10 18 -17 l17 -14 -14 18 c-13 16 -21 21 -21 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220 1512 c0 -4 10 -13 23 -21 l22 -14 -19 22 c-20 22 -26 25 -26 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1954 1468 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2834 1448 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375 1440 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2613 1433 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2694 1428 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2473 1423 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2660 1400 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2955 1400 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2402 1380 l-23 -19 20 2 c11 1 18 3 16 6 -3 2 0 10 6 18 16 18 8 16 -19 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 1370 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2484 1358 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2765 1360 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2845 1360 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2280 1350 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2423 1343 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423 1333 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593 1333 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2204 1328 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2454 1328 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2484 1328 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1973 1323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2576 1318 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 1303 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783 1303 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2375 1300 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415 1300 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1883 1293 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158 1283 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1915 1250 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2053 1243 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2783 1235 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944 1218 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1994 1218 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2933 1213 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2086 1202 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0 -11 -4 -14 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 1190 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2775 1170 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2345 1160 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2910 1160 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013 1143 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290 1146 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 1120 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981 1106 l-12 -14 13 -8 13 -7 -7 8 c-4 4 -3 14 3 22 6 7 9 13 6 13 -2 0 -10 -6 -16 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2395 1109 l-8 -12 13 8 13 8 -7 -19 -7 -19 12 13 13 12 -11 11 -11 11 -7 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2354 1098 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2945 1100 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2445 1090 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670 1080 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 1020 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2800 1010 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784 988 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350 960 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 940 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2793 943 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 933 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 920 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2473 903 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843 893 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465 880 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2474 870 l0 -20 10 10 10 10 -10 10 -10 10 0 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 860 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2183 843 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 830 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 818 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660 810 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2180 810 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663 803 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213 803 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1936 802 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2013 803 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853 773 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364 748 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2704 738 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2204 718 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413 703 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075 690 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844 688 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2413 693 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2524 678 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395 640 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2070 640 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064 628 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2025 500 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305 490 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554 188 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2673 183 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050 170 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043 123 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343 113 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f8c5db",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2295 1610 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470 1539 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734 1508 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2225 1510 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2294 1508 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2594 1508 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2404 1498 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2553 1483 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2285 1470 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2360 1475 c0 -2 6 -8 13 -14 l14 -11 0 13 c0 8 -6 14 -14 14 -7 0 -13 -1 -13 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2520 1460 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020 1440 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2315 1430 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2870 1370 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3025 1370 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 1360 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2284 1358 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2820 1360 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2990 1350 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2710 1320 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2889 1313 l-14 -18 18 14 c9 7 17 15 17 17 0 8 -8 3 -21 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2065 1310 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2280 1290 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2633 1283 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2745 1280 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 1260 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 1240 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 1220 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005 1220 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860 1190 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2745 1189 c-11 -16 -1 -19 13 -3 l13 14 -10 0 c-5 0 -13 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303 1173 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2665 1130 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395 1080 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450 1080 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954 1048 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2513 1043 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845 1030 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2490 990 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844 928 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 910 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233 893 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720 870 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 790 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573 793 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 770 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850 760 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205 750 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083 743 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974 708 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2075 640 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 190 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f7bdd6",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2413 1503 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2536 1492 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2353 1473 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415 1450 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2733 1443 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2643 1423 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3014 1368 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2820 1350 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2433 1343 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2705 1270 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2655 1250 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700 1120 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2680 1090 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643 1023 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648 933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f395be",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2323 1613 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2285 1501 c-2 -5 4 -11 15 -14 11 -3 20 -2 20 3 0 12 -28 21 -35 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 1450 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2363 1443 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2593 1323 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713 983 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370 690 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#fad8e7",
    stroke: "none"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f6b1cf",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2300 1600 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2634 1538 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2585 1510 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2284 1498 l-7 -13 8 7 c4 4 15 2 24 -5 l16 -12 -14 18 c-7 9 -15 17 -17 17 -1 0 -6 -6 -10 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2374 1448 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3004 1358 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#fbdfec",
    stroke: "none"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#f9cade",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2375 1440 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2 -4 1 -10z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeorgesLogo);
export default __webpack_public_path__ + "static/media/georges-logo.6b537384220434437b4d021f251c412a.svg";
export { ForwardRef as ReactComponent };